/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve();
/******/
/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "javascript/" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunks[chunkId][2] = promise;
/******/
/******/ 		head.appendChild(script);
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__players__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channels_channels__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pms_pms__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__battles_battles__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__poke__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__network__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__postorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__serverconnect__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["b"] = afterLoad;












function Webclient() {
  this.players = new __WEBPACK_IMPORTED_MODULE_1__players__["a" /* default */]();
  this.channels = new __WEBPACK_IMPORTED_MODULE_2__channels_channels__["a" /* default */]();
  this.pms = new __WEBPACK_IMPORTED_MODULE_3__pms_pms__["a" /* default */]();
  this.battles = new __WEBPACK_IMPORTED_MODULE_4__battles_battles__["a" /* default */]();
  this.ownTiers = [];
  this.team = {
    "tier": "",
    "pokes": [new __WEBPACK_IMPORTED_MODULE_5__poke__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_5__poke__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_5__poke__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_5__poke__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_5__poke__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_5__poke__["a" /* default */]()]
  };

  this.ownName = () => {
    return this.players.name(this.ownId);
  };

  this.ownAuth = () => {
    return this.players.auth(this.ownId);
  };

  this.ownPlayer = () => {
    return this.players.player(this.ownId);
  };

  this.requestInfo = function(id) {
    __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("player", {
      "id": id
    });
  };

  this.onConnected = () => {
    __WEBPACK_IMPORTED_MODULE_7__frontend__["default"].printHtml("<timestamp/> Connected to server!");

    var loginInfo = {
      version: 1
    };

    loginInfo.name = __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("user");

    // var data = {version: 1};
    // data.default = queryField("channel");
    loginInfo.autojoin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */])("auto-join-" + this.serverIP, "array");

    loginInfo.ladder = __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("player.ladder", "boolean");
    if (loginInfo.ladder === null) {
      loginInfo.ladder = true;
    }

    loginInfo.idle = __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("player.idle", "boolean");
    if (loginInfo.idle === null) {
      loginInfo.idle = false;
    }

    loginInfo.color = __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("player.color") || "";
    loginInfo.info = {
      "avatar": __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("player.avatar") || 167,
      "info": __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("player.info")
    };

    if (this.team) {
      this.cacheTeam();
      loginInfo.teams = [this.getTeamData(this.team)];
    }

    if (loginInfo.name) {
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("login", loginInfo);
    } else {
      __WEBPACK_IMPORTED_MODULE_7__frontend__["default"].promptUsernameDialog(function(res) {
        if (res && res.username) {
          loginInfo.name = res.username;
          __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].set("user", res.username);
        } else {
          loginInfo.name = "guest" + Math.floor(10000 + Math.random() * 90000);
        }
        __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("login", loginInfo);
      });
    }
  };

  this.challenge = function(id, params) {
      //network.send("challengeplayer", {"id": id, "team": 0, "clauses": clauses, "tier": tier });
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].send("challengeplayer", __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
        "id": id
      }, params));
    },

    this.cancelFindBattle = () => {
      this.searchingForBattle = false;
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].send("challengeplayer", {
        "id": 0,
        "desc": "cancelled"
      });
    },

    this.dealWithChallenge = params => {
      if (params.desc === "sent") {
        if (this.players.isIgnored(params.id) || params.mode !== 0) {
          this.declineChallenge(params);
        } else if (__WEBPACK_IMPORTED_MODULE_7__frontend__["default"].teambuilderOpen) {
          this.declineChallenge(params, "busy");
        } else {
          __WEBPACK_IMPORTED_MODULE_7__frontend__["default"].showChallenge(params);
        }
      } else if (params.desc === "cancelled") {
        __WEBPACK_IMPORTED_MODULE_7__frontend__["default"].cancelChallenge(params);
      } else {
        var messages = {
          "busy": "#player is busy.",
          "refused": "#player refused your challenge.",
          "invalidtier": "You can't challenge #player in " + params.tier + ".",
          "invalidgen": "You can't challenge #player, generation is invalid.",
          "invalidteam": "You can't challenge #player by selecting this team."
        };

        if (params.desc in messages) {
          __WEBPACK_IMPORTED_MODULE_7__frontend__["default"].printHtml(
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>")
            .append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span>")
              .addClass("challenge-" + params.desc)
              .text(messages[params.desc].replace("#player", this.players.name(params.id))))
            .html());
        } else {
          console.log("Unknown challenge type received.");
          console.log(params);
        }
      }
    },

    this.declineChallenge = function(params, reason) {
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].send("challengeplayer", __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, params, {
        "desc": reason || "refused"
      }));
    },

    this.acceptChallenge = function(params) {
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].send("challengeplayer", __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, params, {
        "desc": "accepted"
      }));
    },

    this.onChat = function(params) {
      var chan = __WEBPACK_IMPORTED_MODULE_7__frontend__["default"].channels.channel(params.channel);

      if ((params.channel === -1 && params.message.charAt(0) !== "~")) {
        __WEBPACK_IMPORTED_MODULE_7__frontend__["default"].printMessage(params.message, params.html);
      } else if (chan) {
        chan.printMessage(params.message, params.html);
      }
    },

    this.print = function(msg) {
      console.log(msg);
    },

    this.sendMessage = function(message, id) {
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("chat", {
        channel: id,
        message: message
      });
    },

    this.getTeamData = function(orTeam) {
      orTeam = orTeam || this.team;
      var team = {};
      team.tier = orTeam.tier;
      team.gen = orTeam.gen;
      team.pokes = [{}, {}, {}, {}, {}, {}];
      team.illegal = orTeam.illegal || false;
      team.name = orTeam.name || "";
      for (var i in orTeam.pokes) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(team.pokes[i], orTeam.pokes[i]);
        delete team.pokes[i].ui;
        delete team.pokes[i].data;
      }

      return team;
    };

  this.cacheTeam = function() {
    var newTeam = JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, this.getTeamData(), {
      "tier": ""
    }));
    var oldCache = this.cachedTeam;
    this.cachedTeam = newTeam;

    return !oldCache || newTeam != oldCache;
  };

  this.sendTeam = () => {
    if (!this.team.tier || this.cacheTeam()) {
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("teamchange", {
        "teams": [this.getTeamData()]
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("changetier", {
        "0": this.team.tier
      });
    }
  };

  this.saveTeam = () => {
    __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].set("team", this.getTeamData());
  };

  this.loadTeam = () => {
    var team = __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("team", "object");
    if (team) {
      this.team = team;
      for (var i in team.pokes) {
        this.team.pokes[i] = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(new __WEBPACK_IMPORTED_MODULE_5__poke__["a" /* default */](), team.pokes[i]);
      }
    }
  };

  this.sendPM = (message, id) => {
    var lines = message.trim().split("\n");

    for (var i = 0, len = lines.length; i < len; i++) {
      this.pms.pm(id).printMessage(this.ownId, lines[i]);
      __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("pm", {
        to: id,
        message: lines[i]
      });
    }
  };

  this.joinChannel = function(id) {
    __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("joinchannel", {
      channel: id
    });
  };

  this.leaveChannel = function(id) {
    __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command("leavechannel", {
      channel: id
    });
  };
}

var webclient = new Webclient();

function afterLoad() {
  webclient.loadTeam();

  var userGiven = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* queryField */])("user");
  var relayGiven = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* queryField */])("relay");
  var portGiven = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* queryField */])("port");

  if (userGiven) {
    __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].set("user", userGiven);
  }
  if (relayGiven) {
    __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].set("relay", relayGiven);
  }
  if (portGiven) {
    __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].set("port", portGiven);
  }

  webclient.channels.joinChannel(0);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__serverconnect__["a" /* default */])({
    "relay": __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("relay"),
    "port": __WEBPACK_IMPORTED_MODULE_8__postorage__["a" /* default */].get("port")
  });
}

window.webclient = webclient;
/* harmony default export */ __webpack_exports__["a"] = webclient;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vex_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vex_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vex_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vex_dialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vex_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vex_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap3_dialog__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap3_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap3_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_colorpicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_colorpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_colorpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__playerlistui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__channels_channellistui__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pms_pmlistui__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__battles_battlelistui__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__postorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__network__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__battles_battleconstants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__notif__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pokeinfo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__afterload__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__stylesheets_frontend_less__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__stylesheets_frontend_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__stylesheets_frontend_less__);



 //for .tooltip. Useful?




















__WEBPACK_IMPORTED_MODULE_1_vex_js___default.a.registerPlugin(__WEBPACK_IMPORTED_MODULE_2_vex_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_1_vex_js___default.a.defaultOptions.className = 'vex-theme-os';

function WebclientUI() {
  this.players = new __WEBPACK_IMPORTED_MODULE_6__playerlistui__["a" /* default */]();
  this.channels = new __WEBPACK_IMPORTED_MODULE_7__channels_channellistui__["a" /* default */]();
  this.pms = new __WEBPACK_IMPORTED_MODULE_8__pms_pmlistui__["a" /* default */]();
  this.battles = new __WEBPACK_IMPORTED_MODULE_9__battles_battlelistui__["a" /* default */]();
  this.tabs = [];
  this.timestamps = true;
  this.challenges = [];
  this.waitingInfos = {};
  this.battleNotifications = true;

  this.printDisconnectionMessage = (/* html */) => {
    this.printHtml("<b>Disconnected from Server! If the disconnect is due to an internet problem, try to <a href='po:reconnect/'>reconnect</a> once the issue is solved. You can also go back to the <a href='" + __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].registry + "'>server list</a>.</b>");
    this.switchToChannel();
  };

  this.switchToChannel = () => {
    if (this.currentTab.shortHand != "channel") {
      for (var i = this.tabs.length - 1; i >= 0; i--) {
        if (this.tabs[i].shortHand == "channel") {
          this.tabs[i].setCurrentTab();
          return;
        }
      }
    }
  };

  this.setBattleSound = val => {
    console.log("setting battle sounds " + val);
    this.battles.setSound(val);
    __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("battle.sound", val);
    setTimeout(() => {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-simplesound-dd").prop("checked", this.battles.sound);
    });
  };

  this.updateBadgeCount = () => {
    var total = -1; // NOTHING DISPLAYED

    if (this.channels.countActive() > 0) {
      total = 0;
    }

    var flashes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tab-active").length + (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".channel-list-item.tab-flash").length - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".channel-list-item.tab-active").length);

    if (flashes > 0) {
      total = flashes;
    }

    /* -1 : no badge, 0+ : badge with 0+ displayed */
    __WEBPACK_IMPORTED_MODULE_15__notif__["a" /* default */].count = total
    __WEBPACK_IMPORTED_MODULE_15__notif__["a" /* default */].titleUpdate();
    //Todo: remove the log and actually add the badge.
  };

  this.updateSearchingBattleState = () => {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#findbattle a").text(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].searchingForBattle ? "Searching..." : "Find battle");
  };

  this.printHtml = html => {
    for (var id in this.channels.channels()) {
      this.channels.channel(id).printHtml(html);
    }
  };

  this.printMessage = (msg, html) => {
    for (var id in this.channels.channels()) {
      this.channels.channel(id).printMessage(msg, html);
    }
  };

  this.switchToTab = wid => {
    var id = wid.substr(wid.lastIndexOf("-") + 1);
    var obj;
    if (/^channel-/.test(wid)) {
      obj = this.channels.channel(id);
    } else if (/^pm-/.test(wid)) {
      obj = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].pms.pm(id);
    } else if (/^battle-/.test(wid)) {
      obj = this.battles.battle(id);
    }

    obj.setCurrentTab();
  },

  this.displayPlayerWindow = (id, params) => {
    params = params || {};
    var info = "Loading player info...";
    var pl = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.player(id) || __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownPlayer();
    var self = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId === id;

    if (!("clauses" in params)) {
      params.clauses = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("challenge.clauses", "array") || [];
    }

    if (pl.hasOwnProperty("info")) {
      info = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<iframe class="player-info" sandbox></iframe>').attr("src", "data:text/html;charset=utf-8," + this.convertImages(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").html(pl.info)).html());
    } else {
      info = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<iframe class="player-info" sandbox></iframe>').attr("src", "data:text/html;charset=utf-8," + info);
    }
    info = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='well well-sm info-block'>").append(info);

    var firstRow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='flex-row-no-shrink'>").append("<img src='" + __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].trainerSprite(pl.avatar) + "' alt='trainer sprite' class='player-avatar'>");
    firstRow.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='player-teams'>" + (!self ? "<div class='form-group'><label for='opp-team'>Opponent's team:</label><select class='form-control' id='opp-team'></select></div>" : "") + "<div class='form-group'><label for='your-team'>Your team:</label><select class='form-control' id='your-team'></select></div></div>"));
    info = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='flex-column'>").append(firstRow).append(info);

    var i;

    this.addOwnTiers(info.find("#your-team"), params);
    this.addOppTiers(info.find("#opp-team"), pl, params);

    info.updateRatings = true;
    info.params = params;
    this.waitingInfos[id] = info;
    __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].requestInfo(id);
    if (!self) {
      this.waitingInfos[__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId] = info;
      __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].requestInfo(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId);
    }

    var fullInfo = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("flex-row-basic").append(info);
    var clauses = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("input-group checkbox battle-clauses");
    for (i in __WEBPACK_IMPORTED_MODULE_14__battles_battleconstants__["b" /* default */].clauses) {
      clauses.append("<div class='checkbox'><label title='" + __WEBPACK_IMPORTED_MODULE_14__battles_battleconstants__["b" /* default */].clauseDescs[i] + "'><input type='checkbox'>" + __WEBPACK_IMPORTED_MODULE_14__battles_battleconstants__["b" /* default */].clauses[i] + "</label></div>");
    }
    fullInfo.append(clauses);

    if (params.clauses) {
      for (i = 0; i < params.clauses.length; i = i + 1) {
        if (params.clauses[i]) {
          clauses.find("input:eq(" + i + ")").prop("checked", true);
        }
      }
      if (params.desc) {
        clauses.find("input").prop("disabled", true);
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].battles.isBattling(id)) {
      fullInfo = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("flex-column").append(fullInfo);

      var battling = pl.name + " is battling against ";

      var battleList = [];
      var battles = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].battles.battlesOfPlayer(id);

      for (var x in battles) {
        var battle = battles[x];
        var opp = battle.ids[0] == id ? battle.ids[1] : battle.ids[0];
        battleList.push("<a href='po:watch/" + battle.id + "'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.name(opp)) + "</a>");
      }

      fullInfo.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p>").append(battling + battleList.join(", ") + "."));
    }

    var buttons;

    if (!params.desc) {
      var isIgnored = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.isIgnored(id);
      if (!self) {
        buttons = [{
          label: (isIgnored ? 'Unignore' : 'Ignore'),
          action: dialogItself => {
            if (!isNaN(id)) {
              if (!isIgnored) {
                __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.addIgnore(id);
              } else {
                __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.removeIgnore(id);
              }
              this.players.updatePlayer(+id);
            }
            dialogItself.close();
          }
        }, {
          label: 'Private Message',
          action: dialogItself => {
            __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].pms.pm(id, true);
            dialogItself.close();
          }
        }, {
          label: 'Challenge',
          action: dialogItself => {
            var params = {
              "team": 0,
              "mode": 0
            };
            params.clauses = [];

            for (var i in __WEBPACK_IMPORTED_MODULE_14__battles_battleconstants__["b" /* default */].clauses) {
              params.clauses.push(clauses.find("input:eq(" + i + ")").prop("checked") ? 1 : 0);
            }
            params.tier = info.find("#opp-team").val();
            params.team = info.find("#your-team").val();

            __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("challenge.clauses", params.clauses);

            __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].challenge(id, params);
            dialogItself.close();
          }
        }];
      } else {
        buttons = [];
      }
    } else {
      buttons = [{
        label: 'Decline',
        action: dialogItself => {
          __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].declineChallenge(params);
          dialogItself.setData("declined", true);
          dialogItself.close();

          this.printHtml("<span class='challenge-refused'>You refused " + pl.name + "'s challenge.</span>");
        }
      }, {
        label: 'Accept',
        action: dialogItself => {
          params.team = info.find("#your-team").val();
          __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].acceptChallenge(params);
          dialogItself.setData("accepted", true);
          dialogItself.close();
        }
      }];
    }

    var dialogInstance = new __WEBPACK_IMPORTED_MODULE_4_bootstrap3_dialog___default.a({
      title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* escapeHtml */])(pl.name) + (params.desc ? " challenged you in " + params.tier + "!" : ""),
      message: fullInfo,
      "buttons": buttons,
      onhidden: dialogItself => {
        if (params.desc && !dialogItself.getData("cancelled")) {
          if (!dialogItself.getData("accepted") && !dialogItself.getData("declined")) {
            __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].declineChallenge(params);
          }
        }
      },
      closeByBackdrop: params.desc ? false : true
    });
    dialogInstance.open();

    return dialogInstance;
  };

  this.showChallenge = params => {
    this.challenges.push(this.displayPlayerWindow(params.id, params));
  };

  this.cancelChallenge = params => {
    var newChalls = [];

    for (var i in this.challenges) {
      var chall = this.challenges[i];

      if (chall.id == params.id && chall.tier == params.tier) {
        chall.setData("cancelled", true);
        chall.close();
      } else {
        newChalls.push(chall);
      }
    }

    this.challenges = newChalls;
  };

  this.updateInfo = (id, info) => {
    if (id in this.waitingInfos) {
      var plInfo = this.waitingInfos[id];
      var oppPl = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.player(id);
      if (id !== __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId) {
        plInfo.find(".player-avatar").attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].trainerSprite(oppPl.avatar || 167));
        plInfo.find(".player-info").attr("src", "data:text/html;charset=utf-8," + this.convertImages(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").html(info)).html());
      }

      if (plInfo.updateRatings) {
        if (id == __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId) {
          this.addOwnTiers(plInfo.find("#your-team"), plInfo.params);
        } else {
          this.addOppTiers(plInfo.find("#opp-team"), oppPl, plInfo.params);
        }
      }
      delete this.waitingInfos[id];
    }
  };

  this.addOwnTiers = (ownTeams, params) => {
    var pl = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownPlayer();
    ownTeams.html("");

    __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownTiers.forEach((tier, i) => {
      if (!params.desc || tier.toLowerCase() == params.tier.toLowerCase()) {
        var rating = (pl.ratings && pl.ratings[tier]) ? " (" + pl.ratings[tier] + ")" : "";
        ownTeams.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<option>").text(`Team ${i+1}: ${tier}${rating}`).attr("value", i));
      }
    });
  }

  this.addOppTiers = (oppTeams, pl, params) => {
    oppTeams.html("");
    if ("opptier" in params) {
      oppTeams.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<option>").text(params.opptier));
      oppTeams.prop('disabled', true);
      return;
    }

    var selected = false;
    if (pl.ratings) {
      for (var tier in pl.ratings) {
        /* If the opponent shares a tier with us, challenge them in that tier */
        if (!selected && __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownTiers.indexOf(tier) != -1) {
          selected = true;
          oppTeams.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<option selected>").text(tier).attr("value", tier));
        } else {
          oppTeams.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<option>").text(tier).attr("value", tier));
        }
      }
    }

    if (!params.desc && params.ratings) {
      oppTeams.prop("disabled", true);
    }
  };

  this.promptUsernameDialog = callback => __WEBPACK_IMPORTED_MODULE_1_vex_js___default.a.dialog.open({
    message: "Enter your username:",
    input: "<input name='username' type='text' placeholder='Username'>",
    buttons: [
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, __WEBPACK_IMPORTED_MODULE_1_vex_js___default.a.dialog.buttons.YES, {text: "Login"}),
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, __WEBPACK_IMPORTED_MODULE_1_vex_js___default.a.dialog.buttons.NO, {text: "Login as Guest"})
    ],
    callback
  });

  this.convertImages = element => {
    element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
    element.find("img").each(function(index, img) {
      img = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(img);
      var src = img.attr("src").split(":"),
        proto = src[0],
        query = src[1];

      switch (proto) {
        case "pokemon":
          query = "?" + query;
          var poke = __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].toArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["b" /* queryField */])("num", query.slice(1).split("&")[0], query) || "1"),
            gen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["b" /* queryField */])("gen", "6", query),
            shiny = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["b" /* queryField */])("shiny", "false", query) === "true",
            gender = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["b" /* queryField */])("gender", "male", query),
            back = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["b" /* queryField */])("back", "false", query) === "true";

          img.on("error", function() {
            if (gender == "female") {
              gender = "male";
            } else if (gen < 6) {
              gen = 6;
            } else if (gen === 6) {
              gen = 5;
            } else if (shiny) {
              shiny = false;
            } else if (back) {
              back = false;
            } else {
              return;
            }

            img.attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].sprite({
              num: poke[0],
              forme: poke[1],
              female: gender === "female",
              shiny: shiny
            }, {
              gen: gen,
              back: back
            }));
          }).attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].sprite({
            num: poke[0],
            forme: poke[1],
            female: gender === "female",
            shiny: shiny
          }, {
            gen: gen,
            back: back
          }));
          break;
        case "item":
          img.attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["b" /* ItemInfo */].itemSprite(query));
          break;
        case "icon":
          img.attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].icon(query));
          break;
        case "trainer":
          img.attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].trainerSprite(query));
          break;
        case "http":
        case "https":
        case "data":
          /* base64 */
          break;
        default:
          console.log("Unknown protocol: " + proto);
          break;
      }
    });
    return element;
  };

  this.showSettings = () => {
    var content = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>");
    __WEBPACK_IMPORTED_MODULE_4_bootstrap3_dialog___default.a.show({
      "title": "Settings for " + __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownName(),
      "message": dialogItself => {
        content.load("settings", (response, status) => {
          if (status == "error") {
            dialogItself.setData("error", true);
            //todo, error details can be gotten from arguments[2]
            return;
          }
          content.find("#username").val(__WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("user") || "");
          content.find("#usercolor").val(__WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("player.color") || "").colorpicker({
            "format": "hex"
          });
          content.find("#userinfo").val(__WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("player.info") || "");
          content.find("#useravatar").val(__WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("player.avatar") || 0);
          var setAvatar = function() {
            var num = parseInt(content.find("#useravatar").val());
            if (isNaN(num) || num < 0 || num > 844) {
              // nothing or invalid avatar given, do not change
              return;
            }
            content.find("#settings-avatar-image").attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].trainerSprite(num));
          };
          var updateLimitCounter = function() {
            content.find(".userinfo-limit-counter").text(content.find("#userinfo").val().length + "/" + content.find("#userinfo").attr("maxlength"));
          };
          setAvatar();
          updateLimitCounter();
          content.find("#useravatar").on("change keyup", setAvatar);
          content.find("#userinfo").on("change keyup", updateLimitCounter);
        });
        return content;
      },
      "buttons": [{
        label: "Update",
        action: dialogItself => {
          if (dialogItself.getData("error")) {
            dialogItself.close();
            return;
          }
          var userName = content.find("#username").val();
          var userColor = content.find("#usercolor").val();
          var userInfo = content.find("#userinfo").val();
          var userAvatar = content.find("#useravatar").val();
          __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("user", userName);
          __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("player.color", userColor);
          __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("player.info", userInfo);
          __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("player.avatar", Math.floor(Math.min(844, Math.max(userAvatar, 0))));

          var update = {};

          if (userName != __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownName()) {
            update.name = userName;
          }
          if (userColor != __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.color(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId) && userColor) {
            update.color = userColor;
          }
          if (userInfo != __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownPlayer().info && userInfo || userAvatar != __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownPlayer().avatar) {
            update.info = {
              "avatar": __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("player.avatar") || 167,
              "info": userInfo
            };
          }
          __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command("teamchange", update);
          __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].searchingForBattle = false;
          this.updateSearchingBattleState();

          dialogItself.close();
        }
      }]
    });
  };

  this.toggleIdle = () => {
    var isAway = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.away(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId);
    __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("player.idle", !isAway);
    __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command("idle", {
      "away": !isAway
    });
  };

  this.isIdle = () => {
    return __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.away(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId);
  }
}

var webclientUI = new WebclientUI();

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function() {
  webclientUI.linkClickHandler = function(event) {
    var href = this.href,
      sep, cmd, payload, pid;

    if (/^po:/.test(href)) {
      event.preventDefault();

      sep = href.indexOf("/");
      cmd = href.slice(3, sep);

      payload = decodeURIComponent(href.slice(sep + 1));

      // Add other commands here..
      pid = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.id(payload);
      if (pid === -1) {
        pid = parseInt(payload, 10);
      }

      if (cmd === "join") {
        __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].joinChannel(payload);
      } else if (cmd === "pm") { // Create pm window
        if (!isNaN(pid)) {
          __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].pms.pm(pid, true);
        }
      } else if (cmd === "ignore") {
        // Ignore the user
        if (!isNaN(pid)) {
          if (!__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.isIgnored(pid)) {
            __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.addIgnore(pid);
          } else {
            __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.removeIgnore(pid);
          }
          webclientUI.players.updatePlayer(+pid);
        }
      } else if (cmd === "watch") {
        __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command('watch', {
          battle: +payload
        });
      } else if (cmd === "send") {
        __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].currentTab.sendMessage(payload);
      } else if (cmd === "setmsg") {
        __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].currentTab.chat.chatSend.val(payload);
      } else if (cmd === "appendmsg") {
        __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].currentTab.chat.chatSend.val(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].currentTab.chat.chatSend.val() + payload);
      } else if (cmd === "reconnect") {
        //window.location.href= window.location.pathname;
        window.location.reload();
      } else if (cmd === "watch-player") {
        if (__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].battles.isBattling(+payload)) {
          __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command('watch', {
            battle: __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].battles.battleOfPlayer(+payload)
          });
        }
      } else if (cmd === "kick") {
        __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command('kick', {
          id: +payload
        });
      } else if (cmd === "ban") {
        __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command('ban', {
          id: +payload
        });
      } else if (cmd === "idle") {
        webclientUI.toggleIdle();
      } else if (cmd === "timestamps") {
        webclientUI.timestamps = !webclientUI.timestamps;
        setTimeout(function() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-timestamps-dd").prop("checked", webclientUI.timestamps);
        });
        __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("chat.timestamps", webclientUI.timestamps);
      } else if (cmd === "rainbow") {
        webclientUI.players.showColors = !webclientUI.players.showColors;
        setTimeout(function() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-rainbow-dd").prop("checked", webclientUI.players.showColors);
        });
        __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("players.rainbow", webclientUI.players.showColors);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".chat-column").toggleClass("rainbow");
        webclientUI.players.updatePlayers();
      } else if (cmd === "sortauth") {
        webclientUI.players.authFilter = !webclientUI.players.authFilter;
        setTimeout(function() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-sortauth-dd").prop("checked", webclientUI.players.authFilter);
        });
        webclientUI.players.updatePlayers();
        __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("sort-by-auth", webclientUI.players.authFilter);
      } else if (cmd === "exitwarning") {
        webclientUI.exitWarning = !webclientUI.exitWarning;
        setTimeout(function() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-exitwarning-dd").prop("checked", webclientUI.exitWarning);
        });
        __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("exitwarning", webclientUI.exitWarning);
      } else if (cmd === "simplebattle") {
        webclientUI.battles.simpleWindow = !webclientUI.battles.simpleWindow;
        setTimeout(function() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-simplebattle-dd").prop("checked", webclientUI.battles.simpleWindow);
        });
        __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].set("battle.simple-window", webclientUI.battles.simpleWindow);
      } else if (cmd === "battlesound") {
        var currentSound = webclientUI.battles.sound == "unset" ? false : webclientUI.battles.sound;
        webclientUI.setBattleSound(!currentSound);
      } else if (cmd === "register") {
        __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command("register");
      } else if (cmd === "info") {
        webclientUI.displayPlayerWindow(+payload);
      } else if (cmd == "chanevents") {
        webclientUI.channels.toggleChanEvents(payload);
      } else if (cmd == "channotifs") {
        webclientUI.channels.toggleChanNotifs(payload);
        webclientUI.updateBadgeCount();
      } else if (cmd == "settings") {
        webclientUI.showSettings();
      } else if (cmd == "findbattle") {
        //rated: bool, sameTier: bool, range: int
        if (!__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].searchingForBattle) {
          __WEBPACK_IMPORTED_MODULE_13__network__["a" /* default */].command("findbattle", {
            rated: false,
            sameTier: true
          });
          __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].searchingForBattle = true;
          webclientUI.updateSearchingBattleState();
        } else {
          __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].cancelFindBattle();
          webclientUI.updateSearchingBattleState();
        }
      } else if (cmd == "tab") {
        webclientUI.switchToTab(payload);
      } else if (cmd == "teambuilder") {
        webclientUI.teambuilderOpen = true;

        __WEBPACK_IMPORTED_MODULE_4_bootstrap3_dialog___default.a.show({
          title: "Teambuilder",
          message: function() {
            var content = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").load("teambuilder?load=" + (__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].teambuilderLoaded ? false : true), function(response, status) {
              if (status == "error") {
                return;
              }
            });

            return content;
          },
          closeByBackdrop: false,
          onhidden: function() {
            webclientUI.teambuilderOpen = false;
          },
          onshown: function() {
            __webpack_require__.e/* require.ensure */(0).then((() => {
              const Teambuilder = __webpack_require__(7).default;
              new Teambuilder(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".teambuilder"));
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          },
          buttons: [{
              label: "New team",
              action: function(/* dialog */) {
                webclientUI.teambuilder.onNewTeam();
              }
            },
            {
              label: "Importable",
              action: function(/* dialog */) {
                webclientUI.teambuilder.onImportable();
              }
            },
            {
              label: "Update",
              action: function(dialog) {
                dialog.close();
                __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].saveTeam();
                __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].sendTeam();
              }
            }
          ]
        });
      } else if (cmd == "tb-setgen") {
        webclientUI.teambuilder.setGen(+payload);
      } else if (cmd == "download") {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#download-hidden").val(JSON.stringify(localStorage));
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#download-form").submit();
      } else if (cmd == "upload") {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#upload-hidden").click().on("change", function() {
          var file = this.files.item(0);

          var fileReader = new FileReader();
          fileReader.onload = function(e) {
            var res = e.target.result;
            if (!res) {
              return;
            }
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(localStorage, JSON.parse(res));

            __WEBPACK_IMPORTED_MODULE_4_bootstrap3_dialog___default.a.alert("Your data was replaced! Reload the page to see immediate effects.");
          };
          fileReader.readAsText(file, "utf-8");
        });
      }
    } else {
      if (__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].connectedToServer && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("target")) {
        /* Make sure link opens in a new window */
        this.target = "_blank";
      }
    }
  };
  /* handle clicks on links, especially with po: urls */
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("click", "a", webclientUI.linkClickHandler);

  __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.on("ignoreadd", function(id) {
    webclientUI.printHtml("<em>You ignored " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.name(id)) + ".</em>");
  }).on("ignoreremove", function(id) {
    webclientUI.printHtml("<em>You stopped ignoring " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.name(id)) + ".</em>");
  }).on("ownplayerupdated", function(id) {
    var player = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].players.player(id);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-idle-dd").prop("checked", player.away);

    document.title = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownName() + " - Pok\u00E9mon Online";

    /* Display username in header */
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".displayUsername").html(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownName());
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".avatar-miniature").attr("src", __WEBPACK_IMPORTED_MODULE_16__pokeinfo__["a" /* PokeInfo */].trainerSprite(__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownPlayer().avatar));
  });

  webclientUI.timestamps = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("chat.timestamps", "boolean") === null ? true : __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("chat.timestamps", "boolean");
  webclientUI.players.showColors = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("players.rainbow", "boolean") === null ? true : __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("players.rainbow", "boolean");
  webclientUI.exitWarning = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("exitwarning", "boolean") === null ? true : __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("exitwarning", "boolean");
  webclientUI.players.authFilter = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("sort-by-auth", "boolean") === null ? true : __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("sort-by-auth", "boolean");
  webclientUI.battles.simpleWindow = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("battle.simple-window", "boolean") === null ? true : __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("battle.simple-window", "boolean");
  webclientUI.battles.sound = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("battle.sound", "boolean") === null ? "unset" : __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("battle.sound", "boolean");

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-timestamps-dd").prop("checked", webclientUI.timestamps);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-rainbow-dd").prop("checked", webclientUI.players.showColors);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-idle-dd").prop("checked", webclientUI.isIdle());
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-exitwarning-dd").prop("checked", webclientUI.exitWarning);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-sortauth-dd").prop("checked", webclientUI.players.authFilter);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-simplebattle-dd").prop("checked", webclientUI.battles.simpleWindow);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#checkbox-simplesound-dd").prop("checked", webclientUI.battles.sound === true);

  webclientUI.channels.chanevents = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("chanevents-" + (__WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("relay") || __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].relayIP), "object") || {};
  webclientUI.channels.channotifs = __WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("channotifs-" + (__WEBPACK_IMPORTED_MODULE_12__postorage__["a" /* default */].get("relay") || __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].relayIP), "object") || {};

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-toggle="tooltip"]').attr("data-placement", "bottom").tooltip();
});

window.onbeforeunload = function(e) {
  if (webclientUI.exitWarning) {
    // don't show message when staying on the site
    if (__WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].connectedToServer && window.location.href != e.target.baseURI) {
      return 'Are you sure you want to disconnect from the server?';
    }
  }
};

window.webclientUI = webclientUI;

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function() {
  /* Load heavy libraries after */
  __webpack_require__.e/* require.ensure */(0/* duplicate */).then((() => {
    __webpack_require__(7);
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#toggleSidebar").click(function(evt) {
    evt.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#leftmenu").toggleClass("hide");
  });

  var checkCompact = function() {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).width() < 768) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#leftmenu").addClass("hide");
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#leftmenu").removeClass("hide");
    }
  };
  checkCompact();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).resize(function() {
    checkCompact();
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__afterload__["a" /* default */])();
});

/* harmony default export */ __webpack_exports__["default"] = webclientUI;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* unused harmony export toAlphanumeric */
/* harmony export (immutable) */ __webpack_exports__["d"] = inherits;
/* harmony export (immutable) */ __webpack_exports__["b"] = queryField;
/* harmony export (immutable) */ __webpack_exports__["a"] = escapeHtml;
/* harmony export (immutable) */ __webpack_exports__["j"] = stripHtml;
/* unused harmony export addDatePadding */
/* harmony export (immutable) */ __webpack_exports__["i"] = timestamp;
/* harmony export (immutable) */ __webpack_exports__["g"] = addChannelLinks;
/* unused harmony export unenumerable */
/* harmony export (immutable) */ __webpack_exports__["e"] = rank;
/* harmony export (immutable) */ __webpack_exports__["f"] = rankStyle;
/* harmony export (immutable) */ __webpack_exports__["h"] = onEnterPressed;
/* harmony export (immutable) */ __webpack_exports__["c"] = afterLoad;


function toAlphanumeric(text) {
    return ("" + text).toLowerCase().replace(/[^a-z0-9]+/g, "");
}

// https://github.com/isaacs/inherits/blob/master/inherits_browser.js
function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}

function queryField(key, defaultStr, query) {
    var match = new RegExp("[?&]" + key + "=([^&]*)")
        .exec(query || window.location.search);
    return (match && decodeURIComponent(match[1].replace(/\+/g, " "))) || defaultStr;
}

function escapeHtml(str) {
    return (str || "").replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\b((?:https?|ftp):\/\/\S+)/gi, "<a href='$1' target='_blank'>$1</a>")
        .replace(/&amp;(?=[^\s<]*<\/a>)/g, "&"); // Revert &amp;'s to &'s in URLs
}

function stripHtml(str) {
    return str.replace(/<\/?[^>]*>/g, "");
}

// Add an option for UTC dates too?
// And AM/PM (date.getHours() < x)
function addDatePadding(date) {
    var str = date.toString();
    return date < 10 ? "0" + str : str;
}

function timestamp() {
    var date = new Date();
    return addDatePadding(date.getHours()) + ":" +
        addDatePadding(date.getMinutes()) + ":" +
        addDatePadding(date.getSeconds());
}

// channelNames must be a list of lowercase names
function addChannelLinks(line, channelNames) {
    var index = line.indexOf("#");
    if (index === -1) {
        return line;
    }

    var str = "", fullChanName, chanName, chr, lastIndex = 0, pos, i;
    while (index !== -1) {
        str += line.substring(lastIndex, index);
        lastIndex = index + 1; // Skip over the '#'

        fullChanName = "";
        chanName = "";

        for (i = 0, pos = lastIndex; i < 20 && (chr = line[pos]); i += 1, pos += 1) {
            fullChanName += chr;
            if (channelNames.indexOf(fullChanName.toLowerCase()) !== -1) {
                chanName = fullChanName;
            }
        }

        if (chanName) {
            str += "<a href='po:join/" + chanName + "'>#" + chanName + "</a>";
            lastIndex += chanName.length;
        } else {
            str += "#";
        }

        index = line.indexOf("#", lastIndex);
    }

    if (lastIndex < line.length) {
        str += line.substr(lastIndex);
    }

    return str;
}

function unenumerable(obj, key, value) {
    if (!obj.hasOwnProperty(key)) {
        // Enumerable, writable, configurable are false
        Object.defineProperty(obj, key, {
            value: value
        });
    }
}

function rank(auth, set) {
    set = set || rankSet;
    auth = Math.max(0, Math.min(4, auth));
    return set[auth] || "";
}

function rankStyle(str, auth, set) {
    set = set || rankStyleSet;
    auth = Math.max(0, Math.min(4, auth));
    return (set[auth] || "").replace(/\{name\}/gi, str);
}

// Shorthand for if (event.which === 13) { callback(); }
function onEnterPressed(callback) {
    return function (event) {
        if (event.which === 13) {
            callback.call(this, event);
        }
    };
}

// User, Mod, Admin, Owner, Hidden
const rankSet = ["", "+", "+", "+", ""];
/* unused harmony export rankSet */

const rankStyleSet = [
    "{name}", "<i>{name}</i>", "<i>{name}</i>", "<i>{name}</i>", "{name}"
];
/* unused harmony export rankStyleSet */


unenumerable(String.prototype, "contains", function (needle) {
    return this.indexOf(needle) > -1;
});

/* Fast index search in a sorted array */
unenumerable(Array.prototype, "dichotomy", function (func) {
    if (this.length === 0) {
        return 0;
    }

    var min = 0;
    var max = this.length - 1;

    while (true) {
        var half = Math.floor(min + (max - min) / 2);

        var cmp = func(this[half]);
        if (min === max) {
            return half + (cmp > 0 ? 1 : 0);
        }

        if (cmp < 0) {
            max = half;
        } else if (cmp > 0) {
            min = (min === half ? max : half);
        } else {
            return half;
        }
    }
});

unenumerable(String.prototype, "startsWith", function(str) {
    return this.lastIndexOf(str, 0) === 0;
});

if (typeof window !== "undefined") {
    window.isActive = true;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).focus(function() {
        window.isActive = true;
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).blur(function() {
        window.isActive = false;
    });
}

/* Add a preventDefault on stopPropagation in order to avoid
 on FF a click on a player element that won't be handled by our handler
 because of the e.stopPropagation() that would've happened. */
 function afterLoad (){
    if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.contextmenu.Constructor) {
        return;
    }
    var ctx = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.contextmenu.Constructor.prototype;
    var ctxcm = ctx.closemenu;
    ctx.closemenu = function(e) {
        var x;
        if (e) {
            x = e.stopPropagation;
            e.stopPropagation = function () {
                x.call(e);
                e.preventDefault();
            }
        }

        ctxcm.call(this, e);

        if (e) {
            e.stopPropagation = x;
        }
    };
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

;(function(window, undefined) {var observable = function(el) {

  /**
   * Extend the original object or create a new empty one
   * @type { Object }
   */

  el = el || {}

  /**
   * Private variables
   */
  var callbacks = {},
    slice = Array.prototype.slice

  /**
   * Public Api
   */

  // extend the el object adding the observable methods
  Object.defineProperties(el, {
    /**
     * Listen to the given `event` ands
     * execute the `callback` each time an event is triggered.
     * @param  { String } event - event id
     * @param  { Function } fn - callback function
     * @returns { Object } el
     */
    on: {
      value: function(event, fn) {
        if (typeof fn == 'function')
          (callbacks[event] = callbacks[event] || []).push(fn)
        return el
      },
      enumerable: false,
      writable: false,
      configurable: false
    },

    /**
     * Removes the given `event` listeners
     * @param   { String } event - event id
     * @param   { Function } fn - callback function
     * @returns { Object } el
     */
    off: {
      value: function(event, fn) {
        if (event == '*' && !fn) callbacks = {}
        else {
          if (fn) {
            var arr = callbacks[event]
            for (var i = 0, cb; cb = arr && arr[i]; ++i) {
              if (cb == fn) arr.splice(i--, 1)
            }
          } else delete callbacks[event]
        }
        return el
      },
      enumerable: false,
      writable: false,
      configurable: false
    },

    /**
     * Listen to the given `event` and
     * execute the `callback` at most once
     * @param   { String } event - event id
     * @param   { Function } fn - callback function
     * @returns { Object } el
     */
    one: {
      value: function(event, fn) {
        function on() {
          el.off(event, on)
          fn.apply(el, arguments)
        }
        return el.on(event, on)
      },
      enumerable: false,
      writable: false,
      configurable: false
    },

    /**
     * Execute all callback functions that listen to
     * the given `event`
     * @param   { String } event - event id
     * @returns { Object } el
     */
    trigger: {
      value: function(event) {

        // getting the arguments
        var arglen = arguments.length - 1,
          args = new Array(arglen),
          fns,
          fn,
          i

        for (i = 0; i < arglen; i++) {
          args[i] = arguments[i + 1] // skip first argument
        }

        fns = slice.call(callbacks[event] || [], 0)

        for (i = 0; fn = fns[i]; ++i) {
          fn.apply(el, args)
        }

        if (callbacks['*'] && event != '*')
          el.trigger.apply(el, ['*', event].concat(args))

        return el
      },
      enumerable: false,
      writable: false,
      configurable: false
    }
  })

  return el

}
  /* istanbul ignore next */
  // support CommonJS, AMD & browser
  if (true)
    module.exports = observable
  else if (typeof define === 'function' && define.amd)
    define(function() { return observable })
  else
    window.observable = observable

})(typeof window != 'undefined' ? window : undefined);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BattleConstants = {};

/* harmony default export */ __webpack_exports__["b"] = BattleConstants;

BattleConstants.statuses = {
    0: "",
    1: "par",
    2: "slp",
    3: "frz",
    4: "brn",
    5: "psn",
    6: "confusion",
    31: "fnt"
};

BattleConstants.weathers = {
    0: "none",
    1: "hail",
    2: "raindance",
    3: "sandstorm",
    4: "sunnyday",
    5: "strongsun",
    6: "strongrain",
    7: "strongwinds"
};

BattleConstants.clauses = {
    0: "Sleep Clause",
    1: "Freeze Clause",
    2: "Disallow Spects",
    3: "Item Clause",
    4: "Challenge Cup",
    5: "No Timeout",
    6: "Species Clause",
    7: "Team Preview",
    8: "Self-KO Clause",
    9: "Inverted Clause"
};

BattleConstants.clauseDescs = {
    0:"You can not put more than one Pokemon of the opposing team to sleep at the same time.",
    1:"You can not freeze more than one Pokemon of the opposing team at the same time.",
    2:"Nobody can watch your battle.",
    3:"No more than one of the same items is allowed per team.",
    4:"Random teams are given to trainers.",
    5:"No time limit for playing.",
    6:"One player cannot have more than one of the same pokemon per team.",
    7:"At the beginning of the battle, you can see the opponent's team and rearrange yours accordingly.",
    8:"The one who causes a tie (Recoil, Explosion, Destinybond, ...) loses the battle.",
    9:"All Type Effectivenesses are inverted (Ex: Water is weak to Fire)"
};

BattleConstants.clauseTexts = [
    "Sleep Clause prevented the sleep inducing effect of the move from working.",
    "Freeze Clause prevented the freezing effect of the move from working.",
    "",
    "",
    "",
    "The battle ended by timeout.",
    "",
    "",
    "The Self-KO Clause acted as a tiebreaker.",
    ""
];

BattleConstants.modes = {
    0: "Singles",
    1: "Doubles",
    2: "Triples",
    3: "Rotation"
};

const modes = BattleConstants.modes;
/* harmony export (immutable) */ __webpack_exports__["c"] = modes;

const clauses = BattleConstants.clauses;
/* unused harmony export clauses */

const clauseTexts = BattleConstants.clauseTexts;
/* unused harmony export clauseTexts */

const clauseDescs = BattleConstants.clauseDescs;
/* unused harmony export clauseDescs */

const statuses = BattleConstants.statuses;
/* harmony export (immutable) */ __webpack_exports__["a"] = statuses;

const weathers = BattleConstants.weathers;
/* unused harmony export weathers */


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = poStorage;
/* Currently, these keys are used:
    * player.name: string
    * player.idle: boolean
    * player.avatar: number
    * player.color: string
    *
    * tb.teams: object
    *
    * chat.timestamps: boolean
    *
    * relay: string
    * autoload: boolean
    * exitwarning: boolean
    * passhash-{data}: string
    * auto-join-[serverip/port]: array
    * chanevents-[serverip/port]: object
*/


function poStorage(name, type) {
    return poStorage.get(name, type);
}

poStorage.set = function (name, val) {
    var namespace = window.webclientStorageNamespace || "po.";
    if (Array.isArray(val) || (val && val.toString() === "[object Object]")) {
        val = JSON.stringify(val);
    }

    localStorage.setItem(namespace + name, val);
};

poStorage.get = function (name, type) {
    type = type || "string";

    var namespace = window.webclientStorageNamespace || "po.";
    var value = localStorage.getItem(namespace + name);
    if (value === null) {
        return value; // undefined
    }

    if (type === "string") {
        return value;
    } else {
        return JSON.parse(value);
    }
};

poStorage.init = function (name, val) {
    var namespace = window.webclientStorageNamespace || "po.",
        value = localStorage.getItem(namespace + name);

    if (value === null) {
        poStorage.set(name, val);
        return true;
    }

    return false;
};

poStorage.remove = function (name) {
    var namespace = window.webclientStorageNamespace || "po.";
    localStorage.removeItem(namespace + name);
};

poStorage.clear = function () {
    localStorage.clear();
};

Object.defineProperty(poStorage.prototype, 'length', {get: function() {
   return localStorage.length;
}});

poStorage.keys = function () {
    var namespace = window.webclientStorageNamespace || "po.";
    var keys = Object.keys(localStorage);
    var list = [];
    for (var i = 0, len = keys.length; i < len; i++) {
        if (keys[i].substr(0, namespace.length) === namespace) {
            list.push(keys[i]);
        }
    }
    return list;
};

poStorage.toString = function () {
    return "poStorage [" + poStorage.keys().map(function (k) {
        return "'" + k + "'";
    }).join(", ") + "]";
};

window.poStorage = poStorage;


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vex_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vex_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vex_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battles_battleconstants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_md5__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__postorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(3);










/* global MozWebSocket:false, serverConfig:false */

function createNetwork(WebSocket) {
    var states = {
        Connecting: 0,
        Open: 1,
        Closing: 2,
        Closed: 3,
        "0": "Connecting",
        "1": "Open",
        "2": "Closing",
        "3": "Closed"
    };

    // TODO: Organize this
    var transformers = {
        register: function () {
            return "register|";
        },
        registry: function () {
            return "registry";
        },
        // ?
        teamchange: function (payload) {
            return "teamchange|" + JSON.stringify(payload);
        },
        changetier: function (payload) {
            return "changetier|" + JSON.stringify(payload);
        },
        // battle: number
        watch: function (payload) {
            return "watch|" + payload.battle;
        },
        // battle: number
        stopwatching: function (payload) {
            return "stopwatching|" + payload.battle;
        },
        // sameTier: boolean, range: number
        findbattle: function (payload) {
            return "findbattle|" + JSON.stringify(payload);
        },
        // ?
        battlechoice: function (payload) {
            return "battlechoice|" + payload.id + "|" + JSON.stringify(payload.choice);
        },
        // battle: number
        forfeit: function (payload) {
            return "forfeit|" + payload.battle;
        },
        // id: number
        player: function (payload) {
            return "player|" + payload.id;
        },
        // ip: string
        connect: function (payload) {
            return "connect|" + payload.ip;
        },
        replay: function (payload) {
            return "replay|" + payload.battle;
        },
        // channel: string
        joinchannel: function (payload) {
            return "join|" + payload.channel;
        },
        // channel: number
        leavechannel: function (payload) {
            return "leave|" + payload.channel;
        },
        // message: string, channel: number
        chat: function (payload) {
            return "chat|" + JSON.stringify(payload);
        },
        // to: number, message: string
        pm: function (payload) {
            return "pm|" + JSON.stringify(payload);
        },
        // battle: number, message: string
        battlechat: function (payload) {
            return "battlechat|" + payload.battle + "|" + payload.message;
        },
        // battle: number, message: string
        spectatingchat: function (payload) {
            return "spectatingchat|" + payload.battle + "|" + payload.message;
        },
        // version: number, name: string, default: string, autojoin: string, ladder: boolean, idle: boolean, color: string
        login: function (payload) {
            return "login|" + JSON.stringify(payload);
        },
        // hash: string
        auth: function (payload) {
            return "auth|" + payload.hash;
        },
        // id: number
        getrankings: function (payload) {
            return "getrankings|" + payload.id;
        },
        //id: number, tier: string, team: number (of own team slot), clauses: number
        challengeplayer: function (payload) {
            /* Convert clauses as an array to a number */
            var copy = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, payload, {"clauses": 0});
            var mult = 1;
            for (var i in payload.clauses) {
                copy.clauses += mult * payload.clauses[i];
                mult *= 2;
            }
            return "challenge|" + JSON.stringify(copy);
        },
        kick: function (payload) {
            return "kick|" + payload.id;
        },
        ban: function (payload) {
            return "ban|" + payload.id;
        },
        idle: function (payload) {
            return "idle|" + (payload.away ? 1 : 0);
        },
        ladder: function (payload) {
            return "ladder|" + (payload.ladder ? 1 : 0);
        }
    };

    var parsers = {
        defaultserver: function (payload) {
            /* If the server is on the same IP as the relay, we display the server IP but
                send localhost */
            var server = payload.replace("localhost", this.relay),
                qserver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* queryField */])("server");

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#advanced-connection").val((qserver && qserver !== "default") ? qserver : server);

            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* queryField */])("autoconnect") === "true") {
                __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].connectToServer();
            } else {
                this.command("registry");
            }
        },
        servers: function (payload) {
            var servers = JSON.parse(payload),
                html = "",
                server, len, i;

            for (i = 0, len = servers.length; i < len; i += 1) {
                server = servers[i];
                html += "<tr><td class='server-name'>" + server.name + "</td><td>" + server.num + ("max" in server ? " / " + server.max : "") + "</td><td class='server-ip'>" + server.ip + ":" + server.port + "</td></tr>";
                __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].registry.descriptions[server.name] = server.description;
            }

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#servers-list tbody").prepend(html);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#servers-list").tablesorter({
                sortList: [[1, 1]]
            });
        },
        connected: function () {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].onConnected();
        },
        disconnected: function () {
            __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].printDisconnectionMessage();
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].connectedToServer = false;
            // announcement.hide("slow");
        },
        msg: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].print(payload);
        },
        error: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].print(payload);
        },
        chat: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].onChat(JSON.parse(payload));
        },
        playerkick: function (payload) {
            var params = JSON.parse(payload);
            if (params.source) {
                __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].printHtml("<span class='player-kick'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.name(params.source)) + " kicked " +
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.name(params.target)) + "!</span>");
            } else {
                __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].printHtml("<span class='player-kick'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.name(params.target)) +
                    " was kicked by the server!</span>");
            }
        },
        playerban: function (payload) {
            var params = JSON.parse(payload);
            if (params.source) {
                __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].printHtml("<span class='player-ban'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.name(params.source)) + " banned " +
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.name(params.target)) + (params.hasOwnProperty("time") ? " for " + params.time + " minute(s)" : "") + "!</span>");
            } else {
                __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].printHtml("<span class='player-ban'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.name(params.target)) +
                    " was banned by the server" + (params.hasOwnProperty("time") ? " for " + params.time + " minute(s)" : "") + "!</span>");
            }
        },
        challenge: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].registered = true;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#register-dd").addClass("disabled");

            var net = this;

            //var password = $("#password").val();
            var password = '';
            var user = __WEBPACK_IMPORTED_MODULE_7__postorage__["a" /* default */].get("user");
            var storedPw = serverConfig.local ? (__WEBPACK_IMPORTED_MODULE_7__postorage__["a" /* default */].get("pwfor_" + network.ip + "%%" + user) || '') : '';
            console.log(serverConfig, storedPw);

            var hash;

            if (password) {
                hash = __WEBPACK_IMPORTED_MODULE_4_md5___default()(__WEBPACK_IMPORTED_MODULE_4_md5___default()(password) + payload);
                net.send("auth", {hash: hash});
            } else {
                __WEBPACK_IMPORTED_MODULE_1_vex_js___default.a.dialog.open({
                    unsafeMessage: "Please enter your password, <strong>" + __WEBPACK_IMPORTED_MODULE_7__postorage__["a" /* default */].get("user") +"</strong> (<small><a href='" + window.location.pathname + "' target='_self' onclick='poStorage.remove(\"user\");'>Not you?</a></small>):",
                    input: `<input name='password' type='password' placeholder='Password' required value='${storedPw}' />`,
                    callback: function (res) {
                        if (res && res.password) {
                            // after clicking OK
                            // res.password is the value from the textbox
                            hash = __WEBPACK_IMPORTED_MODULE_4_md5___default()(__WEBPACK_IMPORTED_MODULE_4_md5___default()(res.password) + payload);
                            net.send("auth", {hash: hash});

                            if (serverConfig.local) {
                                //TODO: maybe use electron-side saving for electron clients
                                __WEBPACK_IMPORTED_MODULE_7__postorage__["a" /* default */].set("pwfor_" + network.ip + "%%" + user, res.password);
                            }
                        } else {
                            // after clicking Cancel
                            net.close();
                        }
                    }
                });
            }
        },
        battlechallenge: function(payload) {
            var params = JSON.parse(payload);
            var clauses = [];
            for (var i in __WEBPACK_IMPORTED_MODULE_3__battles_battleconstants__["b" /* default */].clauses) {
                if (params.clauses & (1 << i)) {
                    clauses.push(1);
                } else {
                    clauses.push(0);
                }
            }
            params.clauses = clauses;

            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].dealWithChallenge(params);
        },
        announcement: function (/* payload */) {
            /*webclient.sandboxHtml(announcement, payload);
            announcement.css("visibility", "visible");*/
        },
        channels: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.setNames(JSON.parse(payload));
        },
        newchannel: function (payload) {
            var params = JSON.parse(payload);
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.newChannel(params.id, params.name);
        },
        removechannel: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.removeChannel(payload);
        },
        channelnamechange: function (payload) {
            var params = JSON.parse(payload);
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.changeChannelName(params.id, params.name);
        },
        players: function (payload) {
            var params = JSON.parse(payload);
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.addPlayer(params);
        },
        playerlogout: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.removePlayer(payload);
        },
        join: function (payload) {
            var parts = payload.split("|"),
                chan = +parts[0],
                player = +parts[1];

            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.channel(chan).newPlayer(player);
        },
        leave: function (payload) {
            var parts = payload.split("|"),
                chan = +parts[0],
                player = +parts[1];

            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.channel(chan).removePlayer(player);
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.testPlayerOnline(player);
        },
        channelplayers: function (payload) {
            var params = JSON.parse(payload);
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.channel(params.channel).setPlayers(params.players);
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].channels.joinChannel(params.channel);
        },
        login: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].connectedToServer = true;

            var params = JSON.parse(payload);
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].ownTiers = params.tiers;
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.login(params.id, params.info);

            this.command("getrankings", {id: params.id});
        },
        unregistered: function (/* payload */) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#register-dd").removeClass("disabled");
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].registered = false;
        },
        pm: function (payload) {
            var params = JSON.parse(payload),
                src = params.src;
            if (!__WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.isIgnored(src)) {
                __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].pms.pm(src).printMessage(src, params.message);
            }
        },
        watchbattle: function (payload) {
            var id = payload.split("|")[0];
            var params = JSON.parse(payload.slice(id.length + 1));
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.watchBattle(+id, params);
        },
        battlecommand: function (payload) {
            var battleid = payload.split("|")[0];
            if (battleid in __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.battles) {
                __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.dealWithCommand(battleid, JSON.parse(payload.slice(battleid.length + 1)));
            }
        },
        replaycommand: function (payload) {
            var time = payload.split("|")[0];
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.dealWithCommand(+time, JSON.parse(payload.slice(time.length + 1)));
        },
        battlestarted: function (payload) {
            var battleid = payload.split("|")[0],
                battle = JSON.parse(payload.slice(battleid.length + 1)),
                obj = {};

            obj[battleid] = battle;
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.addBattle(obj);
        },
        channelbattle: function (payload) {
            var chanid = payload.split("|")[0],
                params = JSON.parse(payload.slice(chanid.length + 1)),
                obj = {};

            obj[params.battleid] = params.battle;
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.addBattle(obj);
        },
        channelbattlelist: function (payload) {
            var chanid = payload.split("|")[0],
                battle = JSON.parse(payload.slice(chanid.length + 1));

            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.addBattle(battle);

            /* Update whole player list */
            // if (chanid === webclient.currentChannel()) {
            //     webclient.ui.playerList.setPlayers(webclient.channel.playerIds());
            // }
        },
        battlefinished: function (payload) {
            var battleid = payload.split("|")[0],
                result = JSON.parse(payload.slice(battleid.length + 1));

            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.battleEnded(battleid, result);
        },
        stopwatching: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].battles.serverStopWatching(+payload);
        },
        rankings: function (payload) {
            var parts = payload.split("|"),
                rankings = JSON.parse(parts[1]), tier, rank,
                html = "";

            for (tier in rankings) {
                rank = rankings[tier];
                if (rank.ranking === -1) {
                    html += "<li><strong>Unranked</strong>";
                } else {
                    html += "<li><strong>#" + rank.ranking + "/" + rank.total + "</strong> <em>(" + rank.rating + ")</em>";
                }

                html += " - <strong>" + tier + "</strong></li>";
            }

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#rankings").html(html);
        },
        tiers: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].tiersList = JSON.parse(payload);
        },
        optionschange: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].players.optionsChange(JSON.parse(payload));
        },
        teamtiers: function (payload) {
            __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].ownTiers = JSON.parse(payload);
        }
    };

    //actual working commands:
    parsers = {
        connected: parsers.connected,
        disconnected: parsers.disconnected,
        msg: parsers.msg,
        error : parsers.error,
        chat: parsers.chat,
        playerkick: parsers.playerkick,
        playerban: parsers.playerban,
        players: parsers.players,
        channels: parsers.channels,
        newchannel: parsers.newchannel,
        removechannel: parsers.removechannel,
        channelnamechange: parsers.channelnamechange,
        join: parsers.join,
        leave: parsers.leave,
        playerlogout: parsers.playerlogout,
        login: parsers.login,
        channelplayers: parsers.channelplayers,
        challenge: parsers.challenge,
        pm: parsers.pm,
        watchbattle: parsers.watchbattle,
        battlechallenge: parsers.battlechallenge,
        battlecommand: parsers.battlecommand,
        replaycommand: parsers.replaycommand,
        battlestarted: parsers.battlestarted,
        battlefinished: parsers.battlefinished,
        channelbattle: parsers.channelbattle,
        channelbattlelist: parsers.channelbattlelist,
        optionschange: parsers.optionschange,
        unregistered: parsers.unregistered,
        tiers: parsers.tiers,
        teamtiers: parsers.teamtiers,
        stopwatching: parsers.stopwatching
    };

    function Network() {
        __WEBPACK_IMPORTED_MODULE_2_riot_observable___default()(this);

        this.buffer = [];
        this.socket = null;

        this.relay = "";
        this.ip = "";

        this._opened = false;
    }

    Network.prototype.open = function (ip, onopen, onerror, onclose) {
        if (this._opened) {
            return;
        }

        try {
            this.socket = new WebSocket("ws://" + ip);
        } catch (ex) {
            __WEBPACK_IMPORTED_MODULE_1_vex_js___default.a.dialog.alert("Invalid relay IP.");
            throw ex;
        }

        this.ip = ip;
        this.relay = ip.substr(0, ip.lastIndexOf(":"));

        this._opened = true;
        this.socket.onopen = this.onopen(onopen);
        this.socket.onmessage = this.onmessage();
        if (typeof onerror === "function") {
            this.socket.onerror = onerror;
        }
        if (typeof onerror === "function") {
            this.socket.onclose = onclose;
        }
        return this;
    };

    Network.prototype.command = Network.prototype.send = function (command, payload) {
        this.sendRaw(transformers[command].call(this, payload));
        return this;
    };

    Network.prototype.sendRaw = function (msg) {
        if (!this.isOpen()) {
            this.buffer.push(msg);
            return this;
        }

        try {
            this.socket.send(msg);
        } catch (ex) {
            // Ignore potential SYNTAX_ERRs
        }
        return this;
    };

    Network.prototype.close = function () {
        if (!this.opened()) {
            return;
        }

        this.socket.close(1000);
        this.socket = null;
        this._opened = false;
        __WEBPACK_IMPORTED_MODULE_6__webclient__["a" /* default */].connectedToServer = false;
        return this;
    };

    // State
    Network.prototype.opened = function () {
        var socket = this.socket;
        return socket && (socket.readyState === states.Connecting || socket.readyState === states.Open);
    };

    Network.prototype.isOpen = function () {
        var socket = this.socket;
        return socket && (socket.readyState === states.Open);
    };

    // Events
    Network.prototype.onopen = function (cb) {
        var net = this;

        return function () {
            for (var i = 0, len = net.buffer.length; i < len; i++) {
                net.sendRaw(net.buffer[i]);
            }

            if (typeof cb === "function") {
                cb.call(net, net);
            }
        };
    };

    Network.prototype.onmessage = function () {
        var net = this;
        return function (evt) {
            var data = evt.data,
                pipe = data.indexOf("|"),
                cmd, payload;

            if (pipe === -1) {
                console.error("Received raw message, should be changed in the relay station:", data);
            } else {
                cmd = data.substr(0, pipe);
                payload = data.slice(pipe + 1);
                if (parsers.hasOwnProperty(cmd)) {
                    parsers[cmd].call(net, payload);
                } else {
                    net.trigger(cmd, payload);
                }
            }
        };
    };

    Network.states = Network.prototype.states = states;
    Network.transformers = transformers;
    Network.parsers = parsers;

    var network = new Network();
    return network;
}

/* harmony default export */ __webpack_exports__["a"] = createNetwork(typeof MozWebSocket === "function" ? MozWebSocket : WebSocket);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__ = __webpack_require__(28);


const GenInfo = {};
/* harmony export (immutable) */ __webpack_exports__["c"] = GenInfo;

const PokeInfo = {};
/* harmony export (immutable) */ __webpack_exports__["a"] = PokeInfo;

const GenderInfo = {};
/* harmony export (immutable) */ __webpack_exports__["k"] = GenderInfo;

const NatureInfo = {};
/* harmony export (immutable) */ __webpack_exports__["d"] = NatureInfo;

const MoveInfo = {};
/* harmony export (immutable) */ __webpack_exports__["f"] = MoveInfo;

const CategoryInfo = {};
/* harmony export (immutable) */ __webpack_exports__["g"] = CategoryInfo;

const StatInfo = {};
/* harmony export (immutable) */ __webpack_exports__["i"] = StatInfo;

const StatusInfo = {};
/* harmony export (immutable) */ __webpack_exports__["j"] = StatusInfo;

const ItemInfo = {};
/* harmony export (immutable) */ __webpack_exports__["b"] = ItemInfo;

const TypeInfo = {};
/* harmony export (immutable) */ __webpack_exports__["e"] = TypeInfo;

const AbilityInfo = {};
/* harmony export (immutable) */ __webpack_exports__["h"] = AbilityInfo;


var maxGen = {num: 0, subnum: 0};
for (var i in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].gens.versions) {
    var num = (+i) & ((1 << 16)-1);
    var subnum = (+i) >> 16;
    if (num >= maxGen.num) {
        maxGen.num = num;
        maxGen.subnum = subnum;
    }
}

GenInfo.lastGen = maxGen;

var getGen = function(gen, correct) {
    var shouldCorrect = correct !== false;
    if (shouldCorrect) {
        gen = gen || GenInfo.lastGen;
        if (typeof gen === "object") {
            if ("num" in gen) {
                gen.num = +gen.num;
            }
        } else {
            gen = +gen;
        }
    }

    if (typeof gen !== "object") {
        gen = {"num": PokeInfo.species(gen), "subnum": PokeInfo.forme(gen)};
    }

    if (shouldCorrect) {
        if ("num" in gen) {
            gen.num = +gen.num;
        }

        if (isNaN(gen.num) || gen.num < 1 || gen.num > GenInfo.lastGen.num) {
            gen = GenInfo.lastGen;
        }
    }

    return gen;
};

GenInfo.getGen = getGen;
GenInfo.list = function() {
    var arr = [];
    for (var i in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].gens.versions) {
        arr.push(i);
    }
    arr.sort(function(a, b) {
        var genA = getGen(a);
        var genB = getGen(b);
        return (genA.num - genB.num) || (genA.subnum - genB.subnum);
    });
    return arr;
};

GenInfo.name = function(gen) {
    var num = getGen(gen, false).num;
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].generations.generations[num];
};

GenInfo.version = function(gen) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].gens.versions[GenInfo.toNum(gen)];
};

GenInfo.toNum = function(gen) {
    gen = getGen(gen);
    return gen.num + (gen.subnum << 16);
};

GenInfo.options = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].generations.options;
};

GenInfo.option = function(gen) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].generations.options[getGen(gen, false).num];
};

GenInfo.hasOption = function(gen, option) {
    return !!GenInfo.option(gen)[option];
};

PokeInfo.toNum = function(poke) {
    if (typeof poke === "object") {
        return poke.num + ((poke.forme || 0) << 16);
    }
    return poke;
};

PokeInfo.toObject = function(poke) {
    if (typeof poke === "object") {
        return poke;
    }
    poke = +poke;
    return {
        num: PokeInfo.species(poke),
        forme: PokeInfo.forme(poke),
        gen: GenInfo.lastGen
    };
};

PokeInfo.toArray = function(num) {
    var pokenum = 0,
        formenum = 0,
        poke;

    if (typeof num === "number") {
        poke = ["" + num];
    } else if (typeof num === "string") {
        poke = num.split("-");
    } else if (Array.isArray(num)) {
        poke = num;
    }

    if (poke.length === 1) {
        pokenum = PokeInfo.species(+poke[0]);
        formenum = PokeInfo.forme(+poke[0]);
    } else if (poke.length === 2) {
        pokenum = PokeInfo.species(+poke[0]);
        formenum = PokeInfo.species(+poke[1]);
    }

    if (isNaN(pokenum)) {
        pokenum = 0;
    }
    if (isNaN(formenum)) {
        formenum = 0;
    }

    return [pokenum, formenum];
};

PokeInfo.species = function(poke) {
    return poke === undefined ? undefined : poke & ((1 << 16) - 1);
};

PokeInfo.forme = function(poke) {
    return poke === undefined ? undefined : poke >> 16;
};

PokeInfo.find = function(id, what, gen) {
    gen = getGen(gen);
    id = this.toNum(id);

    var gennum = gen.num;
    var array = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes[what][gennum];

    // ability3 in < gen 5
    if (!array) {
        return 0;
    }

    if (id in array) {
        return array[id];
    }

    var ornum = this.species(id);

    if (ornum in array) {
        return array[ornum];
    }

    while (gennum < GenInfo.lastGen.num && ! (id in array) && !(ornum in array)) {
        array = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes[what][++gennum];
    }

    if (!(id in array)) {
        id = ornum;
    } else {
        /* expand */
        if (gennum != gen.num) {
            __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes[what][gen.num][id] = array[id];
        }
    }

    return array[id];
};

PokeInfo.trainerSprite = function(num) {
    return "/images/trainers/" + (num||0) + ".png";
};

PokeInfo.heldItemSprite = function() {
    return ItemInfo.itemSprite("helditem");
};

PokeInfo.genderSprite = function(num) {
    return "/images/genders/ingame_gender" + num + ".png";
};

PokeInfo.substituteSprite = function(back) {
    return "/images/s-m/" + (back ? "back/" : "") + "substitute.png";
}

PokeInfo.sprite = function(poke, params) {
    params = params || {};
    poke = PokeInfo.toObject(poke);
    var gen = getGen(params.gen || poke.gen);
    /* Reuse gen 6 sprites if possible */
    if (gen.num > 6 && PokeInfo.released(poke, 6)) {
        gen = getGen(6);
    }
    var back = params.back || false;

    // Use last gen when dealing with missingno.
    if (poke.num === 0) {
        return "/images/" + __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].generations.options[GenInfo.lastGen.num].sprite_folder + "0.png";
    }

    var options = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].generations.options[gen.num];
    var path = options.sprite_folder;
    if (options.animated) {
        path = "http://web.pokemon-online.eu/images/" + path + "animated/";
    } else  {
        path = "/images/" + path;
    }
    if (back) {
        path += "back/";
    }
    if (PokeInfo.isShiny(poke, poke.gen)) {
        path += "shiny/";
    }
    if (poke.female) {
        path += "female/";
    }
    if (options.animated) {
        path += ("00" + poke.num).slice(-3);
    } else {
        path += poke.num;
    }
    if (poke.forme) {
        path += "-" + poke.forme;
    }
    path += options.animated ? ".gif" : ".png";

    return path;
};

PokeInfo.icon = function(poke) {
    poke = this.toObject(poke);
    return "/images/icons/" + poke.num + (poke.forme ? "-" + poke.forme : "") + ".png";
};

PokeInfo.name = function(poke) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.pokemons[this.toNum(poke)];
};

PokeInfo.num = function(name) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.nums[name.toLowerCase()];
};

PokeInfo.gender = function(poke) {
    var pokeNum = this.toNum(poke);
    if (!(pokeNum in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.gender)) {
        pokeNum %= 65536;
    }
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.gender[pokeNum];
};

PokeInfo.height = function(poke) {
    var pokeNum = this.toNum(poke);
    if (! (pokeNum in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.height)) {
        pokeNum %= 65536;
    }
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.height[pokeNum];
};

PokeInfo.weight = function(poke) {
    var pokeNum = this.toNum(poke);
    if (! (pokeNum in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.weight)) {
        pokeNum %= 65536;
    }
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.weight[pokeNum];
};

PokeInfo.heldItem = function(poke) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.items[this.toNum(poke)];
};

PokeInfo.stats = function(poke, gen) {
    return this.find(poke, "stats", gen);
};

PokeInfo.stat = function(poke, stat, gen) {
    return this.stats(poke, gen)[stat];
};

PokeInfo.allMoves = function(poke, gen) {
    var moves = this.find(poke, "all_moves", gen);
    if (!Array.isArray(moves)) {
        moves = [moves];
    }
    return moves;
};

PokeInfo.types = function(poke, gen) {
    var type1 = this.find(poke, "type1", gen);
    var type2 = this.find(poke, "type2", gen);
    var types = [type1];
    if (type2 != 18) {
        types.push(type2);
    }
    return types;
};

PokeInfo.abilities = function(poke, gen) {
    return [
        this.find(poke, "ability1", gen) || 0,
        this.find(poke, "ability2", gen) || 0,
        this.find(poke, "ability3", gen) || 0
    ];
};

PokeInfo._releasedCache = {};
PokeInfo.releasedList = function(gen, excludeFormes) {
    var gnum = getGen(gen).num;
    if ((gnum + "_ef" + excludeFormes) in PokeInfo._releasedCache) {
        return PokeInfo._releasedCache[gnum + "_ef" + excludeFormes];
    }

    var releasedList = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.released[gnum],
        list = {};

    for (var i in releasedList) {
        if (excludeFormes && +i > 65535) {
            continue;
        }

        // For space economy, values can just be 1
        if (releasedList[i] === 1) {
            list[i] = PokeInfo.name(+i);
        } else {
            list[i] = releasedList[i];
        }
    }

    PokeInfo._releasedCache[gnum + "_ef" + excludeFormes] = list;
    return list;
};

PokeInfo.excludeFormes = true;

PokeInfo.released = function(poke, gen) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.released[getGen(gen).num].hasOwnProperty(this.toNum(poke));
};

PokeInfo.calculateHpIv = function(ivs) {
    /* In generations 1 & 2 the HP DV/IV is calculated */
    return (ivs[1] & 1) * 8 +
        (ivs[2] & 1) * 4 +
        (ivs[5] & 1) * 2 +
        (ivs[3] & 1);
};

PokeInfo.calculateBestShiny = function(info) {
    var shinyIvs = info.ivs.slice();

    shinyIvs[2] = shinyIvs[3] = shinyIvs[4] = shinyIvs[5] = 10;

    // currently only attempts to maintain hp type
    shinyIvs[1] = 15;
    var gen2 = getGen(2);
    var type = MoveInfo.getHiddenPowerType(info.ivs, gen2);
    while (shinyIvs[1] >= 0) {
        if (type === MoveInfo.getHiddenPowerType(shinyIvs, gen2)) break;
        shinyIvs[1] -= (shinyIvs[1] % 2) ? 1 : 3;
    }
    if (shinyIvs[1] < 0) {
        shinyIvs[1] = 15;
    }

    shinyIvs[0] = PokeInfo.calculateHpIv(shinyIvs);
    return shinyIvs;
};

PokeInfo.isShiny = function(info, gen) {
    if (!gen || gen.num > 2) return info.shiny;
    if (!info.ivs || gen.num < 2) return false;
    return info.ivs[2] === 10 && info.ivs[3] === 10 && info.ivs[5] === 10 &&
        [2, 3, 6, 7, 10, 11, 14, 15].indexOf(info.ivs[1]) > -1;
};

PokeInfo.calculateStatInfo = function(info, stat, gen) {
    if (info.num === 292 && stat === 0) {
        return 1;
    }
    gen = gen || GenInfo.lastGen;
    var baseStat = PokeInfo.stat(info, stat, gen);
    var ev = Math.floor(info.ev / 4);
    var iv = info.iv;
    var level = info.level;
    if (stat === 0) { // HP
        if (gen.num > 2) {
            return Math.floor((iv + 2 * baseStat + ev + 100) * level / 100) + 10;
        } else {
            return Math.max(1, Math.min(999,
                Math.floor(((iv + baseStat) * 2 + ev) * level / 100) + level + 10));
        }
    } else {
        if (gen.num > 2) {
            var natureBoost = info.natureBoost;
            return Math.floor(Math.floor((iv + 2 * baseStat + ev) * level / 100 + 5) * natureBoost);
        } else {
            return Math.max(1, Math.min(999,
                Math.floor(((iv + baseStat) * 2 + ev) * level / 100) + 5));
        }
    }
};

PokeInfo.calculateStat = function(poke, stat, gen) {
    gen = gen || GenInfo.lastGen;
    return PokeInfo.calculateStatInfo({
        "num": poke.num,
        "forme": poke.forme || 0,
        "iv": poke.ivs[stat],
        "ev": poke.evs[stat],
        "level": poke.level,
        "natureBoost": NatureInfo.getNatureEffect(poke.nature, stat)
    }, stat, gen);
};

PokeInfo.minStat = function(poke, stat, gen) {
    gen = gen || GenInfo.lastGen;
    var ret = PokeInfo.calculateStatInfo({
        "num": poke.num,
        "forme": poke.forme || 0,
        "iv": gen.num > 2 ? 31 : 15,
        "ev": gen.num > 2 ? 0 : 255,
        "level": poke.level,
        "natureBoost": 1
    }, stat, gen);
    var boost = poke.boost || 0;
    if (gen.num <= 2) {
        return Math.floor(ret * Math.floor(
            Math.max(2, 2 + boost) / Math.max(2, 2 - boost) * 100) / 100);
    }
    return Math.floor(ret * Math.max(2, 2 + boost) / Math.max(2, 2 - boost));
};

PokeInfo.maxStat = function(poke, stat, gen) {
    gen = gen || GenInfo.lastGen;
    var ret = PokeInfo.calculateStatInfo({
        "num": poke.num,
        "forme": poke.forme || 0,
        "iv": gen.num > 2 ? 31 : 15,
        "ev": 252,
        "level": poke.level,
        "natureBoost": 1.1
    }, stat, gen);
    var boost = poke.boost || 0;
    if (gen.num <= 2) {
        return Math.floor(ret * Math.floor(
            Math.max(2, 2 + boost) / Math.max(2, 2 - boost) * 100) / 100);
    }
    return Math.floor(ret * Math.max(2, 2 + boost) / Math.max(2, 2 - boost));
};

PokeInfo.itemForForme = function(poke) {
    var num = PokeInfo.toNum(poke);
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].pokes.item_for_forme[num] || 0;
};

GenderInfo.name = function(gender) {
    return {1: "male", 2: "female", 3: "neutral"}[gender];
};

GenderInfo.shorthand = function(gender) {
    return {1: "(M)", 2: "(F)", 3: "", 0: ""}[gender];
};

NatureInfo.list = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].natures.nature;
};

NatureInfo.name = function(nature) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].natures.nature[nature];
};

NatureInfo.num = function(nature) {
    if (!__WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].natures.nums) {
        __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].natures.nums = {};
        for (var i = 0; i < 25; i++) {
            __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].natures.nums[NatureInfo.name(i).toLowerCase()] = i;
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].natures.nums[nature.toLowerCase()];
};

NatureInfo.getNatureEffect = function(nature_id, stat_id) {
    var arr = [-1, 0, 1, 3, 4, 2];
    var n1 = (Math.floor(nature_id / 5) === arr[stat_id]) ? 1 : 0;
    var n2 = (nature_id % 5 === arr[stat_id]) ? 1 : 0;
    return (10 + n1 - n2) / 10;
};

NatureInfo.boostedStat = function(nature_id) {
    var arr = [1, 2, 5, 3, 4];
    if (Math.floor(nature_id / 5) !== nature_id % 5) {
        return arr[Math.floor(nature_id / 5)];
    }
    return -1;
};

NatureInfo.reducedStat = function(nature_id) {
    var arr = [1, 2, 5, 3, 4];
    if (Math.floor(nature_id / 5) !== nature_id % 5) {
        return arr[nature_id % 5];
    }
    return -1;
};

NatureInfo.getNatureForBoosts = function(plus_boost, neg_boost) {
    for (var i = 0; i < 25; i++) {
        if (NatureInfo.boostedStat(i) == plus_boost && NatureInfo.reducedStat(i) == neg_boost) {
            return i;
        }
    }
    return -1;
};

MoveInfo.list = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.moves;
};

MoveInfo.hasMove = function(move) {
    return move in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.moves;
};

MoveInfo.name = function(move) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.moves[move];
};

MoveInfo.num = function(move) {
    if (!__WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.nums) {
        __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.nums = {};
        for (var num in MoveInfo.list()) {
            __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.nums[MoveInfo.name(num).toLowerCase()] = num;
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.nums[move.toLowerCase()];
};

MoveInfo.findId = function(move) {
    var list = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.moves,
        moveNum, moveName;

    for (moveNum in list) {
        moveName = list[moveNum];

        if (move === moveName) {
            return +moveNum;
        }
    }

    return 0;
};

MoveInfo.find = function(id, what, gen) {
    gen = getGen(gen);

    if (! (what in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves)) {
        return "";
    }

    var gennum = gen.num;
    var array = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves[what][gennum];

    if (id in array) {
        return array[id];
    }

    while (gennum < GenInfo.lastGen.num && ! (id in array)) {
        array = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves[what][++gennum];
    }

    /* expand */
    if (gennum != gen.num && id in array) {
        __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves[what][gen.num][id] = array[id];
    }

    return array[id];
};

MoveInfo.accuracy = function(move, gen) {
    return this.find(move, "accuracy", gen) || 0;
};

MoveInfo.category = function(move, gen) {
    var d = this.find(move, "damage_class", gen);
    if (d && getGen(gen).num <= 2) {
        return TypeInfo.category(MoveInfo.type(move));
    }
    return d || 0;
};

MoveInfo.effect = function(move, gen) {
    var p = MoveInfo.effectChance(move, gen);
    if (getGen(gen).num < 2) {
        p = p + "/256 (" + Math.round(p / 256 * 100) + "%)";
    }
    return (this.find(move, "effect", gen) || "").replace("$effect_chance", p);
};

MoveInfo.effectChance = function(move, gen) {
    return this.find(move, "effect_chance", gen) || 0;
};

MoveInfo.power = function(move, gen) {
    return this.find(move, "power", gen) || 0;
};

MoveInfo.pp = function(move, gen) {
    return this.find(move, "pp", gen);
};

MoveInfo.type = function(move, gen) {
    return this.find(move, "type", gen) || 0;
};

MoveInfo.message = function(move, part) {
    var messages = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].moves.move_message[move];

    if (!messages) {
        return "";
    }

    var parts = messages.split("|");
    if (part >= 0 && part < parts.length) {
        return parts[part];
    }

    return "";
};

MoveInfo.getHiddenPowerIVs = function(type, generation) {
    generation = getGen(generation).num;
    type = +type;

    if (generation < 3) {
        // only 1 optimal HP exists per type
        type -= 1;
        return [[
            ((type & 4) << 1) | ((type & 1) << 2) | 3,
            12 | (type >> 2),
            12 | (type & 3),
            15, 15, 15
        ]];
    }

    var ivLists = [];
    for (var i = 63; i >= 0; i--) {
        var ivs = [
            (i & 1) ? 31 : 30,
            (i & 2) ? 31 : 30,
            (i & 4) ? 31 : 30,
            (i & 8) ? 31 : 30,
            (i & 16) ? 31 : 30,
            (i & 32) ? 31 : 30
        ];
        if (MoveInfo.getHiddenPowerType(ivs, generation) === type) {
            ivLists.push(ivs);
        }
    }

    var statImportance = [5, 3, 0, 2, 4, 1];
    return ivLists.sort(function(a, b) {
        // sort for perfect speed IV
        // sort for total perfect IVs
        // and then sort based on which stats are more important
        // Speed > SpAtk > HP > Def > SpDef > HP
        if (a[5] !== b[5]) return b[5] - a[5];
        var sumA = 0;
        var sumB = 0;
        var imp = 0;
        for (var i = 0; i < 6; i++) {
            sumA += a[i];
            sumB += b[i];
            if (!imp && a[statImportance[i]] !== b[statImportance[i]]) {
                imp += b[statImportance[i]] - a[statImportance[i]];
            }
        }
        return (sumB - sumA) || imp;
    });
};

MoveInfo.getHiddenPowerType = function(ivs, generation) {
    generation = getGen(generation).num;
    if (generation <= 2) {
        return 1 + (ivs[1] & 3) * 4 + (ivs[2] & 3);
    }
    var bits = (ivs[0] & 1) +
        ((ivs[1] & 1) * 2) +
        ((ivs[2] & 1) * 4) +
        ((ivs[5] & 1) * 8) +
        ((ivs[3] & 1) * 16) +
        ((ivs[4] & 1) * 32);
    return 1 + Math.floor(bits * 15 / 63);
};

MoveInfo.getHiddenPowerBP = function(ivs, generation) {
    generation = getGen(generation).num;
    var bits;
    if (generation <= 2) {
        bits = (ivs[3] >> 3) +
            ((ivs[5] >> 2) & 2) +
            ((ivs[2] >> 1) & 4) +
            (ivs[1] & 8);
        return 31 + Math.floor((5 * bits + (ivs[3] & 3)) / 2);
    }
    if (generation <= 5) {
        bits = (ivs[0] & 2) / 2 +
            (ivs[1] & 2) +
            (ivs[2] & 2) * 2 +
            (ivs[5] & 2) * 4 +
            (ivs[3] & 2) * 8 +
            (ivs[4] & 2) * 16;
        return 30 + Math.floor(bits * 40 / 63);
    }
    return 60;
};

CategoryInfo.list = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].categories.categories;
};

CategoryInfo.name = function(category) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].categories.categories[category];
};

ItemInfo.list = function() {
    var list = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.items;
    for (var i in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berries) {
        list[i + 8000] = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berries[i];
    }
    return list;
};

ItemInfo.hasItem = function(item) {
    if (item >= 8000) {
        return (item - 8000) in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berries;
    } else {
        return item in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.items;
    }
};

ItemInfo.name = function(item) {
    if (item >= 8000) {
        return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berries[item - 8000];
    } else {
        return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.items[item];
    }
};

ItemInfo.num = function(name) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.nums[name.toLowerCase()];
};

ItemInfo.berryName = function(item) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berries[item];
};

ItemInfo._releasedCache = {};
ItemInfo.releasedList = function(gen) {
    var gnum = getGen(gen).num;
    if (gnum in ItemInfo._releasedCache) {
        return ItemInfo._releasedCache[gnum];
    }

    var list = {},
        releasedItems = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.released_items[gnum],
        releasedBerries = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.released_berries[gnum],
        i;

    // Inline access for speed
    for (i in releasedItems) {
        list[i] = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.items[i];
    }

    for (i in releasedBerries) {
        list[+i + 8000] = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berries[i];
    }

    ItemInfo._releasedCache[gnum] = list;
    return list;
};

ItemInfo.released = function(item, gen) {
    gen = getGen(gen).num;
    if (item >= 8000) {
        return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.released_berries[gen].hasOwnProperty(item-8000);
    } else {
        return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.released_items[gen].hasOwnProperty(item);
    }
};

ItemInfo.usefulList = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.item_useful;
};

ItemInfo.useful = function(item) {
    return item > 8000 || __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.item_useful.hasOwnProperty(item);
};

ItemInfo.message = function(item, part) {
    var messages = (item >= 8000 ? __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berry_messages[item-8000] : __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.item_messages[item]);

    if (!messages) {
        return "";
    }

    var parts = messages.split("|");
    if (part >= 0 && part < parts.length) {
        return parts[part];
    }

    return "";
};

ItemInfo.desc = function(item) {
    if (item >= 8000) {
        return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.berries_description[+item - 8000] || "";
    } else {
        return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].items.items_description[item] || "";
    }
};

ItemInfo.itemSprite = function(item) {
    if (+item >= 8000) {
        return "/images/berries/" + (item - 8000) + ".png";
    } else {
        return "/images/items/" + item + ".png";
    }
};

ItemInfo.isMegaStone = function(item) {
    return item >= 2000 && item < 3000;
};

StatInfo.list = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].status.stats;
};

StatInfo.name = function(stat) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].status.stats[stat];
};

StatusInfo.list = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].status.status;
};

StatusInfo.name = function(status) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].status.status[status];
};

TypeInfo.list = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].types.types;
};

TypeInfo.name = function(type) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].types.types[type];
};

TypeInfo.num = function(type) {
    type = type.toLowerCase();
    for (var t in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].types.types) {
        if (type === __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].types.types[t].toLowerCase()) {
            return t;
        }
    }
    return -1;
};

TypeInfo.css = function(type) {
    if (type == 18) {
        return "curse";
    }
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].types.types[type].toLowerCase();
};

TypeInfo.categoryList = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].types.category;
};

TypeInfo.category = function(type) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].types.category[type];
};

TypeInfo.sprite = function(type) {
    return "/images/types/type" + type + ".png";
};

AbilityInfo.list = function() {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.abilities;
};

AbilityInfo.name = function(ability) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.abilities[ability];
};

AbilityInfo.num = function(ability) {
    if (!__WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.nums) {
        __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.nums = {};
        for (var num in __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.abilities) {
            __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.nums[__WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.abilities[num].toLowerCase()] = num;
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.nums[ability.toLowerCase()];
};

AbilityInfo.desc = function(ability) {
    return __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.ability_desc[ability] !== true ? __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.ability_desc[ability] : "No ability.";
};

AbilityInfo.message = function(ability, part) {
    var messages = __WEBPACK_IMPORTED_MODULE_0__pokedex_basic__["a" /* default */].abilities.ability_messages[ability];
    part = part || 0;

    if (!messages) {
        return "";
    }

    var parts = messages.split("|");
    if (part >= 0 && part < parts.length) {
        return parts[part];
    }

    return "";
};

/* Needed by simplebattlewindow.js which is inside an iframe */
if(typeof window != "undefined") window.PokeInfo = PokeInfo;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["b"] = Chat;
/* harmony export (immutable) */ __webpack_exports__["a"] = afterLoad;






var chatHtml =`
    <div class="chat">

    </div>

    <div class="chatInputContainer">
      <input type="text" class="form-control chatInput" placeholder="Type your message..." history>
    </div>`;

// At least Chrome (I assume other browsers do the same) expand <timestamp/> to <timestamp><timestamp/> (as it is an unknown element).
var timestampRegex = /<timestamp *\/ *>|<timestamp><\/timestamp>/gi;

function Chat() {
    __WEBPACK_IMPORTED_MODULE_1_riot_observable___default()(this);

    this.element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='flex-column chat-column'>").html(chatHtml);
    if (__WEBPACK_IMPORTED_MODULE_2__frontend__["default"].players.showColors) {
        this.element.addClass("rainbow");
    }
    this.chatTextArea = this.element.find(".chat");
    this.chatSend = this.element.find(".chatInput");
    this.chatCount = 0;

    var self = this;
    this.chatSend.keydown(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* onEnterPressed */])(function () {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val().length > 0) {
            self.trigger("chat", __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val());
        }
        //$(this).val('');
    }));
}

Chat.prototype.disable = function() {
    this.chatSend.prop("disabled", true);
};

Chat.prototype.insertMessage = function (msg, opts) {
    var chatTextArea = this.chatTextArea;
    var cta = chatTextArea[0];
    var scrollDown = cta.scrollTop >= cta.scrollHeight - cta.offsetHeight;
    var timestampPart;

    opts = opts || {};

    if (opts.timestamps) {
        timestampPart = "<span class='timestamp'>(" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["i" /* timestamp */])() + ")</span> ";
        if (opts.html) {
            msg = msg.replace(timestampRegex, timestampPart);
        } else if (msg) {
            msg = timestampPart + msg;
        }
    }

    if (opts.linebreak) {
        msg += "<br/>";
    }

    chatTextArea.append("<div class='chat-line'>" + msg + "</div>");

    /* Limit number of lines */
    if (this.chatCount++ % 100 === 0) {
        chatTextArea.html(chatTextArea.find(".chat-line").slice(-500));
    }

    if (scrollDown) {
        this.scrollDown();
    }
};

Chat.prototype.scrollDown = function() {
    //this.chatTextArea.finish().animate({scrollTop: this.chatTextArea[0].scrollHeight}, "fast");
    this.chatTextArea.scrollTop(this.chatTextArea[0].scrollHeight);
};

function  afterLoad () {
    var maxHistSize = 100;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("keydown", "[history]", function (event) {
        var elem = event.currentTarget;

        elem.hist = elem.hist || [];
        elem.histIndex = elem.histIndex || 0;
        if (event.which === 38) { // Up
            if (elem.histIndex === elem.hist.length && elem.value.match(/\S/)) {
                elem.hist.push(elem.value);
                if (elem.hist.length > maxHistSize) {
                    elem.hist.shift();
                }
            }
            if (elem.histIndex > 0) {
                let str = elem.hist[--elem.histIndex];
                elem.value = str;
                setTimeout(function(){
                    elem.setSelectionRange(str.length, str.length);
                });
            }
        } else if (event.which === 40) { // Down
            if (elem.histIndex < elem.hist.length) {
                let str = elem.hist[++elem.histIndex] || ""
                elem.value = str;
                setTimeout(function(){
                    elem.setSelectionRange(str.length, str.length);
                });
            }
        } else if (event.which === 13) { // Return
            if (!elem.value.length) {
                return;
            }
            elem.hist.push(elem.value);
            if (elem.hist.length > maxHistSize) {
                elem.hist.shift();
            }
            elem.histIndex = elem.hist.length;
            elem.value = "";
        }
    });
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(58)
__webpack_require__(48)
__webpack_require__(49)
__webpack_require__(50)
__webpack_require__(51)
__webpack_require__(52)
__webpack_require__(53)
__webpack_require__(57)
__webpack_require__(54)
__webpack_require__(55)
__webpack_require__(56)
__webpack_require__(47)

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.vex = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*
 * classList.js: Cross-browser full element.classList implementation.
 * 2014-07-23
 *
 * By Eli Grey, http://eligrey.com
 * Public Domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/

/* Copied from MDN:
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
 */

if ("document" in window.self) {

  // Full polyfill for browsers with no classList support
  // Including IE < Edge missing SVGElement.classList
  if (!("classList" in document.createElement("_"))
    || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

  (function (view) {

    "use strict";

    if (!('Element' in view)) return;

    var
        classListProp = "classList"
      , protoProp = "prototype"
      , elemCtrProto = view.Element[protoProp]
      , objCtr = Object
      , strTrim = String[protoProp].trim || function () {
        return this.replace(/^\s+|\s+$/g, "");
      }
      , arrIndexOf = Array[protoProp].indexOf || function (item) {
        var
            i = 0
          , len = this.length
        ;
        for (; i < len; i++) {
          if (i in this && this[i] === item) {
            return i;
          }
        }
        return -1;
      }
      // Vendors: please allow content code to instantiate DOMExceptions
      , DOMEx = function (type, message) {
        this.name = type;
        this.code = DOMException[type];
        this.message = message;
      }
      , checkTokenAndGetIndex = function (classList, token) {
        if (token === "") {
          throw new DOMEx(
              "SYNTAX_ERR"
            , "An invalid or illegal string was specified"
          );
        }
        if (/\s/.test(token)) {
          throw new DOMEx(
              "INVALID_CHARACTER_ERR"
            , "String contains an invalid character"
          );
        }
        return arrIndexOf.call(classList, token);
      }
      , ClassList = function (elem) {
        var
            trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
          , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
          , i = 0
          , len = classes.length
        ;
        for (; i < len; i++) {
          this.push(classes[i]);
        }
        this._updateClassName = function () {
          elem.setAttribute("class", this.toString());
        };
      }
      , classListProto = ClassList[protoProp] = []
      , classListGetter = function () {
        return new ClassList(this);
      }
    ;
    // Most DOMException implementations don't allow calling DOMException's toString()
    // on non-DOMExceptions. Error's toString() is sufficient here.
    DOMEx[protoProp] = Error[protoProp];
    classListProto.item = function (i) {
      return this[i] || null;
    };
    classListProto.contains = function (token) {
      token += "";
      return checkTokenAndGetIndex(this, token) !== -1;
    };
    classListProto.add = function () {
      var
          tokens = arguments
        , i = 0
        , l = tokens.length
        , token
        , updated = false
      ;
      do {
        token = tokens[i] + "";
        if (checkTokenAndGetIndex(this, token) === -1) {
          this.push(token);
          updated = true;
        }
      }
      while (++i < l);

      if (updated) {
        this._updateClassName();
      }
    };
    classListProto.remove = function () {
      var
          tokens = arguments
        , i = 0
        , l = tokens.length
        , token
        , updated = false
        , index
      ;
      do {
        token = tokens[i] + "";
        index = checkTokenAndGetIndex(this, token);
        while (index !== -1) {
          this.splice(index, 1);
          updated = true;
          index = checkTokenAndGetIndex(this, token);
        }
      }
      while (++i < l);

      if (updated) {
        this._updateClassName();
      }
    };
    classListProto.toggle = function (token, force) {
      token += "";

      var
          result = this.contains(token)
        , method = result ?
          force !== true && "remove"
        :
          force !== false && "add"
      ;

      if (method) {
        this[method](token);
      }

      if (force === true || force === false) {
        return force;
      } else {
        return !result;
      }
    };
    classListProto.toString = function () {
      return this.join(" ");
    };

    if (objCtr.defineProperty) {
      var classListPropDesc = {
          get: classListGetter
        , enumerable: true
        , configurable: true
      };
      try {
        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
      } catch (ex) { // IE 8 doesn't support enumerable:true
        if (ex.number === -0x7FF5EC54) {
          classListPropDesc.enumerable = false;
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        }
      }
    } else if (objCtr[protoProp].__defineGetter__) {
      elemCtrProto.__defineGetter__(classListProp, classListGetter);
    }

    }(window.self));

    } else {
    // There is full or partial native classList support, so just check if we need
    // to normalize the add/remove and toggle APIs.

    (function () {
      "use strict";

      var testElement = document.createElement("_");

      testElement.classList.add("c1", "c2");

      // Polyfill for IE 10/11 and Firefox <26, where classList.add and
      // classList.remove exist but support only one argument at a time.
      if (!testElement.classList.contains("c2")) {
        var createMethod = function(method) {
          var original = DOMTokenList.prototype[method];

          DOMTokenList.prototype[method] = function(token) {
            var i, len = arguments.length;

            for (i = 0; i < len; i++) {
              token = arguments[i];
              original.call(this, token);
            }
          };
        };
        createMethod('add');
        createMethod('remove');
      }

      testElement.classList.toggle("c3", false);

      // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
      // support the second argument.
      if (testElement.classList.contains("c3")) {
        var _toggle = DOMTokenList.prototype.toggle;

        DOMTokenList.prototype.toggle = function(token, force) {
          if (1 in arguments && !this.contains(token) === !force) {
            return force;
          } else {
            return _toggle.call(this, token);
          }
        };

      }

      testElement = null;
    }());
  }
}

},{}],2:[function(require,module,exports){

/**
 * Expose `parse`.
 */

module.exports = parse;

/**
 * Tests for browser support.
 */

var innerHTMLBug = false;
var bugTestDiv;
if (typeof document !== 'undefined') {
  bugTestDiv = document.createElement('div');
  // Setup
  bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
  // Make sure that link elements get serialized correctly by innerHTML
  // This requires a wrapper element in IE
  innerHTMLBug = !bugTestDiv.getElementsByTagName('link').length;
  bugTestDiv = undefined;
}

/**
 * Wrap map from jquery.
 */

var map = {
  legend: [1, '<fieldset>', '</fieldset>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  // for script/link/style tags to work in IE6-8, you have to wrap
  // in a div with a non-whitespace character in front, ha!
  _default: innerHTMLBug ? [1, 'X<div>', '</div>'] : [0, '', '']
};

map.td =
map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

map.option =
map.optgroup = [1, '<select multiple="multiple">', '</select>'];

map.thead =
map.tbody =
map.colgroup =
map.caption =
map.tfoot = [1, '<table>', '</table>'];

map.polyline =
map.ellipse =
map.polygon =
map.circle =
map.text =
map.line =
map.path =
map.rect =
map.g = [1, '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">','</svg>'];

/**
 * Parse `html` and return a DOM Node instance, which could be a TextNode,
 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
 * instance, depending on the contents of the `html` string.
 *
 * @param {String} html - HTML string to "domify"
 * @param {Document} doc - The `document` instance to create the Node for
 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
 * @api private
 */

function parse(html, doc) {
  if ('string' != typeof html) throw new TypeError('String expected');

  // default to the global `document` object
  if (!doc) doc = document;

  // tag name
  var m = /<([\w:]+)/.exec(html);
  if (!m) return doc.createTextNode(html);

  html = html.replace(/^\s+|\s+$/g, ''); // Remove leading/trailing whitespace

  var tag = m[1];

  // body support
  if (tag == 'body') {
    var el = doc.createElement('html');
    el.innerHTML = html;
    return el.removeChild(el.lastChild);
  }

  // wrap map
  var wrap = map[tag] || map._default;
  var depth = wrap[0];
  var prefix = wrap[1];
  var suffix = wrap[2];
  var el = doc.createElement('div');
  el.innerHTML = prefix + html + suffix;
  while (depth--) el = el.lastChild;

  // one element
  if (el.firstChild == el.lastChild) {
    return el.removeChild(el.firstChild);
  }

  // several elements
  var fragment = doc.createDocumentFragment();
  while (el.firstChild) {
    fragment.appendChild(el.removeChild(el.firstChild));
  }

  return fragment;
}

},{}],3:[function(require,module,exports){
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

'use strict';

function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};

},{}],4:[function(require,module,exports){
// classList polyfill for old browsers
require('classlist-polyfill')
// Object.assign polyfill
require('es6-object-assign').polyfill()

// String to DOM function
var domify = require('domify')

// Use the DOM's HTML parsing to escape any dangerous strings
var escapeHtml = function escapeHtml (str) {
  if (typeof str !== 'undefined') {
    var div = document.createElement('div')
    div.appendChild(document.createTextNode(str))
    return div.innerHTML
  } else {
    return ''
  }
}

// Utility function to add space-delimited class strings to a DOM element's classList
var addClasses = function addClasses (el, classStr) {
  if (typeof classStr !== 'string' || classStr.length === 0) {
    return
  }
  var classes = classStr.split(' ')
  for (var i = 0; i < classes.length; i++) {
    var className = classes[i]
    if (className.length) {
      el.classList.add(className)
    }
  }
}

// Detect CSS Animation End Support
// https://github.com/limonte/sweetalert2/blob/99bd539f85e15ac170f69d35001d12e092ef0054/src/utils/dom.js#L194
var animationEndEvent = (function detectAnimationEndEvent () {
  var el = document.createElement('div')
  var eventNames = {
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'animationend',
    'OAnimation': 'oanimationend',
    'msAnimation': 'MSAnimationEnd',
    'animation': 'animationend'
  }
  for (var i in eventNames) {
    if (el.style[i] !== undefined) {
      return eventNames[i]
    }
  }
  return false
})()

// vex base CSS classes
var baseClassNames = {
  vex: 'vex',
  content: 'vex-content',
  overlay: 'vex-overlay',
  close: 'vex-close',
  closing: 'vex-closing',
  open: 'vex-open'
}

// Private lookup table of all open vex objects, keyed by id
var vexes = {}
var globalId = 1

// Private boolean to assist the escapeButtonCloses option
var isEscapeActive = false

// vex itself is an object that exposes a simple API to open and close vex objects in various ways
var vex = {
  open: function open (opts) {
    // Check for usage of deprecated options, and log a warning
    var warnDeprecated = function warnDeprecated (prop) {
      console.warn('The "' + prop + '" property is deprecated in vex 3. Use CSS classes and the appropriate "ClassName" options, instead.')
      console.warn('See http://github.hubspot.com/vex/api/advanced/#options')
    }
    if (opts.css) {
      warnDeprecated('css')
    }
    if (opts.overlayCSS) {
      warnDeprecated('overlayCSS')
    }
    if (opts.contentCSS) {
      warnDeprecated('contentCSS')
    }
    if (opts.closeCSS) {
      warnDeprecated('closeCSS')
    }

    // The dialog instance
    var vexInstance = {}

    // Set id
    vexInstance.id = globalId++

    // Store internally
    vexes[vexInstance.id] = vexInstance

    // Set state
    vexInstance.isOpen = true

    // Close function on the vex instance
    // This is how all API functions should close individual vexes
    vexInstance.close = function instanceClose () {
      // Check state
      if (!this.isOpen) {
        return true
      }

      var options = this.options

      // escapeButtonCloses is checked first
      if (isEscapeActive && !options.escapeButtonCloses) {
        return false
      }

      // Allow the user to validate any info or abort the close with the beforeClose callback
      var shouldClose = (function shouldClose () {
        // Call before close callback
        if (options.beforeClose) {
          return options.beforeClose.call(this)
        }
        // Otherwise indicate that it's ok to continue with close
        return true
      }.bind(this)())

      // If beforeClose() fails, abort the close
      if (shouldClose === false) {
        return false
      }

      // Update state
      this.isOpen = false

      // Detect if the content el has any CSS animations defined
      var style = window.getComputedStyle(this.contentEl)
      function hasAnimationPre (prefix) {
        return style.getPropertyValue(prefix + 'animation-name') !== 'none' && style.getPropertyValue(prefix + 'animation-duration') !== '0s'
      }
      var hasAnimation = hasAnimationPre('') || hasAnimationPre('-webkit-') || hasAnimationPre('-moz-') || hasAnimationPre('-o-')

      // Define the function that will actually close the instance
      var close = function close () {
        if (!this.rootEl.parentNode) {
          return
        }
        // Run once
        this.rootEl.removeEventListener(animationEndEvent, close)
        // Remove from lookup table (prevent memory leaks)
        delete vexes[this.id]
        // Remove the dialog from the DOM
        this.rootEl.parentNode.removeChild(this.rootEl)
        // Call after close callback
        if (options.afterClose) {
          options.afterClose.call(this)
        }
        // Remove styling from the body, if no more vexes are open
        if (Object.keys(vexes).length === 0) {
          document.body.classList.remove(baseClassNames.open)
        }
      }.bind(this)

      // Close the vex
      if (animationEndEvent && hasAnimation) {
        // Setup the end event listener, to remove the el from the DOM
        this.rootEl.addEventListener(animationEndEvent, close)
        // Add the closing class to the dialog, showing the close animation
        this.rootEl.classList.add(baseClassNames.closing)
      } else {
        close()
      }

      return true
    }

    // Allow strings as content
    if (typeof opts === 'string') {
      opts = {
        content: opts
      }
    }

    // `content` is unsafe internally, so translate
    // safe default: HTML-escape the content before passing it through
    if (opts.unsafeContent && !opts.content) {
      opts.content = opts.unsafeContent
    } else if (opts.content) {
      opts.content = escapeHtml(opts.content)
    }

    // Store options on instance for future reference
    var options = vexInstance.options = Object.assign({}, vex.defaultOptions, opts)

    // vex root
    var rootEl = vexInstance.rootEl = document.createElement('div')
    rootEl.classList.add(baseClassNames.vex)
    addClasses(rootEl, options.className)

    // Overlay
    var overlayEl = vexInstance.overlayEl = document.createElement('div')
    overlayEl.classList.add(baseClassNames.overlay)
    addClasses(overlayEl, options.overlayClassName)
    if (options.overlayClosesOnClick) {
      overlayEl.addEventListener('click', function overlayClickListener (e) {
        if (e.target === overlayEl) {
          vexInstance.close()
        }
      })
    }
    rootEl.appendChild(overlayEl)

    // Content
    var contentEl = vexInstance.contentEl = document.createElement('div')
    contentEl.classList.add(baseClassNames.content)
    addClasses(contentEl, options.contentClassName)
    contentEl.appendChild(options.content instanceof window.Node ? options.content : domify(options.content))
    rootEl.appendChild(contentEl)

    // Close button
    if (options.showCloseButton) {
      var closeEl = vexInstance.closeEl = document.createElement('div')
      closeEl.classList.add(baseClassNames.close)
      addClasses(closeEl, options.closeClassName)
      closeEl.addEventListener('click', vexInstance.close.bind(vexInstance))
      contentEl.appendChild(closeEl)
    }

    // Add to DOM
    document.querySelector(options.appendLocation).appendChild(rootEl)

    // Call after open callback
    if (options.afterOpen) {
      options.afterOpen.call(vexInstance)
    }

    // Apply styling to the body
    document.body.classList.add(baseClassNames.open)

    // Return the created vex instance
    return vexInstance
  },

  // A top-level vex.close function to close dialogs by reference or id
  close: function close (vexOrId) {
    var id
    if (vexOrId.id) {
      id = vexOrId.id
    } else if (typeof vexOrId === 'string') {
      id = vexOrId
    } else {
      throw new TypeError('close requires a vex object or id string')
    }
    if (!vexes[id]) {
      return false
    }
    return vexes[id].close()
  },

  // Close the most recently created/opened vex
  closeTop: function closeTop () {
    var ids = Object.keys(vexes)
    if (!ids.length) {
      return false
    }
    return vexes[ids[ids.length - 1]].close()
  },

  // Close every vex!
  closeAll: function closeAll () {
    for (var id in vexes) {
      this.close(id)
    }
    return true
  },

  // A getter for the internal lookup table
  getAll: function getAll () {
    return vexes
  },

  // A getter for the internal lookup table
  getById: function getById (id) {
    return vexes[id]
  }
}

// Close top vex on escape
window.addEventListener('keyup', function vexKeyupListener (e) {
  if (e.keyCode === 27) {
    isEscapeActive = true
    vex.closeTop()
    isEscapeActive = false
  }
})

// Close all vexes on history pop state (useful in single page apps)
window.addEventListener('popstate', function () {
  if (vex.defaultOptions.closeAllOnPopState) {
    vex.closeAll()
  }
})

vex.defaultOptions = {
  content: '',
  showCloseButton: true,
  escapeButtonCloses: true,
  overlayClosesOnClick: true,
  appendLocation: 'body',
  className: '',
  overlayClassName: '',
  contentClassName: '',
  closeClassName: '',
  closeAllOnPopState: true
}

// TODO Loading symbols?

// Include escapeHtml function on the library object
Object.defineProperty(vex, '_escapeHtml', {
  configurable: false,
  enumerable: false,
  writable: false,
  value: escapeHtml
})

// Plugin system!
vex.registerPlugin = function registerPlugin (pluginFn, name) {
  var plugin = pluginFn(vex)
  var pluginName = name || plugin.name
  if (vex[pluginName]) {
    throw new Error('Plugin ' + name + ' is already registered.')
  }
  vex[pluginName] = plugin
}

module.exports = vex

},{"classlist-polyfill":1,"domify":2,"es6-object-assign":3}]},{},[4])(4)
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_riot_observable__);
/* harmony export (immutable) */ __webpack_exports__["a"] = BaseTab;






function BaseTab(/* id */) {
    __WEBPACK_IMPORTED_MODULE_3_riot_observable___default()(this);
    this.notificationCount = 0;
}

BaseTab.prototype.isCurrent = function() {
    //return this === webclient.channel;
    return this === __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].currentTab;
};

BaseTab.prototype.activateTab = function() {
    if (!this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + this.shortHand + "-" + this.id).addClass("tab-active");
    }

    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].updateBadgeCount();
};

BaseTab.prototype.flashTab = function() {
    if (!this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + this.shortHand + "-" + this.id).addClass("tab-flash");
    }
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].updateBadgeCount();
};

BaseTab.prototype.makeName = function(name) {
    return "<span class='channel-title'>" + name + "</span><i class='fa fa-times-circle'></i>";
};

BaseTab.prototype.setCurrentTab = function() {
    if (this.tab) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tab").removeClass("current");
        this.tab.addClass("current");
    }

    if (this.isCurrent()) {
        return;
    }

    //Make tab last so we keep the order of the tabs in memory when closing a tab
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.splice(__WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.indexOf(this), 1);
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.push(this);

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + this.shortHand + "-" + this.id).removeClass("tab-active tab-flash");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#po-tabs-list a").removeClass("po-tab-current active");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + this.shortHand + "-" + this.id).addClass("po-tab-current active").blur();

    __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].currentTab = this;

    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.setPlayers(this.getPlayers());

    this.onSetCurrent();

    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].updateBadgeCount();
};

BaseTab.prototype.addTab = function(element) {
    var tab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='tab'></div>");
    //tab.append(element);

    tab.appendTo(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#tabs"));
    element.appendTo(tab);

    this.tab = tab;

    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.push(this);

    if (this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tab").removeClass("current");
        tab.addClass("current");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + this.shortHand + "-" + this.id).addClass("po-tab-current active");
    }
};


BaseTab.prototype.removeTab = function() {
    this.tab.remove();

    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.splice(__WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.indexOf(this), 1);

    if (__WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.length > 0) {
        __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs[__WEBPACK_IMPORTED_MODULE_1__frontend__["default"].tabs.length - 1].setCurrentTab();
    }

    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].updateBadgeCount();
};


BaseTab.prototype.onSetCurrent = function() {

};

BaseTab.prototype.sendMessage = function() {

};


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battletab__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony export (immutable) */ __webpack_exports__["a"] = BattleList;
/* harmony export (immutable) */ __webpack_exports__["b"] = afterLoad;






function BattleList() {
    this.ids = {};
}

var battlelist = BattleList.prototype;

battlelist.createBattleItem = function (id) {
    var battle = __WEBPACK_IMPORTED_MODULE_0__webclient__["a" /* default */].battles.battle(id);
    var name = battle.tier || "";

    var ret = "<a class='list-group-item battle-list-item' href='po:tab/battle-" + id + "' id='battle-" + id + "'>";
    ret += "<span class='glyphicon glyphicon-fire'></span>&nbsp;";
    ret += "<span class='battle-name'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* escapeHtml */])(name) + "</span>";
    ret += "<button type='button' class='close' aria-label='Close' onclick='event.stopPropagation(); event.preventDefault(); webclientUI.battles.quit(" + id + ");'><span aria-hidden='true'>&times;</span></button></a>";
    return ret;
};

battlelist.changeName = function(id, name) {
    if (this.hasBattle(id)) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#battle-' + id + ">.battle-name").text(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* escapeHtml */])(name));
    }
};

battlelist.hasBattle = function(id) {
    return id in this.ids;
};

battlelist.setSound = function(val) {
    this.sound = val;
    for (var id in this.ids) {
        this.ids[id].battle.changeSound(val);
    }
}

battlelist.addBattle = function(id) {
    var self = this;
    if (!this.hasBattle(id)) {
        this.element.append(this.createBattleItem(id));
        var battle = new __WEBPACK_IMPORTED_MODULE_3__battletab__["a" /* default */](id);
        this.ids[id] = battle;
        battle.on("changename", function(id, name) {
            self.changeName(id, name);
        });
        /* In case already received */
        if (battle.battle.tier) {
            this.changeName(id, battle.battle.tier);
        }

        if (window.isActive) {
            __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].switchToTab("battle-"+id);
        } else {
            /* DO not open it at first in order to increase badge count */
            battle.flashTab();
        }
    }
};

battlelist.quit = function(id) {
    if (this.hasBattle(id)) {
        this.element.find("#battle-" + id).remove();
        this.battle(id).close();
        __WEBPACK_IMPORTED_MODULE_0__webclient__["a" /* default */].battles.leaveBattle(id);
        delete this.ids[id];
    }
};

battlelist.battle = function(id) {
    return this.ids[id];
};

battlelist.battles = function() {
    return this.ids;
};

battlelist.startObserving = function(battles) {
    var self = this;

    battles.on("activebattle", function(id) {
        self.addBattle(id);
    });
};

function afterLoad() {
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].battles.startObserving(__WEBPACK_IMPORTED_MODULE_0__webclient__["a" /* default */].battles);
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].battles.element = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#battlelist");
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channeltab__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__postorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = ChannelList;
/* harmony export (immutable) */ __webpack_exports__["b"] = afterLoad;








function ChannelList() {
    this.ids = {};
    this.chanevents = {};
    this.channotifs = {};
}

ChannelList.prototype.createChannelItem = function (id) {
    var name = __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id);
    return "<a class='list-group-item channel-list-item' href='po:tab/channel-" + id + "' " +
        "id='channel-" + id + "'><span class='channel-name'>#" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* escapeHtml */])(name) +
        "</span><button type='button' class='close' aria-label='Close' " +
        "onclick='event.stopPropagation(); event.preventDefault(); webclient.leaveChannel(" + id + ");'>" +
        "<span aria-hidden='true'>&times;</span></button></a>";
};

ChannelList.prototype.countActive = function() {
    var cnt = 0;
    for (var id in this.ids) {
        if (__WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id).toLowerCase() in this.channotifs) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#channel-" + id).hasClass("tab-active")) {
                cnt ++;
            }
        }
    }

    return cnt;
};

ChannelList.prototype.updateChannelName = function(id) {
    if (this.hasChannel(id)) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#channel-' + id + ">.channel-name").text('#' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id)));
    }
};

ChannelList.prototype.hasChannel = function(id) {
    return id in this.ids;
};

ChannelList.prototype.addChannel = function(id) {
    console.log("Adding channel", id, "...");
    if (!this.hasChannel(id)) {
        this.element.append(this.createChannelItem(id));
        this.ids[id] = new __WEBPACK_IMPORTED_MODULE_2__channeltab__["a" /* default */](id, __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id));
    }
};

ChannelList.prototype.removeChannel = function(id) {
    if (this.hasChannel(id)) {
        this.element.find("#channel-" + id).remove();
        this.channel(id).close();
        delete this.ids[id];
    }
};

ChannelList.prototype.channel = function(id) {
    return this.ids[id];
};

ChannelList.prototype.channels = function() {
    return this.ids;
};

ChannelList.prototype.toggleChanEvents = function (id) {
    var chan = __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id).toLowerCase();
    if (chan in this.chanevents) {
        delete this.chanevents[chan];
    } else {
        this.chanevents[chan] = true;
    }

    __WEBPACK_IMPORTED_MODULE_4__postorage__["a" /* default */].set("chanevents-" + __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].serverIP, this.chanevents);
};

ChannelList.prototype.toggleChanNotifs = function (id) {
    var chan = __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id).toLowerCase();
    if (chan in this.channotifs) {
        delete this.channotifs[chan];
    } else {
        this.channotifs[chan] = true;
    }

    __WEBPACK_IMPORTED_MODULE_4__postorage__["a" /* default */].set("channotifs-" + __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].serverIP, this.channotifs);
};

ChannelList.prototype.chanEventsEnabled = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id).toLowerCase() in this.chanevents;
};

ChannelList.prototype.chanNotifsEnabled = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.name(id).toLowerCase() in this.channotifs;
};

ChannelList.prototype.startObserving = function(channels) {
    console.log("observing channel events...");

    channels.on("joinchannel", id => {
        this.addChannel(id);
    });

    channels.on("leavechannel", id => {
        this.removeChannel(id);
    });

    channels.on("changename", id => {
        this.updateChannelName(id);
    });

    channels.on("nameslist", ids => {
        for (var i in ids) {
            this.updateChannelName(ids[i]);
        }
    });
};

ChannelList.prototype.findMatches = function(query, callback) {
    //console.log(arguments);
    if (!query.startsWith("#")) {
        callback([]);
        return;
    }

    query = query.substr(1).toLowerCase();
    var matches = [];

    var names = Object.keys(__WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels.byName);
    names.sort();

    names.forEach(function(elem) {
        if (elem.toLowerCase().startsWith(query)) {
            matches.push({
                "value": "#" + elem,
                "id": elem
            });
        }
    });

    callback(matches);
};

function afterLoad() {
    __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.startObserving(__WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].channels);
    __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#channellist");

    __webpack_require__.e/* require.ensure */(2).then((() => {
        __webpack_require__(31);

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#player-filter").typeahead({
            hint: true,
            highlight: false,
            minLength: 1
        },
        {
            name: "channels",
            display: "value",
            limit: 200,
            source: __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.findMatches.bind(__WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels)
        }).on("typeahead:select", function(event, sugg) {
            __WEBPACK_IMPORTED_MODULE_1__webclient__["a" /* default */].joinChannel(sugg.id);
        });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

    __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.element.contextmenu({
        target: "#channel-context-menu",
        before: function(event/* , context */) {
            /* the name of the channel was right clicked instead of the li */
            var channel;
            if (event.target.tagName.toLowerCase() == "span") {
                channel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target.parentElement);
            } else {
                channel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target);
            }

            var id = channel.attr("id");
            id = id.substr(id.indexOf("-") + 1);
            var menu = this.getMenu();

            /* Add this once, handler of links on context menu */
            if (!menu.attr("weaned")) {
                menu.attr("weaned", true);
                menu.on("click", "a", __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].linkClickHandler);
            }

            menu.find("a").each(function() {
                this.href = this.href.substr(0, this.href.lastIndexOf("/") + 1) + id;
            });

            menu.find("#channels-chanevents-menu").find("a").text(__WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.chanEventsEnabled(id) ? "Disable channel events" : "Enable channel events");
            menu.find("#channels-channotifs-menu").find("a").text(__WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.chanNotifsEnabled(id) ? "Disable notifications" : "Enable notifications");
        },
        onItem: function(context, event) {
            event.preventDefault();
            //var item = $(event.target);
        }
    });
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
    relayIP : "b.pokegts.com",
    registry: "http://po.pokemongts.com:7070",
    relayPort : 10508,
    hostPort : 27025
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__postorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_contextmenu__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_contextmenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_contextmenu__);
/* harmony export (immutable) */ __webpack_exports__["a"] = PlayerList;
/* harmony export (immutable) */ __webpack_exports__["b"] = afterLoad;









/* The list of players */
function PlayerList() {
    this.ids = [];
    this.shown = {};
    this.filter = '';
    this.authFilter = true;
    this.showColors = false;
}

var playerlist = PlayerList.prototype;

playerlist.setFilter = function(filter) {
    if (filter.toLowerCase() == this.filter) {
        return;
    }

    this.filter = filter.toLowerCase();
    this.updatePlayers();
};

playerlist.updatePlayers = function() {
    this.setPlayers(this.ids);
};

playerlist.getCompareFunction = function() {
    if (!this.filter && !this.authFilter) {
        return function(a, b) {
            return a.localeCompare(b);
        };
    }
    var filter = this.filter;
    var authFilter = this.authFilter;
    return function(a, b, autha, authb) {
        var hasa = a.indexOf(filter) > -1;
        var hasb = b.indexOf(filter) > -1;

        if (hasa && !hasb) return -1;
        if (hasb && !hasa) return 1;

        var authDiff = 0;
        if (authFilter) {
            if (autha > 3) autha = 0;
            if (authb > 3) authb = 0;
            authDiff = authb - autha;
        }

        return authDiff || a.localeCompare(b);
    };
};

playerlist.setPlayers = function (playerIds) {
    this.shown = {};

    var html = "";

    var compareFunc = this.getCompareFunction();
    var pls = __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players;
    /* Could be optimized, but later */
    playerIds.sort(function(a, b) {
        return compareFunc(
            pls.name(a).toLowerCase(),
            pls.name(b).toLowerCase(),
            pls.auth(a), pls.auth(b));
    });

    for (var i = 0, len = playerIds.length; i < len; i += 1) {
        html += this.createPlayerItem(playerIds[i]);
    }

    this.element.html(html);
    this.ids = playerIds;

    for (var id in this.ids) {
        this.ids[id] = +this.ids[id];
    }

    this.updatePlayerCount();
};

playerlist.updatePlayerCount = function () {
    var idl = this.ids.length;
    this.count.text(idl + (idl !== 1 ? " Users" : " User"));
};

playerlist.createPlayerItem = function (id) {
    var name = __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.name(id),
        ret;

    this.shown[id] = true;

    ret = "<a href='po:info/" + id + "' class='list-group-item player-list-item player-auth-" + __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.auth(id);

    if (__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.away(id)) {
        ret += " player-away";
    }

    if (__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].battles.isBattling(id)) {
        ret += " player-battling";
    }

    if (__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.isIgnored(id)) {
        ret += " player-ignored";
    }

    ret += "' ";

    if (this.showColors) {
        ret += "style='color:" + __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.color(id) + "' ";
    }

    var fullName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* escapeHtml */])(name);
    if (this.filter) {
        fullName = fullName.replace(new RegExp("("+this.filter+")", "i"), "<b>$1</b>");
    }

    ret += "id='player-"+id+"' pid='" + id + "'>" + fullName + "</a>";
    return ret;
};

playerlist.findPos = function(id) {
    var name = __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.name(id),
        lname = name.toLowerCase(),
        auth = __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.auth(id);

    var compareFunc = this.getCompareFunction();
    return this.ids.dichotomy(function (pid) {
        return compareFunc(
            lname, __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.name(pid).toLowerCase(),
            auth, __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.auth(pid));
    });
};

playerlist.addPlayer = function (id) {
    id = +id;
    /* Find the place where to put the name - dichotomy */
    var pos = this.findPos(id);

    /* Add the graphical element */
    var item = this.createPlayerItem(id);

    var added = false;
    for (var x = pos; x < this.ids.length; x++) {
        if (this.shown[this.ids[x]]) {
            /* Inserts the item before the player at pos */
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".player-list-item#player-" + this.ids[x]).before(item);
            added = true;
            break;
        }
    }
    if (!added) {
        this.element.append(item);
    }

    // Add the id after the position
    this.ids.splice(pos, 0, id);
    this.updatePlayerCount();
};

playerlist.removePlayer = function (id) {
    delete this.shown[id];

    var pos = this.ids.indexOf(+id);
    if (pos !== -1) {
        this.ids.splice(pos, 1);
    }

    /* Remove the graphical element */
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".player-list-item#player-" + id).remove();
    this.updatePlayerCount();
};

playerlist.updatePlayer = function (id) {
    if (this.ids.indexOf(+id) !== -1) {
        this.removePlayer(id);
        this.addPlayer(id);
    }
};

function afterLoad() {
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#playerlist");
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#playercount");

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#player-filter").on("input", function() {
        let s = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
        __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.setFilter(s);

        if (s.length > 0 && s[0] != '#') {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#playerlist").scrollTop(0);
        }
    });
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.setFilter(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#player-filter").val());

    __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.on("playeradd", function(id, obj) {
        __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.updatePlayer(+id);

        if (obj.hasOwnProperty("info")) {
            __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].updateInfo(id, obj.info);
            /* In case a battle was not sharing a channel, get their name / color */
            __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].battles.updateInfo(id, obj);
        }
    }).on("playerupdated", function(id, obj) {
        __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.updatePlayer(+id);

        if (obj.hasOwnProperty("info")) {
            __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].updateInfo(id, obj.info);
        }
    });
    /* Show context menu when clicked */
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].players.element.contextmenu({
        target: "#player-context-menu",
        before: function(event/* , context */) {
            var player = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target);
            var pid = player.attr("pid");
            var menu = this.getMenu();

            if (!pid) {
                return false;
            }

            /* Add this once, handler of links on context menu */
            if (!menu.attr("weaned")) {
                menu.attr("weaned", true);
                menu.on("click", "a", __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].linkClickHandler);
            }

            menu.find("a").each(function() {
                this.href = this.href.substr(0, this.href.lastIndexOf("/") + 1) + pid;
            });

            menu.find("#player-ignore-menu").find("a").text(__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.isIgnored(pid) ? "Unignore" : "Ignore");
            menu.find("#player-idle-menu").find("a").text(__WEBPACK_IMPORTED_MODULE_3__postorage__["a" /* default */].get("player.idle", "boolean") ? "Unidle" : "Idle");

            if (__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.player(pid) != __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].ownPlayer()) {
                menu.find("#player-ignore-menu").show();
                menu.find("#player-idle-menu").hide();
            } else {
                menu.find("#player-ignore-menu").hide();
                menu.find("#player-idle-menu").show();
            }

            var ownAuth = __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].ownAuth();

            if (ownAuth > __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.auth(pid)) {
               menu.find(".divider").show();
               menu.find("#player-kick-menu").show();
               if (ownAuth >= 2) {
                    menu.find("#player-ban-menu").show();
               } else {
                    menu.find("#player-ban-menu").hide();
               }
            } else {
                menu.find(".divider").hide();
                menu.find("#player-kick-menu").hide();
                menu.find("#player-ban-menu").hide();
            }

            if (__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].battles.isBattling(pid)) {
                menu.find("#player-watch-menu").show();
            } else {
                menu.find("#player-watch-menu").hide();
            }
        },
        onItem: function(context, event) {
            event.preventDefault();
            //var item = $(event.target);
        }
    });
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = PMList;
/* harmony export (immutable) */ __webpack_exports__["b"] = afterLoad;





function PMList() {
    this.ids = {};
}

var pmlist = PMList.prototype;

pmlist.createPMItem = function (id) {
    var name = __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].pms.pm(id).name(),
        ret;

    ret = "<a class='list-group-item pm-list-item' ";
    ret += "href='po:tab/pm-" + id + "' "
    ret += "id='pm-"+id+"'><span class='glyphicon glyphicon-envelope'></span>&nbsp;" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* escapeHtml */])(name) + '<button type="button" class="close" aria-label="Close" onclick="event.stopPropagation(); event.preventDefault(); webclientUI.pms.removePM(' + id + ');"><span aria-hidden="true">&times;</span></button></a>';
    return ret;
};


pmlist.updatePMName = function(id) {
    if (this.hasPM(id)) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pm-'+id).text('#' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].pms.pm(id).name()));
    }
};

pmlist.hasPM = function(id) {
    return id in this.ids;
};

pmlist.addPM = function(id) {
    if (!this.hasPM(id)) {
        this.element.append(this.createPMItem(id));
        this.ids[id] = __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].pms.pm(id);
    }
};

pmlist.removePM = function(id) {
    if (this.hasPM(id)) {
        this.element.find("#pm-" + id).remove();
        this.pm(id).close();
        delete this.ids[id];
    }
};

pmlist.pm = function(id) {
    return this.ids[id];
};

pmlist.pms = function() {
    return this.ids;
};

pmlist.startObserving = function(pms) {
    var self = this;

    pms.on("newpm", function(id) {
        self.addPM(id);
    });

    pms.on("changename", function(id) {
        self.updateChannelName(id);
    });
};

function afterLoad() {
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].pms.startObserving(__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].pms);
    __WEBPACK_IMPORTED_MODULE_1__frontend__["default"].pms.element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pmlist");
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define */

/* ================================================
 * Make use of Bootstrap's modal more monkey-friendly.
 *
 * For Bootstrap 3.
 *
 * javanoob@hotmail.com
 *
 * https://github.com/nakupanda/bootstrap3-dialog
 *
 * Licensed under The MIT License.
 * ================================================ */
(function (root, factory) {

    "use strict";

    // CommonJS module is defined
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = factory(__webpack_require__(0), __webpack_require__(11));
    }
    // AMD module is defined
    else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
            return factory($);
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        // planted over the root!
        root.BootstrapDialog = factory(root.jQuery);
    }

}(this, function ($) {

    "use strict";

    /* ================================================
     * Definition of BootstrapDialogModal.
     * Extend Bootstrap Modal and override some functions.
     * BootstrapDialogModal === Modified Modal.
     * ================================================ */
    var Modal = $.fn.modal.Constructor;
    var BootstrapDialogModal = function (element, options) {
        Modal.call(this, element, options);
    };
    BootstrapDialogModal.getModalVersion = function () {
        var version = null;
        if (typeof $.fn.modal.Constructor.VERSION === 'undefined') {
            version = 'v3.1';
        } else if (/3\.2\.\d+/.test($.fn.modal.Constructor.VERSION)) {
            version = 'v3.2';
        } else if (/3\.3\.[1,2]/.test($.fn.modal.Constructor.VERSION)) {
            version = 'v3.3';  // v3.3.1, v3.3.2
        } else {
            version = 'v3.3.4';
        }

        return version;
    };
    BootstrapDialogModal.ORIGINAL_BODY_PADDING = parseInt(($('body').css('padding-right') || 0), 10);
    BootstrapDialogModal.METHODS_TO_OVERRIDE = {};
    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.1'] = {};
    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.2'] = {
        hide: function (e) {
            if (e) {
                e.preventDefault();
            }
            e = $.Event('hide.bs.modal');

            this.$element.trigger(e);

            if (!this.isShown || e.isDefaultPrevented()) {
                return;
            }

            this.isShown = false;

            // Remove css class 'modal-open' when the last opened dialog is closing.
            var openedDialogs = this.getGlobalOpenedDialogs();
            if (openedDialogs.length === 0) {
                this.$body.removeClass('modal-open');
            }

            this.resetScrollbar();
            this.escape();

            $(document).off('focusin.bs.modal');

            this.$element
            .removeClass('in')
            .attr('aria-hidden', true)
            .off('click.dismiss.bs.modal');

            $.support.transition && this.$element.hasClass('fade') ?
            this.$element
            .one('bsTransitionEnd', $.proxy(this.hideModal, this))
            .emulateTransitionEnd(300) :
            this.hideModal();
        }
    };
    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.3'] = {
        /**
         * Overrided.
         * 
         * @returns {undefined}
         */
        setScrollbar: function () {
            var bodyPad = BootstrapDialogModal.ORIGINAL_BODY_PADDING;
            if (this.bodyIsOverflowing) {
                this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
            }
        },
        /**
         * Overrided.
         * 
         * @returns {undefined}
         */
        resetScrollbar: function () {
            var openedDialogs = this.getGlobalOpenedDialogs();
            if (openedDialogs.length === 0) {
                this.$body.css('padding-right', BootstrapDialogModal.ORIGINAL_BODY_PADDING);
            }
        },
        /**
         * Overrided.
         * 
         * @returns {undefined}
         */
        hideModal: function () {
            this.$element.hide();
            this.backdrop($.proxy(function () {
                var openedDialogs = this.getGlobalOpenedDialogs();
                if (openedDialogs.length === 0) {
                    this.$body.removeClass('modal-open');
                }
                this.resetAdjustments();
                this.resetScrollbar();
                this.$element.trigger('hidden.bs.modal');
            }, this));
        }
    };
    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.3.4'] = $.extend({}, BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.3']);
    BootstrapDialogModal.prototype = {
        constructor: BootstrapDialogModal,
        /**
         * New function, to get the dialogs that opened by BootstrapDialog.
         * 
         * @returns {undefined}
         */
        getGlobalOpenedDialogs: function () {
            var openedDialogs = [];
            $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
                if (dialogInstance.isRealized() && dialogInstance.isOpened()) {
                    openedDialogs.push(dialogInstance);
                }
            });

            return openedDialogs;
        }
    };

    // Add compatible methods.
    BootstrapDialogModal.prototype = $.extend(BootstrapDialogModal.prototype, Modal.prototype, BootstrapDialogModal.METHODS_TO_OVERRIDE[BootstrapDialogModal.getModalVersion()]);

    /* ================================================
     * Definition of BootstrapDialog.
     * ================================================ */
    var BootstrapDialog = function (options) {
        this.defaultOptions = $.extend(true, {
            id: BootstrapDialog.newGuid(),
            buttons: [],
            data: {},
            onshow: null,
            onshown: null,
            onhide: null,
            onhidden: null
        }, BootstrapDialog.defaultOptions);
        this.indexedButtons = {};
        this.registeredButtonHotkeys = {};
        this.draggableData = {
            isMouseDown: false,
            mouseOffset: {}
        };
        this.realized = false;
        this.opened = false;
        this.initOptions(options);
        this.holdThisInstance();
    };

    BootstrapDialog.BootstrapDialogModal = BootstrapDialogModal;

    /**
     *  Some constants.
     */
    BootstrapDialog.NAMESPACE = 'bootstrap-dialog';
    BootstrapDialog.TYPE_DEFAULT = 'type-default';
    BootstrapDialog.TYPE_INFO = 'type-info';
    BootstrapDialog.TYPE_PRIMARY = 'type-primary';
    BootstrapDialog.TYPE_SUCCESS = 'type-success';
    BootstrapDialog.TYPE_WARNING = 'type-warning';
    BootstrapDialog.TYPE_DANGER = 'type-danger';
    BootstrapDialog.DEFAULT_TEXTS = {};
    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_DEFAULT] = 'Information';
    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_INFO] = 'Information';
    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_PRIMARY] = 'Information';
    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_SUCCESS] = 'Success';
    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_WARNING] = 'Warning';
    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_DANGER] = 'Danger';
    BootstrapDialog.DEFAULT_TEXTS['OK'] = 'OK';
    BootstrapDialog.DEFAULT_TEXTS['CANCEL'] = 'Cancel';
    BootstrapDialog.DEFAULT_TEXTS['CONFIRM'] = 'Confirmation';
    BootstrapDialog.SIZE_NORMAL = 'size-normal';
    BootstrapDialog.SIZE_SMALL = 'size-small';
    BootstrapDialog.SIZE_WIDE = 'size-wide';    // size-wide is equal to modal-lg
    BootstrapDialog.SIZE_LARGE = 'size-large';
    BootstrapDialog.BUTTON_SIZES = {};
    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_NORMAL] = '';
    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_SMALL] = '';
    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_WIDE] = '';
    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_LARGE] = 'btn-lg';
    BootstrapDialog.ICON_SPINNER = 'glyphicon glyphicon-asterisk';
    BootstrapDialog.BUTTONS_ORDER_CANCEL_OK = 'btns-order-cancel-ok';
    BootstrapDialog.BUTTONS_ORDER_OK_CANCEL = 'btns-order-ok-cancel';

    /**
     * Default options.
     */
    BootstrapDialog.defaultOptions = {
        type: BootstrapDialog.TYPE_PRIMARY,
        size: BootstrapDialog.SIZE_NORMAL,
        cssClass: '',
        title: null,
        message: null,
        nl2br: true,
        closable: true,
        closeByBackdrop: true,
        closeByKeyboard: true,
        closeIcon: '&#215;',
        spinicon: BootstrapDialog.ICON_SPINNER,
        autodestroy: true,
        draggable: false,
        animate: true,
        description: '',
        tabindex: -1,
        btnsOrder: BootstrapDialog.BUTTONS_ORDER_CANCEL_OK
    };

    /**
     * Config default options.
     */
    BootstrapDialog.configDefaultOptions = function (options) {
        BootstrapDialog.defaultOptions = $.extend(true, BootstrapDialog.defaultOptions, options);
    };

    /**
     * Open / Close all created dialogs all at once.
     */
    BootstrapDialog.dialogs = {};
    BootstrapDialog.openAll = function () {
        $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
            dialogInstance.open();
        });
    };
    BootstrapDialog.closeAll = function () {
        $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
            dialogInstance.close();
        });
    };

    /**
     * Get dialog instance by given id.
     * 
     * @returns dialog instance
     */
    BootstrapDialog.getDialog = function (id) {
        var dialog = null;
        if (typeof BootstrapDialog.dialogs[id] !== 'undefined') {
            dialog = BootstrapDialog.dialogs[id];
        }

        return dialog;
    };

    /**
     * Set a dialog.
     * 
     * @returns the dialog that has just been set.
     */
    BootstrapDialog.setDialog = function (dialog) {
        BootstrapDialog.dialogs[dialog.getId()] = dialog;

        return dialog;
    };

    /**
     * Alias of BootstrapDialog.setDialog(dialog)
     * 
     * @param {type} dialog
     * @returns {unresolved}
     */
    BootstrapDialog.addDialog = function (dialog) {
        return BootstrapDialog.setDialog(dialog);
    };

    /**
     * Move focus to next visible dialog.
     */
    BootstrapDialog.moveFocus = function () {
        var lastDialogInstance = null;
        $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
            if (dialogInstance.isRealized() && dialogInstance.isOpened()) {
                lastDialogInstance = dialogInstance;
            }
        });
        if (lastDialogInstance !== null) {
            lastDialogInstance.getModal().focus();
        }
    };

    BootstrapDialog.METHODS_TO_OVERRIDE = {};
    BootstrapDialog.METHODS_TO_OVERRIDE['v3.1'] = {
        handleModalBackdropEvent: function () {
            this.getModal().on('click', {dialog: this}, function (event) {
                event.target === this && event.data.dialog.isClosable() && event.data.dialog.canCloseByBackdrop() && event.data.dialog.close();
            });

            return this;
        },
        /**
         * To make multiple opened dialogs look better.
         * 
         * Will be removed in later version, after Bootstrap Modal >= 3.3.0, updating z-index is unnecessary.
         */
        updateZIndex: function () {
            if (this.isOpened()) {
                var zIndexBackdrop = 1040;
                var zIndexModal = 1050;
                var dialogCount = 0;
                $.each(BootstrapDialog.dialogs, function (dialogId, dialogInstance) {
                    if (dialogInstance.isRealized() && dialogInstance.isOpened()) {
                        dialogCount++;
                    }
                });
                var $modal = this.getModal();
                var $backdrop = $modal.data('bs.modal').$backdrop;
                $modal.css('z-index', zIndexModal + (dialogCount - 1) * 20);
                $backdrop.css('z-index', zIndexBackdrop + (dialogCount - 1) * 20);
            }

            return this;
        },
        open: function () {
            !this.isRealized() && this.realize();
            this.getModal().modal('show');
            this.updateZIndex();

            return this;
        }
    };
    BootstrapDialog.METHODS_TO_OVERRIDE['v3.2'] = {
        handleModalBackdropEvent: BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']['handleModalBackdropEvent'],
        updateZIndex: BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']['updateZIndex'],
        open: BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']['open']
    };
    BootstrapDialog.METHODS_TO_OVERRIDE['v3.3'] = {};
    BootstrapDialog.METHODS_TO_OVERRIDE['v3.3.4'] = $.extend({}, BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']);
    BootstrapDialog.prototype = {
        constructor: BootstrapDialog,
        initOptions: function (options) {
            this.options = $.extend(true, this.defaultOptions, options);

            return this;
        },
        holdThisInstance: function () {
            BootstrapDialog.addDialog(this);

            return this;
        },
        initModalStuff: function () {
            this.setModal(this.createModal())
            .setModalDialog(this.createModalDialog())
            .setModalContent(this.createModalContent())
            .setModalHeader(this.createModalHeader())
            .setModalBody(this.createModalBody())
            .setModalFooter(this.createModalFooter());

            this.getModal().append(this.getModalDialog());
            this.getModalDialog().append(this.getModalContent());
            this.getModalContent()
            .append(this.getModalHeader())
            .append(this.getModalBody())
            .append(this.getModalFooter());

            return this;
        },
        createModal: function () {
            var $modal = $('<div class="modal" role="dialog" aria-hidden="true"></div>');
            $modal.prop('id', this.getId());
            $modal.attr('aria-labelledby', this.getId() + '_title');

            return $modal;
        },
        getModal: function () {
            return this.$modal;
        },
        setModal: function ($modal) {
            this.$modal = $modal;

            return this;
        },
        createModalDialog: function () {
            return $('<div class="modal-dialog"></div>');
        },
        getModalDialog: function () {
            return this.$modalDialog;
        },
        setModalDialog: function ($modalDialog) {
            this.$modalDialog = $modalDialog;

            return this;
        },
        createModalContent: function () {
            return $('<div class="modal-content"></div>');
        },
        getModalContent: function () {
            return this.$modalContent;
        },
        setModalContent: function ($modalContent) {
            this.$modalContent = $modalContent;

            return this;
        },
        createModalHeader: function () {
            return $('<div class="modal-header"></div>');
        },
        getModalHeader: function () {
            return this.$modalHeader;
        },
        setModalHeader: function ($modalHeader) {
            this.$modalHeader = $modalHeader;

            return this;
        },
        createModalBody: function () {
            return $('<div class="modal-body"></div>');
        },
        getModalBody: function () {
            return this.$modalBody;
        },
        setModalBody: function ($modalBody) {
            this.$modalBody = $modalBody;

            return this;
        },
        createModalFooter: function () {
            return $('<div class="modal-footer"></div>');
        },
        getModalFooter: function () {
            return this.$modalFooter;
        },
        setModalFooter: function ($modalFooter) {
            this.$modalFooter = $modalFooter;

            return this;
        },
        createDynamicContent: function (rawContent) {
            var content = null;
            if (typeof rawContent === 'function') {
                content = rawContent.call(rawContent, this);
            } else {
                content = rawContent;
            }
            if (typeof content === 'string') {
                content = this.formatStringContent(content);
            }

            return content;
        },
        formatStringContent: function (content) {
            if (this.options.nl2br) {
                return content.replace(/\r\n/g, '<br />').replace(/[\r\n]/g, '<br />');
            }

            return content;
        },
        setData: function (key, value) {
            this.options.data[key] = value;

            return this;
        },
        getData: function (key) {
            return this.options.data[key];
        },
        setId: function (id) {
            this.options.id = id;

            return this;
        },
        getId: function () {
            return this.options.id;
        },
        getType: function () {
            return this.options.type;
        },
        setType: function (type) {
            this.options.type = type;
            this.updateType();

            return this;
        },
        updateType: function () {
            if (this.isRealized()) {
                var types = [BootstrapDialog.TYPE_DEFAULT,
                    BootstrapDialog.TYPE_INFO,
                    BootstrapDialog.TYPE_PRIMARY,
                    BootstrapDialog.TYPE_SUCCESS,
                    BootstrapDialog.TYPE_WARNING,
                    BootstrapDialog.TYPE_DANGER];

                this.getModal().removeClass(types.join(' ')).addClass(this.getType());
            }

            return this;
        },
        getSize: function () {
            return this.options.size;
        },
        setSize: function (size) {
            this.options.size = size;
            this.updateSize();

            return this;
        },
        updateSize: function () {
            if (this.isRealized()) {
                var dialog = this;

                // Dialog size
                this.getModal().removeClass(BootstrapDialog.SIZE_NORMAL)
                .removeClass(BootstrapDialog.SIZE_SMALL)
                .removeClass(BootstrapDialog.SIZE_WIDE)
                .removeClass(BootstrapDialog.SIZE_LARGE);
                this.getModal().addClass(this.getSize());

                // Smaller dialog.
                this.getModalDialog().removeClass('modal-sm');
                if (this.getSize() === BootstrapDialog.SIZE_SMALL) {
                    this.getModalDialog().addClass('modal-sm');
                }

                // Wider dialog.
                this.getModalDialog().removeClass('modal-lg');
                if (this.getSize() === BootstrapDialog.SIZE_WIDE) {
                    this.getModalDialog().addClass('modal-lg');
                }

                // Button size
                $.each(this.options.buttons, function (index, button) {
                    var $button = dialog.getButton(button.id);
                    var buttonSizes = ['btn-lg', 'btn-sm', 'btn-xs'];
                    var sizeClassSpecified = false;
                    if (typeof button['cssClass'] === 'string') {
                        var btnClasses = button['cssClass'].split(' ');
                        $.each(btnClasses, function (index, btnClass) {
                            if ($.inArray(btnClass, buttonSizes) !== -1) {
                                sizeClassSpecified = true;
                            }
                        });
                    }
                    if (!sizeClassSpecified) {
                        $button.removeClass(buttonSizes.join(' '));
                        $button.addClass(dialog.getButtonSize());
                    }
                });
            }

            return this;
        },
        getCssClass: function () {
            return this.options.cssClass;
        },
        setCssClass: function (cssClass) {
            this.options.cssClass = cssClass;

            return this;
        },
        getTitle: function () {
            return this.options.title;
        },
        setTitle: function (title) {
            this.options.title = title;
            this.updateTitle();

            return this;
        },
        updateTitle: function () {
            if (this.isRealized()) {
                var title = this.getTitle() !== null ? this.createDynamicContent(this.getTitle()) : this.getDefaultText();
                this.getModalHeader().find('.' + this.getNamespace('title')).html('').append(title).prop('id', this.getId() + '_title');
            }

            return this;
        },
        getMessage: function () {
            return this.options.message;
        },
        setMessage: function (message) {
            this.options.message = message;
            this.updateMessage();

            return this;
        },
        updateMessage: function () {
            if (this.isRealized()) {
                var message = this.createDynamicContent(this.getMessage());
                this.getModalBody().find('.' + this.getNamespace('message')).html('').append(message);
            }

            return this;
        },
        isClosable: function () {
            return this.options.closable;
        },
        setClosable: function (closable) {
            this.options.closable = closable;
            this.updateClosable();

            return this;
        },
        setCloseByBackdrop: function (closeByBackdrop) {
            this.options.closeByBackdrop = closeByBackdrop;

            return this;
        },
        canCloseByBackdrop: function () {
            return this.options.closeByBackdrop;
        },
        setCloseByKeyboard: function (closeByKeyboard) {
            this.options.closeByKeyboard = closeByKeyboard;

            return this;
        },
        canCloseByKeyboard: function () {
            return this.options.closeByKeyboard;
        },
        isAnimate: function () {
            return this.options.animate;
        },
        setAnimate: function (animate) {
            this.options.animate = animate;

            return this;
        },
        updateAnimate: function () {
            if (this.isRealized()) {
                this.getModal().toggleClass('fade', this.isAnimate());
            }

            return this;
        },
        getSpinicon: function () {
            return this.options.spinicon;
        },
        setSpinicon: function (spinicon) {
            this.options.spinicon = spinicon;

            return this;
        },
        addButton: function (button) {
            this.options.buttons.push(button);

            return this;
        },
        addButtons: function (buttons) {
            var that = this;
            $.each(buttons, function (index, button) {
                that.addButton(button);
            });

            return this;
        },
        getButtons: function () {
            return this.options.buttons;
        },
        setButtons: function (buttons) {
            this.options.buttons = buttons;
            this.updateButtons();

            return this;
        },
        /**
         * If there is id provided for a button option, it will be in dialog.indexedButtons list.
         *
         * In that case you can use dialog.getButton(id) to find the button.
         *
         * @param {type} id
         * @returns {undefined}
         */
        getButton: function (id) {
            if (typeof this.indexedButtons[id] !== 'undefined') {
                return this.indexedButtons[id];
            }

            return null;
        },
        getButtonSize: function () {
            if (typeof BootstrapDialog.BUTTON_SIZES[this.getSize()] !== 'undefined') {
                return BootstrapDialog.BUTTON_SIZES[this.getSize()];
            }

            return '';
        },
        updateButtons: function () {
            if (this.isRealized()) {
                if (this.getButtons().length === 0) {
                    this.getModalFooter().hide();
                } else {
                    this.getModalFooter().show().find('.' + this.getNamespace('footer')).html('').append(this.createFooterButtons());
                }
            }

            return this;
        },
        isAutodestroy: function () {
            return this.options.autodestroy;
        },
        setAutodestroy: function (autodestroy) {
            this.options.autodestroy = autodestroy;
        },
        getDescription: function () {
            return this.options.description;
        },
        setDescription: function (description) {
            this.options.description = description;

            return this;
        },
        setTabindex: function (tabindex) {
            this.options.tabindex = tabindex;

            return this;
        },
        getTabindex: function () {
            return this.options.tabindex;
        },
        updateTabindex: function () {
            if (this.isRealized()) {
                this.getModal().attr('tabindex', this.getTabindex());
            }

            return this;
        },
        getDefaultText: function () {
            return BootstrapDialog.DEFAULT_TEXTS[this.getType()];
        },
        getNamespace: function (name) {
            return BootstrapDialog.NAMESPACE + '-' + name;
        },
        createHeaderContent: function () {
            var $container = $('<div></div>');
            $container.addClass(this.getNamespace('header'));

            // title
            $container.append(this.createTitleContent());

            // Close button
            $container.prepend(this.createCloseButton());

            return $container;
        },
        createTitleContent: function () {
            var $title = $('<div></div>');
            $title.addClass(this.getNamespace('title'));

            return $title;
        },
        createCloseButton: function () {
            var $container = $('<div></div>');
            $container.addClass(this.getNamespace('close-button'));
            var $icon = $('<button class="close" aria-label="close"></button>');
            $icon.append(this.options.closeIcon);
            $container.append($icon);
            $container.on('click', {dialog: this}, function (event) {
                event.data.dialog.close();
            });

            return $container;
        },
        createBodyContent: function () {
            var $container = $('<div></div>');
            $container.addClass(this.getNamespace('body'));

            // Message
            $container.append(this.createMessageContent());

            return $container;
        },
        createMessageContent: function () {
            var $message = $('<div></div>');
            $message.addClass(this.getNamespace('message'));

            return $message;
        },
        createFooterContent: function () {
            var $container = $('<div></div>');
            $container.addClass(this.getNamespace('footer'));

            return $container;
        },
        createFooterButtons: function () {
            var that = this;
            var $container = $('<div></div>');
            $container.addClass(this.getNamespace('footer-buttons'));
            this.indexedButtons = {};
            $.each(this.options.buttons, function (index, button) {
                if (!button.id) {
                    button.id = BootstrapDialog.newGuid();
                }
                var $button = that.createButton(button);
                that.indexedButtons[button.id] = $button;
                $container.append($button);
            });

            return $container;
        },
        createButton: function (button) {
            var $button = $('<button class="btn"></button>');
            $button.prop('id', button.id);
            $button.data('button', button);

            // Icon
            if (typeof button.icon !== 'undefined' && $.trim(button.icon) !== '') {
                $button.append(this.createButtonIcon(button.icon));
            }

            // Label
            if (typeof button.label !== 'undefined') {
                $button.append(button.label);
            }

            // title
            if (typeof button.title !== 'undefined') {
                $button.attr('title',  button.title);
            }

            // Css class
            if (typeof button.cssClass !== 'undefined' && $.trim(button.cssClass) !== '') {
                $button.addClass(button.cssClass);
            } else {
                $button.addClass('btn-default');
            }

            // Data attributes
            if (typeof button.data === 'object' && button.data.constructor === {}.constructor) {
                $.each(button.data, function (key, value) {
                    $button.attr('data-' + key, value);
                });
            }

            // Hotkey
            if (typeof button.hotkey !== 'undefined') {
                this.registeredButtonHotkeys[button.hotkey] = $button;
            }

            // Button on click
            $button.on('click', {dialog: this, $button: $button, button: button}, function (event) {
                var dialog = event.data.dialog;
                var $button = event.data.$button;
                var button = $button.data('button');
                if (button.autospin) {
                    $button.toggleSpin(true);
                }
                if (typeof button.action === 'function') {
                    return button.action.call($button, dialog, event);
                }
            });

            // Dynamically add extra functions to $button
            this.enhanceButton($button);

            //Initialize enabled or not
            if (typeof button.enabled !== 'undefined') {
                $button.toggleEnable(button.enabled);
            }

            return $button;
        },
        /**
         * Dynamically add extra functions to $button
         *
         * Using '$this' to reference 'this' is just for better readability.
         *
         * @param {type} $button
         * @returns {_L13.BootstrapDialog.prototype}
         */
        enhanceButton: function ($button) {
            $button.dialog = this;

            // Enable / Disable
            $button.toggleEnable = function (enable) {
                var $this = this;
                if (typeof enable !== 'undefined') {
                    $this.prop("disabled", !enable).toggleClass('disabled', !enable);
                } else {
                    $this.prop("disabled", !$this.prop("disabled"));
                }

                return $this;
            };
            $button.enable = function () {
                var $this = this;
                $this.toggleEnable(true);

                return $this;
            };
            $button.disable = function () {
                var $this = this;
                $this.toggleEnable(false);

                return $this;
            };

            // Icon spinning, helpful for indicating ajax loading status.
            $button.toggleSpin = function (spin) {
                var $this = this;
                var dialog = $this.dialog;
                var $icon = $this.find('.' + dialog.getNamespace('button-icon'));
                if (typeof spin === 'undefined') {
                    spin = !($button.find('.icon-spin').length > 0);
                }
                if (spin) {
                    $icon.hide();
                    $button.prepend(dialog.createButtonIcon(dialog.getSpinicon()).addClass('icon-spin'));
                } else {
                    $icon.show();
                    $button.find('.icon-spin').remove();
                }

                return $this;
            };
            $button.spin = function () {
                var $this = this;
                $this.toggleSpin(true);

                return $this;
            };
            $button.stopSpin = function () {
                var $this = this;
                $this.toggleSpin(false);

                return $this;
            };

            return this;
        },
        createButtonIcon: function (icon) {
            var $icon = $('<span></span>');
            $icon.addClass(this.getNamespace('button-icon')).addClass(icon);

            return $icon;
        },
        /**
         * Invoke this only after the dialog is realized.
         *
         * @param {type} enable
         * @returns {undefined}
         */
        enableButtons: function (enable) {
            $.each(this.indexedButtons, function (id, $button) {
                $button.toggleEnable(enable);
            });

            return this;
        },
        /**
         * Invoke this only after the dialog is realized.
         *
         * @returns {undefined}
         */
        updateClosable: function () {
            if (this.isRealized()) {
                // Close button
                this.getModalHeader().find('.' + this.getNamespace('close-button')).toggle(this.isClosable());
            }

            return this;
        },
        /**
         * Set handler for modal event 'show.bs.modal'.
         * This is a setter!
         */
        onShow: function (onshow) {
            this.options.onshow = onshow;

            return this;
        },
        /**
         * Set handler for modal event 'shown.bs.modal'.
         * This is a setter!
         */
        onShown: function (onshown) {
            this.options.onshown = onshown;

            return this;
        },
        /**
         * Set handler for modal event 'hide.bs.modal'.
         * This is a setter!
         */
        onHide: function (onhide) {
            this.options.onhide = onhide;

            return this;
        },
        /**
         * Set handler for modal event 'hidden.bs.modal'.
         * This is a setter!
         */
        onHidden: function (onhidden) {
            this.options.onhidden = onhidden;

            return this;
        },
        isRealized: function () {
            return this.realized;
        },
        setRealized: function (realized) {
            this.realized = realized;

            return this;
        },
        isOpened: function () {
            return this.opened;
        },
        setOpened: function (opened) {
            this.opened = opened;

            return this;
        },
        handleModalEvents: function () {
            this.getModal().on('show.bs.modal', {dialog: this}, function (event) {
                var dialog = event.data.dialog;
                dialog.setOpened(true);
                if (dialog.isModalEvent(event) && typeof dialog.options.onshow === 'function') {
                    var openIt = dialog.options.onshow(dialog);
                    if (openIt === false) {
                        dialog.setOpened(false);
                    }

                    return openIt;
                }
            });
            this.getModal().on('shown.bs.modal', {dialog: this}, function (event) {
                var dialog = event.data.dialog;
                dialog.isModalEvent(event) && typeof dialog.options.onshown === 'function' && dialog.options.onshown(dialog);
            });
            this.getModal().on('hide.bs.modal', {dialog: this}, function (event) {
                var dialog = event.data.dialog;
                dialog.setOpened(false);
                if (dialog.isModalEvent(event) && typeof dialog.options.onhide === 'function') {
                    var hideIt = dialog.options.onhide(dialog);
                    if (hideIt === false) {
                        dialog.setOpened(true);
                    }

                    return hideIt;
                }
            });
            this.getModal().on('hidden.bs.modal', {dialog: this}, function (event) {
                var dialog = event.data.dialog;
                dialog.isModalEvent(event) && typeof dialog.options.onhidden === 'function' && dialog.options.onhidden(dialog);
                if (dialog.isAutodestroy()) {
                    dialog.setRealized(false);
                    delete BootstrapDialog.dialogs[dialog.getId()];
                    $(this).remove();
                }
                BootstrapDialog.moveFocus();
            });

            // Backdrop, I did't find a way to change bs3 backdrop option after the dialog is popped up, so here's a new wheel.
            this.handleModalBackdropEvent();

            // ESC key support
            this.getModal().on('keyup', {dialog: this}, function (event) {
                event.which === 27 && event.data.dialog.isClosable() && event.data.dialog.canCloseByKeyboard() && event.data.dialog.close();
            });

            // Button hotkey
            this.getModal().on('keyup', {dialog: this}, function (event) {
                var dialog = event.data.dialog;
                if (typeof dialog.registeredButtonHotkeys[event.which] !== 'undefined') {
                    var $button = $(dialog.registeredButtonHotkeys[event.which]);
                    !$button.prop('disabled') && $button.focus().trigger('click');
                }
            });

            return this;
        },
        handleModalBackdropEvent: function () {
            this.getModal().on('click', {dialog: this}, function (event) {
                $(event.target).hasClass('modal-backdrop') && event.data.dialog.isClosable() && event.data.dialog.canCloseByBackdrop() && event.data.dialog.close();
            });

            return this;
        },
        isModalEvent: function (event) {
            return typeof event.namespace !== 'undefined' && event.namespace === 'bs.modal';
        },
        makeModalDraggable: function () {
            if (this.options.draggable) {
                this.getModalHeader().addClass(this.getNamespace('draggable')).on('mousedown', {dialog: this}, function (event) {
                    var dialog = event.data.dialog;
                    dialog.draggableData.isMouseDown = true;
                    var dialogOffset = dialog.getModalDialog().offset();
                    dialog.draggableData.mouseOffset = {
                        top: event.clientY - dialogOffset.top,
                        left: event.clientX - dialogOffset.left
                    };
                });
                this.getModal().on('mouseup mouseleave', {dialog: this}, function (event) {
                    event.data.dialog.draggableData.isMouseDown = false;
                });
                $('body').on('mousemove', {dialog: this}, function (event) {
                    var dialog = event.data.dialog;
                    if (!dialog.draggableData.isMouseDown) {
                        return;
                    }
                    dialog.getModalDialog().offset({
                        top: event.clientY - dialog.draggableData.mouseOffset.top,
                        left: event.clientX - dialog.draggableData.mouseOffset.left
                    });
                });
            }

            return this;
        },
        realize: function () {
            this.initModalStuff();
            this.getModal().addClass(BootstrapDialog.NAMESPACE)
            .addClass(this.getCssClass());
            this.updateSize();
            if (this.getDescription()) {
                this.getModal().attr('aria-describedby', this.getDescription());
            }
            this.getModalFooter().append(this.createFooterContent());
            this.getModalHeader().append(this.createHeaderContent());
            this.getModalBody().append(this.createBodyContent());
            this.getModal().data('bs.modal', new BootstrapDialogModal(this.getModal(), {
                backdrop: 'static',
                keyboard: false,
                show: false
            }));
            this.makeModalDraggable();
            this.handleModalEvents();
            this.setRealized(true);
            this.updateButtons();
            this.updateType();
            this.updateTitle();
            this.updateMessage();
            this.updateClosable();
            this.updateAnimate();
            this.updateSize();
            this.updateTabindex();

            return this;
        },
        open: function () {
            !this.isRealized() && this.realize();
            this.getModal().modal('show');

            return this;
        },
        close: function () {
            !this.isRealized() && this.realize();
            this.getModal().modal('hide');

            return this;
        }
    };

    // Add compatible methods.
    BootstrapDialog.prototype = $.extend(BootstrapDialog.prototype, BootstrapDialog.METHODS_TO_OVERRIDE[BootstrapDialogModal.getModalVersion()]);

    /**
     * RFC4122 version 4 compliant unique id creator.
     *
     * Added by https://github.com/tufanbarisyildirim/
     *
     *  @returns {String}
     */
    BootstrapDialog.newGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    /* ================================================
     * For lazy people
     * ================================================ */

    /**
     * Shortcut function: show
     *
     * @param {type} options
     * @returns the created dialog instance
     */
    BootstrapDialog.show = function (options) {
        return new BootstrapDialog(options).open();
    };

    /**
     * Alert window
     *
     * @returns the created dialog instance
     */
    BootstrapDialog.alert = function () {
        var alertOptions = {};
        var defaultAlertOptions = {
            type: BootstrapDialog.TYPE_PRIMARY,
            title: null,
            message: null,
            closable: false,
            draggable: false,
            buttonLabel: BootstrapDialog.DEFAULT_TEXTS.OK,
            buttonHotkey: null,
            callback: null
        };

        if (typeof arguments[0] === 'object' && arguments[0].constructor === {}.constructor) {
            alertOptions = $.extend(true, defaultAlertOptions, arguments[0]);
        } else {
            alertOptions = $.extend(true, defaultAlertOptions, {
                message: arguments[0],
                callback: typeof arguments[1] !== 'undefined' ? arguments[1] : null
            });
        }

        var dialog = new BootstrapDialog(alertOptions);
        dialog.setData('callback', alertOptions.callback);
        dialog.addButton({
            label: alertOptions.buttonLabel,
            hotkey: alertOptions.buttonHotkey,
            action: function (dialog) {
                if (typeof dialog.getData('callback') === 'function' && dialog.getData('callback').call(this, true) === false) {
                    return false;
                }
                dialog.setData('btnClicked', true);

                return dialog.close();
            }
        });
        if (typeof dialog.options.onhide === 'function') {
            dialog.onHide(function (dialog) {
                var hideIt = true;
                if (!dialog.getData('btnClicked') && dialog.isClosable() && typeof dialog.getData('callback') === 'function') {
                    hideIt = dialog.getData('callback')(false);
                }
                if (hideIt === false) {
                    return false;
                }
                hideIt = this.onhide(dialog);

                return hideIt;
            }.bind({
                onhide: dialog.options.onhide
            }));
        } else {
            dialog.onHide(function (dialog) {
                var hideIt = true;
                if (!dialog.getData('btnClicked') && dialog.isClosable() && typeof dialog.getData('callback') === 'function') {
                    hideIt = dialog.getData('callback')(false);
                }

                return hideIt;
            });
        }

        return dialog.open();
    };

    /**
     * Confirm window
     *
     * @returns the created dialog instance
     */
    BootstrapDialog.confirm = function () {
        var confirmOptions = {};
        var defaultConfirmOptions = {
            type: BootstrapDialog.TYPE_PRIMARY,
            title: null,
            message: null,
            closable: false,
            draggable: false,
            btnCancelLabel: BootstrapDialog.DEFAULT_TEXTS.CANCEL,
            btnCancelClass: null,
            btnCancelHotkey: null,
            btnOKLabel: BootstrapDialog.DEFAULT_TEXTS.OK,
            btnOKClass: null,
            btnOKHotkey: null,
            btnsOrder: BootstrapDialog.defaultOptions.btnsOrder,
            callback: null
        };
        if (typeof arguments[0] === 'object' && arguments[0].constructor === {}.constructor) {
            confirmOptions = $.extend(true, defaultConfirmOptions, arguments[0]);
        } else {
            confirmOptions = $.extend(true, defaultConfirmOptions, {
                message: arguments[0],
                callback: typeof arguments[1] !== 'undefined' ? arguments[1] : null
            });
        }
        if (confirmOptions.btnOKClass === null) {
            confirmOptions.btnOKClass = ['btn', confirmOptions.type.split('-')[1]].join('-');
        }

        var dialog = new BootstrapDialog(confirmOptions);
        dialog.setData('callback', confirmOptions.callback);

        var buttons = [{
                label: confirmOptions.btnCancelLabel,
                cssClass: confirmOptions.btnCancelClass,
                hotkey: confirmOptions.btnCancelHotkey,
                action: function (dialog) {
                    if (typeof dialog.getData('callback') === 'function' && dialog.getData('callback').call(this, false) === false) {
                        return false;
                    }

                    return dialog.close();
                }
            }, {
                label: confirmOptions.btnOKLabel,
                cssClass: confirmOptions.btnOKClass,
                hotkey: confirmOptions.btnOKHotkey,
                action: function (dialog) {
                    if (typeof dialog.getData('callback') === 'function' && dialog.getData('callback').call(this, true) === false) {
                        return false;
                    }

                    return dialog.close();
                }
            }];
        if (confirmOptions.btnsOrder === BootstrapDialog.BUTTONS_ORDER_OK_CANCEL) {
            buttons.reverse();
        }
        dialog.addButtons(buttons);

        return dialog.open();

    };

    /**
     * Warning window
     *
     * @param {type} message
     * @returns the created dialog instance
     */
    BootstrapDialog.warning = function (message, callback) {
        return new BootstrapDialog({
            type: BootstrapDialog.TYPE_WARNING,
            message: message
        }).open();
    };

    /**
     * Danger window
     *
     * @param {type} message
     * @returns the created dialog instance
     */
    BootstrapDialog.danger = function (message, callback) {
        return new BootstrapDialog({
            type: BootstrapDialog.TYPE_DANGER,
            message: message
        }).open();
    };

    /**
     * Success window
     *
     * @param {type} message
     * @returns the created dialog instance
     */
    BootstrapDialog.success = function (message, callback) {
        return new BootstrapDialog({
            type: BootstrapDialog.TYPE_SUCCESS,
            message: message
        }).open();
    };

    return BootstrapDialog;

}));


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channels_channellistui__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__playerlistui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chat__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pms_pmlistui__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__battles_battlelistui__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["a"] = function() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* afterLoad */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chat__["a" /* afterLoad */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__playerlistui__["b" /* afterLoad */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__channels_channellistui__["b" /* afterLoad */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pms_pmlistui__["b" /* afterLoad */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__battles_battlelistui__["b" /* afterLoad */])();

  //Need to be last because it joins a channel, at least needs to be after channelList()
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__webclient__["b" /* afterLoad */])();
};


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/*
	Notif
*/


const notif = {
    count: -1,
    titleUpdate: function() {
        if (notif.count >= 0) {
            var x = notif.count > 9 ? 9 : notif.count;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#favicon").attr("href", "/images/favicons/favicon-"+x+".png");
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#favicon").attr("href", "/images/favicons/favicon.png");
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = notif;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Bootstrap Colorpicker v2.5.1
 * https://itsjavi.com/bootstrap-colorpicker/
 *
 * Originally written by (c) 2012 Stefan Petre
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0.txt
 *
 */

(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function(jq) {
      return (factory(jq));
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else if (jQuery && !jQuery.fn.colorpicker) {
    factory(jQuery);
  }
}(this, function($) {
  'use strict';
  /**
   * Color manipulation helper class
   *
   * @param {Object|String} [val]
   * @param {Object} [predefinedColors]
   * @param {String|null} [fallbackColor]
   * @param {String|null} [fallbackFormat]
   * @param {Boolean} [hexNumberSignPrefix]
   * @constructor
   */
  var Color = function(
    val, predefinedColors, fallbackColor, fallbackFormat, hexNumberSignPrefix) {
    this.fallbackValue = fallbackColor ?
      (
        fallbackColor && (typeof fallbackColor.h !== 'undefined') ?
        fallbackColor :
        this.value = {
          h: 0,
          s: 0,
          b: 0,
          a: 1
        }
      ) :
      null;

    this.fallbackFormat = fallbackFormat ? fallbackFormat : 'rgba';

    this.hexNumberSignPrefix = hexNumberSignPrefix === true;

    this.value = this.fallbackValue;

    this.origFormat = null; // original string format

    this.predefinedColors = predefinedColors ? predefinedColors : {};

    // We don't want to share aliases across instances so we extend new object
    this.colors = $.extend({}, Color.webColors, this.predefinedColors);

    if (val) {
      if (typeof val.h !== 'undefined') {
        this.value = val;
      } else {
        this.setColor(String(val));
      }
    }

    if (!this.value) {
      // Initial value is always black if no arguments are passed or val is empty
      this.value = {
        h: 0,
        s: 0,
        b: 0,
        a: 1
      };
    }
  };

  Color.webColors = { // 140 predefined colors from the HTML Colors spec
    "aliceblue": "f0f8ff",
    "antiquewhite": "faebd7",
    "aqua": "00ffff",
    "aquamarine": "7fffd4",
    "azure": "f0ffff",
    "beige": "f5f5dc",
    "bisque": "ffe4c4",
    "black": "000000",
    "blanchedalmond": "ffebcd",
    "blue": "0000ff",
    "blueviolet": "8a2be2",
    "brown": "a52a2a",
    "burlywood": "deb887",
    "cadetblue": "5f9ea0",
    "chartreuse": "7fff00",
    "chocolate": "d2691e",
    "coral": "ff7f50",
    "cornflowerblue": "6495ed",
    "cornsilk": "fff8dc",
    "crimson": "dc143c",
    "cyan": "00ffff",
    "darkblue": "00008b",
    "darkcyan": "008b8b",
    "darkgoldenrod": "b8860b",
    "darkgray": "a9a9a9",
    "darkgreen": "006400",
    "darkkhaki": "bdb76b",
    "darkmagenta": "8b008b",
    "darkolivegreen": "556b2f",
    "darkorange": "ff8c00",
    "darkorchid": "9932cc",
    "darkred": "8b0000",
    "darksalmon": "e9967a",
    "darkseagreen": "8fbc8f",
    "darkslateblue": "483d8b",
    "darkslategray": "2f4f4f",
    "darkturquoise": "00ced1",
    "darkviolet": "9400d3",
    "deeppink": "ff1493",
    "deepskyblue": "00bfff",
    "dimgray": "696969",
    "dodgerblue": "1e90ff",
    "firebrick": "b22222",
    "floralwhite": "fffaf0",
    "forestgreen": "228b22",
    "fuchsia": "ff00ff",
    "gainsboro": "dcdcdc",
    "ghostwhite": "f8f8ff",
    "gold": "ffd700",
    "goldenrod": "daa520",
    "gray": "808080",
    "green": "008000",
    "greenyellow": "adff2f",
    "honeydew": "f0fff0",
    "hotpink": "ff69b4",
    "indianred": "cd5c5c",
    "indigo": "4b0082",
    "ivory": "fffff0",
    "khaki": "f0e68c",
    "lavender": "e6e6fa",
    "lavenderblush": "fff0f5",
    "lawngreen": "7cfc00",
    "lemonchiffon": "fffacd",
    "lightblue": "add8e6",
    "lightcoral": "f08080",
    "lightcyan": "e0ffff",
    "lightgoldenrodyellow": "fafad2",
    "lightgrey": "d3d3d3",
    "lightgreen": "90ee90",
    "lightpink": "ffb6c1",
    "lightsalmon": "ffa07a",
    "lightseagreen": "20b2aa",
    "lightskyblue": "87cefa",
    "lightslategray": "778899",
    "lightsteelblue": "b0c4de",
    "lightyellow": "ffffe0",
    "lime": "00ff00",
    "limegreen": "32cd32",
    "linen": "faf0e6",
    "magenta": "ff00ff",
    "maroon": "800000",
    "mediumaquamarine": "66cdaa",
    "mediumblue": "0000cd",
    "mediumorchid": "ba55d3",
    "mediumpurple": "9370d8",
    "mediumseagreen": "3cb371",
    "mediumslateblue": "7b68ee",
    "mediumspringgreen": "00fa9a",
    "mediumturquoise": "48d1cc",
    "mediumvioletred": "c71585",
    "midnightblue": "191970",
    "mintcream": "f5fffa",
    "mistyrose": "ffe4e1",
    "moccasin": "ffe4b5",
    "navajowhite": "ffdead",
    "navy": "000080",
    "oldlace": "fdf5e6",
    "olive": "808000",
    "olivedrab": "6b8e23",
    "orange": "ffa500",
    "orangered": "ff4500",
    "orchid": "da70d6",
    "palegoldenrod": "eee8aa",
    "palegreen": "98fb98",
    "paleturquoise": "afeeee",
    "palevioletred": "d87093",
    "papayawhip": "ffefd5",
    "peachpuff": "ffdab9",
    "peru": "cd853f",
    "pink": "ffc0cb",
    "plum": "dda0dd",
    "powderblue": "b0e0e6",
    "purple": "800080",
    "red": "ff0000",
    "rosybrown": "bc8f8f",
    "royalblue": "4169e1",
    "saddlebrown": "8b4513",
    "salmon": "fa8072",
    "sandybrown": "f4a460",
    "seagreen": "2e8b57",
    "seashell": "fff5ee",
    "sienna": "a0522d",
    "silver": "c0c0c0",
    "skyblue": "87ceeb",
    "slateblue": "6a5acd",
    "slategray": "708090",
    "snow": "fffafa",
    "springgreen": "00ff7f",
    "steelblue": "4682b4",
    "tan": "d2b48c",
    "teal": "008080",
    "thistle": "d8bfd8",
    "tomato": "ff6347",
    "turquoise": "40e0d0",
    "violet": "ee82ee",
    "wheat": "f5deb3",
    "white": "ffffff",
    "whitesmoke": "f5f5f5",
    "yellow": "ffff00",
    "yellowgreen": "9acd32",
    "transparent": "transparent"
  };

  Color.prototype = {
    constructor: Color,
    colors: {}, // merged web and predefined colors
    predefinedColors: {},
    /**
     * @return {Object}
     */
    getValue: function() {
      return this.value;
    },
    /**
     * @param {Object} val
     */
    setValue: function(val) {
      this.value = val;
    },
    _sanitizeNumber: function(val) {
      if (typeof val === 'number') {
        return val;
      }
      if (isNaN(val) || (val === null) || (val === '') || (val === undefined)) {
        return 1;
      }
      if (val === '') {
        return 0;
      }
      if (typeof val.toLowerCase !== 'undefined') {
        if (val.match(/^\./)) {
          val = "0" + val;
        }
        return Math.ceil(parseFloat(val) * 100) / 100;
      }
      return 1;
    },
    isTransparent: function(strVal) {
      if (!strVal || !(typeof strVal === 'string' || strVal instanceof String)) {
        return false;
      }
      strVal = strVal.toLowerCase().trim();
      return (strVal === 'transparent') || (strVal.match(/#?00000000/)) || (strVal.match(/(rgba|hsla)\(0,0,0,0?\.?0\)/));
    },
    rgbaIsTransparent: function(rgba) {
      return ((rgba.r === 0) && (rgba.g === 0) && (rgba.b === 0) && (rgba.a === 0));
    },
    // parse a string to HSB
    /**
     * @protected
     * @param {String} strVal
     * @returns {boolean} Returns true if it could be parsed, false otherwise
     */
    setColor: function(strVal) {
      strVal = strVal.toLowerCase().trim();
      if (strVal) {
        if (this.isTransparent(strVal)) {
          this.value = {
            h: 0,
            s: 0,
            b: 0,
            a: 0
          };
          return true;
        } else {
          var parsedColor = this.parse(strVal);
          if (parsedColor) {
            this.value = this.value = {
              h: parsedColor.h,
              s: parsedColor.s,
              b: parsedColor.b,
              a: parsedColor.a
            };
            if (!this.origFormat) {
              this.origFormat = parsedColor.format;
            }
          } else if (this.fallbackValue) {
            // if parser fails, defaults to fallbackValue if defined, otherwise the value won't be changed
            this.value = this.fallbackValue;
          }
        }
      }
      return false;
    },
    setHue: function(h) {
      this.value.h = 1 - h;
    },
    setSaturation: function(s) {
      this.value.s = s;
    },
    setBrightness: function(b) {
      this.value.b = 1 - b;
    },
    setAlpha: function(a) {
      this.value.a = Math.round((parseInt((1 - a) * 100, 10) / 100) * 100) / 100;
    },
    toRGB: function(h, s, b, a) {
      if (arguments.length === 0) {
        h = this.value.h;
        s = this.value.s;
        b = this.value.b;
        a = this.value.a;
      }

      h *= 360;
      var R, G, B, X, C;
      h = (h % 360) / 60;
      C = b * s;
      X = C * (1 - Math.abs(h % 2 - 1));
      R = G = B = b - C;

      h = ~~h;
      R += [C, X, 0, 0, X, C][h];
      G += [X, C, C, X, 0, 0][h];
      B += [0, 0, X, C, C, X][h];

      return {
        r: Math.round(R * 255),
        g: Math.round(G * 255),
        b: Math.round(B * 255),
        a: a
      };
    },
    toHex: function(h, s, b, a) {
      if (arguments.length === 0) {
        h = this.value.h;
        s = this.value.s;
        b = this.value.b;
        a = this.value.a;
      }

      var rgb = this.toRGB(h, s, b, a);

      if (this.rgbaIsTransparent(rgb)) {
        return 'transparent';
      }

      var hexStr = (this.hexNumberSignPrefix ? '#' : '') + (
          (1 << 24) +
          (parseInt(rgb.r) << 16) +
          (parseInt(rgb.g) << 8) +
          parseInt(rgb.b))
        .toString(16)
        .slice(1);

      return hexStr;
    },
    toHSL: function(h, s, b, a) {
      if (arguments.length === 0) {
        h = this.value.h;
        s = this.value.s;
        b = this.value.b;
        a = this.value.a;
      }

      var H = h,
        L = (2 - s) * b,
        S = s * b;
      if (L > 0 && L <= 1) {
        S /= L;
      } else {
        S /= 2 - L;
      }
      L /= 2;
      if (S > 1) {
        S = 1;
      }
      return {
        h: isNaN(H) ? 0 : H,
        s: isNaN(S) ? 0 : S,
        l: isNaN(L) ? 0 : L,
        a: isNaN(a) ? 0 : a
      };
    },
    toAlias: function(r, g, b, a) {
      var c, rgb = (arguments.length === 0) ? this.toHex() : this.toHex(r, g, b, a);

      // support predef. colors in non-hex format too, as defined in the alias itself
      var original = this.origFormat === 'alias' ? rgb : this.toString(this.origFormat, false);

      for (var alias in this.colors) {
        c = this.colors[alias].toLowerCase().trim();
        if ((c === rgb) || (c === original)) {
          return alias;
        }
      }
      return false;
    },
    RGBtoHSB: function(r, g, b, a) {
      r /= 255;
      g /= 255;
      b /= 255;

      var H, S, V, C;
      V = Math.max(r, g, b);
      C = V - Math.min(r, g, b);
      H = (C === 0 ? null :
        V === r ? (g - b) / C :
        V === g ? (b - r) / C + 2 :
        (r - g) / C + 4
      );
      H = ((H + 360) % 6) * 60 / 360;
      S = C === 0 ? 0 : C / V;
      return {
        h: this._sanitizeNumber(H),
        s: S,
        b: V,
        a: this._sanitizeNumber(a)
      };
    },
    HueToRGB: function(p, q, h) {
      if (h < 0) {
        h += 1;
      } else if (h > 1) {
        h -= 1;
      }
      if ((h * 6) < 1) {
        return p + (q - p) * h * 6;
      } else if ((h * 2) < 1) {
        return q;
      } else if ((h * 3) < 2) {
        return p + (q - p) * ((2 / 3) - h) * 6;
      } else {
        return p;
      }
    },
    HSLtoRGB: function(h, s, l, a) {
      if (s < 0) {
        s = 0;
      }
      var q;
      if (l <= 0.5) {
        q = l * (1 + s);
      } else {
        q = l + s - (l * s);
      }

      var p = 2 * l - q;

      var tr = h + (1 / 3);
      var tg = h;
      var tb = h - (1 / 3);

      var r = Math.round(this.HueToRGB(p, q, tr) * 255);
      var g = Math.round(this.HueToRGB(p, q, tg) * 255);
      var b = Math.round(this.HueToRGB(p, q, tb) * 255);
      return [r, g, b, this._sanitizeNumber(a)];
    },
    /**
     * @param {String} strVal
     * @returns {Object} Object containing h,s,b,a,format properties or FALSE if failed to parse
     */
    parse: function(strVal) {
      if (arguments.length === 0) {
        return false;
      }

      var that = this,
        result = false,
        isAlias = (typeof this.colors[strVal] !== 'undefined'),
        values, format;

      if (isAlias) {
        strVal = this.colors[strVal].toLowerCase().trim();
      }

      $.each(this.stringParsers, function(i, parser) {
        var match = parser.re.exec(strVal);
        values = match && parser.parse.apply(that, [match]);
        if (values) {
          result = {};
          format = (isAlias ? 'alias' : (parser.format ? parser.format : that.getValidFallbackFormat()));
          if (format.match(/hsla?/)) {
            result = that.RGBtoHSB.apply(that, that.HSLtoRGB.apply(that, values));
          } else {
            result = that.RGBtoHSB.apply(that, values);
          }
          if (result instanceof Object) {
            result.format = format;
          }
          return false; // stop iterating
        }
        return true;
      });
      return result;
    },
    getValidFallbackFormat: function() {
      var formats = [
        'rgba', 'rgb', 'hex', 'hsla', 'hsl'
      ];
      if (this.origFormat && (formats.indexOf(this.origFormat) !== -1)) {
        return this.origFormat;
      }
      if (this.fallbackFormat && (formats.indexOf(this.fallbackFormat) !== -1)) {
        return this.fallbackFormat;
      }

      return 'rgba'; // By default, return a format that will not lose the alpha info
    },
    /**
     *
     * @param {string} [format] (default: rgba)
     * @param {boolean} [translateAlias] Return real color for pre-defined (non-standard) aliases (default: false)
     * @returns {String}
     */
    toString: function(format, translateAlias) {
      format = format || this.origFormat || this.fallbackFormat;
      translateAlias = translateAlias || false;

      var c = false;

      switch (format) {
        case 'rgb':
          {
            c = this.toRGB();
            if (this.rgbaIsTransparent(c)) {
              return 'transparent';
            }
            return 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')';
          }
          break;
        case 'rgba':
          {
            c = this.toRGB();
            return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + c.a + ')';
          }
          break;
        case 'hsl':
          {
            c = this.toHSL();
            return 'hsl(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%)';
          }
          break;
        case 'hsla':
          {
            c = this.toHSL();
            return 'hsla(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%,' + c.a + ')';
          }
          break;
        case 'hex':
          {
            return this.toHex();
          }
          break;
        case 'alias':
          {
            c = this.toAlias();

            if (c === false) {
              return this.toString(this.getValidFallbackFormat());
            }

            if (translateAlias && !(c in Color.webColors) && (c in this.predefinedColors)) {
              return this.predefinedColors[c];
            }

            return c;
          }
        default:
          {
            return c;
          }
          break;
      }
    },
    // a set of RE's that can match strings and generate color tuples.
    // from John Resig color plugin
    // https://github.com/jquery/jquery-color/
    stringParsers: [{
      re: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,
      format: 'rgb',
      parse: function(execResult) {
        return [
          execResult[1],
          execResult[2],
          execResult[3],
          1
        ];
      }
    }, {
      re: /rgb\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,
      format: 'rgb',
      parse: function(execResult) {
        return [
          2.55 * execResult[1],
          2.55 * execResult[2],
          2.55 * execResult[3],
          1
        ];
      }
    }, {
      re: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
      format: 'rgba',
      parse: function(execResult) {
        return [
          execResult[1],
          execResult[2],
          execResult[3],
          execResult[4]
        ];
      }
    }, {
      re: /rgba\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
      format: 'rgba',
      parse: function(execResult) {
        return [
          2.55 * execResult[1],
          2.55 * execResult[2],
          2.55 * execResult[3],
          execResult[4]
        ];
      }
    }, {
      re: /hsl\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,
      format: 'hsl',
      parse: function(execResult) {
        return [
          execResult[1] / 360,
          execResult[2] / 100,
          execResult[3] / 100,
          execResult[4]
        ];
      }
    }, {
      re: /hsla\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
      format: 'hsla',
      parse: function(execResult) {
        return [
          execResult[1] / 360,
          execResult[2] / 100,
          execResult[3] / 100,
          execResult[4]
        ];
      }
    }, {
      re: /#?([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
      format: 'hex',
      parse: function(execResult) {
        return [
          parseInt(execResult[1], 16),
          parseInt(execResult[2], 16),
          parseInt(execResult[3], 16),
          1
        ];
      }
    }, {
      re: /#?([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
      format: 'hex',
      parse: function(execResult) {
        return [
          parseInt(execResult[1] + execResult[1], 16),
          parseInt(execResult[2] + execResult[2], 16),
          parseInt(execResult[3] + execResult[3], 16),
          1
        ];
      }
    }],
    colorNameToHex: function(name) {
      if (typeof this.colors[name.toLowerCase()] !== 'undefined') {
        return this.colors[name.toLowerCase()];
      }
      return false;
    }
  };

  /*
   * Default plugin options
   */
  var defaults = {
    horizontal: false, // horizontal mode layout ?
    inline: false, //forces to show the colorpicker as an inline element
    color: false, //forces a color
    format: false, //forces a format
    input: 'input', // children input selector
    container: false, // container selector
    component: '.add-on, .input-group-addon', // children component selector
    fallbackColor: false, // fallback color value. null = keeps current color.
    fallbackFormat: 'hex', // fallback color format
    hexNumberSignPrefix: true, // put a '#' (number sign) before hex strings
    sliders: {
      saturation: {
        maxLeft: 100,
        maxTop: 100,
        callLeft: 'setSaturation',
        callTop: 'setBrightness'
      },
      hue: {
        maxLeft: 0,
        maxTop: 100,
        callLeft: false,
        callTop: 'setHue'
      },
      alpha: {
        maxLeft: 0,
        maxTop: 100,
        callLeft: false,
        callTop: 'setAlpha'
      }
    },
    slidersHorz: {
      saturation: {
        maxLeft: 100,
        maxTop: 100,
        callLeft: 'setSaturation',
        callTop: 'setBrightness'
      },
      hue: {
        maxLeft: 100,
        maxTop: 0,
        callLeft: 'setHue',
        callTop: false
      },
      alpha: {
        maxLeft: 100,
        maxTop: 0,
        callLeft: 'setAlpha',
        callTop: false
      }
    },
    template: '<div class="colorpicker dropdown-menu">' +
      '<div class="colorpicker-saturation"><i><b></b></i></div>' +
      '<div class="colorpicker-hue"><i></i></div>' +
      '<div class="colorpicker-alpha"><i></i></div>' +
      '<div class="colorpicker-color"><div /></div>' +
      '<div class="colorpicker-selectors"></div>' +
      '</div>',
    align: 'right',
    customClass: null, // custom class added to the colorpicker element
    colorSelectors: null // custom color aliases
  };

  /**
   * Colorpicker component class
   *
   * @param {Object|String} element
   * @param {Object} options
   * @constructor
   */
  var Colorpicker = function(element, options) {
    this.element = $(element).addClass('colorpicker-element');
    this.options = $.extend(true, {}, defaults, this.element.data(), options);
    this.component = this.options.component;
    this.component = (this.component !== false) ? this.element.find(this.component) : false;
    if (this.component && (this.component.length === 0)) {
      this.component = false;
    }
    this.container = (this.options.container === true) ? this.element : this.options.container;
    this.container = (this.container !== false) ? $(this.container) : false;

    // Is the element an input? Should we search inside for any input?
    this.input = this.element.is('input') ? this.element : (this.options.input ?
      this.element.find(this.options.input) : false);
    if (this.input && (this.input.length === 0)) {
      this.input = false;
    }
    // Set HSB color
    this.color = this.createColor(this.options.color !== false ? this.options.color : this.getValue());

    this.format = this.options.format !== false ? this.options.format : this.color.origFormat;

    if (this.options.color !== false) {
      this.updateInput(this.color);
      this.updateData(this.color);
    }

    // Setup picker
    var $picker = this.picker = $(this.options.template);
    if (this.options.customClass) {
      $picker.addClass(this.options.customClass);
    }
    if (this.options.inline) {
      $picker.addClass('colorpicker-inline colorpicker-visible');
    } else {
      $picker.addClass('colorpicker-hidden');
    }
    if (this.options.horizontal) {
      $picker.addClass('colorpicker-horizontal');
    }
    if (
      (['rgba', 'hsla', 'alias'].indexOf(this.format) !== -1) ||
      this.options.format === false ||
      this.getValue() === 'transparent'
    ) {
      $picker.addClass('colorpicker-with-alpha');
    }
    if (this.options.align === 'right') {
      $picker.addClass('colorpicker-right');
    }
    if (this.options.inline === true) {
      $picker.addClass('colorpicker-no-arrow');
    }
    if (this.options.colorSelectors) {
      var colorpicker = this,
        selectorsContainer = colorpicker.picker.find('.colorpicker-selectors');

      if (selectorsContainer.length > 0) {
        $.each(this.options.colorSelectors, function(name, color) {
          var $btn = $('<i />')
            .addClass('colorpicker-selectors-color')
            .css('background-color', color)
            .data('class', name).data('alias', name);

          $btn.on('mousedown.colorpicker touchstart.colorpicker', function(event) {
            event.preventDefault();
            colorpicker.setValue(
              colorpicker.format === 'alias' ? $(this).data('alias') : $(this).css('background-color')
            );
          });
          selectorsContainer.append($btn);
        });
        selectorsContainer.show().addClass('colorpicker-visible');
      }
    }

    // Prevent closing the colorpicker when clicking on itself
    $picker.on('mousedown.colorpicker touchstart.colorpicker', $.proxy(function(e) {
      if (e.target === e.currentTarget) {
        e.preventDefault();
      }
    }, this));

    // Bind click/tap events on the sliders
    $picker.find('.colorpicker-saturation, .colorpicker-hue, .colorpicker-alpha')
      .on('mousedown.colorpicker touchstart.colorpicker', $.proxy(this.mousedown, this));

    $picker.appendTo(this.container ? this.container : $('body'));

    // Bind other events
    if (this.input !== false) {
      this.input.on({
        'keyup.colorpicker': $.proxy(this.keyup, this)
      });
      this.input.on({
        'change.colorpicker': $.proxy(this.change, this)
      });
      if (this.component === false) {
        this.element.on({
          'focus.colorpicker': $.proxy(this.show, this)
        });
      }
      if (this.options.inline === false) {
        this.element.on({
          'focusout.colorpicker': $.proxy(this.hide, this)
        });
      }
    }

    if (this.component !== false) {
      this.component.on({
        'click.colorpicker': $.proxy(this.show, this)
      });
    }

    if ((this.input === false) && (this.component === false)) {
      this.element.on({
        'click.colorpicker': $.proxy(this.show, this)
      });
    }

    // for HTML5 input[type='color']
    if ((this.input !== false) && (this.component !== false) && (this.input.attr('type') === 'color')) {

      this.input.on({
        'click.colorpicker': $.proxy(this.show, this),
        'focus.colorpicker': $.proxy(this.show, this)
      });
    }
    this.update();

    $($.proxy(function() {
      this.element.trigger('create');
    }, this));
  };

  Colorpicker.Color = Color;

  Colorpicker.prototype = {
    constructor: Colorpicker,
    destroy: function() {
      this.picker.remove();
      this.element.removeData('colorpicker', 'color').off('.colorpicker');
      if (this.input !== false) {
        this.input.off('.colorpicker');
      }
      if (this.component !== false) {
        this.component.off('.colorpicker');
      }
      this.element.removeClass('colorpicker-element');
      this.element.trigger({
        type: 'destroy'
      });
    },
    reposition: function() {
      if (this.options.inline !== false || this.options.container) {
        return false;
      }
      var type = this.container && this.container[0] !== window.document.body ? 'position' : 'offset';
      var element = this.component || this.element;
      var offset = element[type]();
      if (this.options.align === 'right') {
        offset.left -= this.picker.outerWidth() - element.outerWidth();
      }
      this.picker.css({
        top: offset.top + element.outerHeight(),
        left: offset.left
      });
    },
    show: function(e) {
      if (this.isDisabled()) {
        // Don't show the widget if it's disabled (the input)
        return;
      }
      this.picker.addClass('colorpicker-visible').removeClass('colorpicker-hidden');
      this.reposition();
      $(window).on('resize.colorpicker', $.proxy(this.reposition, this));
      if (e && (!this.hasInput() || this.input.attr('type') === 'color')) {
        if (e.stopPropagation && e.preventDefault) {
          e.stopPropagation();
          e.preventDefault();
        }
      }
      if ((this.component || !this.input) && (this.options.inline === false)) {
        $(window.document).on({
          'mousedown.colorpicker': $.proxy(this.hide, this)
        });
      }
      this.element.trigger({
        type: 'showPicker',
        color: this.color
      });
    },
    hide: function(e) {
      if ((typeof e !== 'undefined') && e.target) {
        // Prevent hide if triggered by an event and an element inside the colorpicker has been clicked/touched
        if (
          $(e.currentTarget).parents('.colorpicker').length > 0 ||
          $(e.target).parents('.colorpicker').length > 0
        ) {
          return false;
        }
      }
      this.picker.addClass('colorpicker-hidden').removeClass('colorpicker-visible');
      $(window).off('resize.colorpicker', this.reposition);
      $(window.document).off({
        'mousedown.colorpicker': this.hide
      });
      this.update();
      this.element.trigger({
        type: 'hidePicker',
        color: this.color
      });
    },
    updateData: function(val) {
      val = val || this.color.toString(this.format, false);
      this.element.data('color', val);
      return val;
    },
    updateInput: function(val) {
      val = val || this.color.toString(this.format, false);
      if (this.input !== false) {
        this.input.prop('value', val);
        this.input.trigger('change');
      }
      return val;
    },
    updatePicker: function(val) {
      if (typeof val !== 'undefined') {
        this.color = this.createColor(val);
      }
      var sl = (this.options.horizontal === false) ? this.options.sliders : this.options.slidersHorz;
      var icns = this.picker.find('i');
      if (icns.length === 0) {
        return;
      }
      if (this.options.horizontal === false) {
        sl = this.options.sliders;
        icns.eq(1).css('top', sl.hue.maxTop * (1 - this.color.value.h)).end()
          .eq(2).css('top', sl.alpha.maxTop * (1 - this.color.value.a));
      } else {
        sl = this.options.slidersHorz;
        icns.eq(1).css('left', sl.hue.maxLeft * (1 - this.color.value.h)).end()
          .eq(2).css('left', sl.alpha.maxLeft * (1 - this.color.value.a));
      }
      icns.eq(0).css({
        'top': sl.saturation.maxTop - this.color.value.b * sl.saturation.maxTop,
        'left': this.color.value.s * sl.saturation.maxLeft
      });

      this.picker.find('.colorpicker-saturation')
        .css('backgroundColor', (this.options.hexNumberSignPrefix ? '' : '#') + this.color.toHex(this.color.value.h, 1, 1, 1));

      this.picker.find('.colorpicker-alpha')
        .css('backgroundColor', (this.options.hexNumberSignPrefix ? '' : '#') + this.color.toHex());

      this.picker.find('.colorpicker-color, .colorpicker-color div')
        .css('backgroundColor', this.color.toString(this.format, true));

      return val;
    },
    updateComponent: function(val) {
      var color;

      if (typeof val !== 'undefined') {
        color = this.createColor(val);
      } else {
        color = this.color;
      }

      if (this.component !== false) {
        var icn = this.component.find('i').eq(0);
        if (icn.length > 0) {
          icn.css({
            'backgroundColor': color.toString(this.format, true)
          });
        } else {
          this.component.css({
            'backgroundColor': color.toString(this.format, true)
          });
        }
      }

      return color.toString(this.format, false);
    },
    update: function(force) {
      var val;
      if ((this.getValue(false) !== false) || (force === true)) {
        // Update input/data only if the current value is not empty
        val = this.updateComponent();
        this.updateInput(val);
        this.updateData(val);
        this.updatePicker(); // only update picker if value is not empty
      }
      return val;

    },
    setValue: function(val) { // set color manually
      this.color = this.createColor(val);
      this.update(true);
      this.element.trigger({
        type: 'changeColor',
        color: this.color,
        value: val
      });
    },
    /**
     * Creates a new color using the instance options
     * @protected
     * @param {String} val
     * @returns {Color}
     */
    createColor: function(val) {
      return new Color(
        val ? val : null,
        this.options.colorSelectors,
        this.options.fallbackColor ? this.options.fallbackColor : this.color,
        this.options.fallbackFormat,
        this.options.hexNumberSignPrefix
      );
    },
    getValue: function(defaultValue) {
      defaultValue = (typeof defaultValue === 'undefined') ? this.options.fallbackColor : defaultValue;
      var val;
      if (this.hasInput()) {
        val = this.input.val();
      } else {
        val = this.element.data('color');
      }
      if ((val === undefined) || (val === '') || (val === null)) {
        // if not defined or empty, return default
        val = defaultValue;
      }
      return val;
    },
    hasInput: function() {
      return (this.input !== false);
    },
    isDisabled: function() {
      if (this.hasInput()) {
        return (this.input.prop('disabled') === true);
      }
      return false;
    },
    disable: function() {
      if (this.hasInput()) {
        this.input.prop('disabled', true);
        this.element.trigger({
          type: 'disable',
          color: this.color,
          value: this.getValue()
        });
        return true;
      }
      return false;
    },
    enable: function() {
      if (this.hasInput()) {
        this.input.prop('disabled', false);
        this.element.trigger({
          type: 'enable',
          color: this.color,
          value: this.getValue()
        });
        return true;
      }
      return false;
    },
    currentSlider: null,
    mousePointer: {
      left: 0,
      top: 0
    },
    mousedown: function(e) {
      if (!e.pageX && !e.pageY && e.originalEvent && e.originalEvent.touches) {
        e.pageX = e.originalEvent.touches[0].pageX;
        e.pageY = e.originalEvent.touches[0].pageY;
      }
      e.stopPropagation();
      e.preventDefault();

      var target = $(e.target);

      //detect the slider and set the limits and callbacks
      var zone = target.closest('div');
      var sl = this.options.horizontal ? this.options.slidersHorz : this.options.sliders;
      if (!zone.is('.colorpicker')) {
        if (zone.is('.colorpicker-saturation')) {
          this.currentSlider = $.extend({}, sl.saturation);
        } else if (zone.is('.colorpicker-hue')) {
          this.currentSlider = $.extend({}, sl.hue);
        } else if (zone.is('.colorpicker-alpha')) {
          this.currentSlider = $.extend({}, sl.alpha);
        } else {
          return false;
        }
        var offset = zone.offset();
        //reference to guide's style
        this.currentSlider.guide = zone.find('i')[0].style;
        this.currentSlider.left = e.pageX - offset.left;
        this.currentSlider.top = e.pageY - offset.top;
        this.mousePointer = {
          left: e.pageX,
          top: e.pageY
        };
        //trigger mousemove to move the guide to the current position
        $(window.document).on({
          'mousemove.colorpicker': $.proxy(this.mousemove, this),
          'touchmove.colorpicker': $.proxy(this.mousemove, this),
          'mouseup.colorpicker': $.proxy(this.mouseup, this),
          'touchend.colorpicker': $.proxy(this.mouseup, this)
        }).trigger('mousemove');
      }
      return false;
    },
    mousemove: function(e) {
      if (!e.pageX && !e.pageY && e.originalEvent && e.originalEvent.touches) {
        e.pageX = e.originalEvent.touches[0].pageX;
        e.pageY = e.originalEvent.touches[0].pageY;
      }
      e.stopPropagation();
      e.preventDefault();
      var left = Math.max(
        0,
        Math.min(
          this.currentSlider.maxLeft,
          this.currentSlider.left + ((e.pageX || this.mousePointer.left) - this.mousePointer.left)
        )
      );
      var top = Math.max(
        0,
        Math.min(
          this.currentSlider.maxTop,
          this.currentSlider.top + ((e.pageY || this.mousePointer.top) - this.mousePointer.top)
        )
      );
      this.currentSlider.guide.left = left + 'px';
      this.currentSlider.guide.top = top + 'px';
      if (this.currentSlider.callLeft) {
        this.color[this.currentSlider.callLeft].call(this.color, left / this.currentSlider.maxLeft);
      }
      if (this.currentSlider.callTop) {
        this.color[this.currentSlider.callTop].call(this.color, top / this.currentSlider.maxTop);
      }
      // Change format dynamically
      // Only occurs if user choose the dynamic format by
      // setting option format to false
      if (
        this.options.format === false &&
        (this.currentSlider.callTop === 'setAlpha' ||
          this.currentSlider.callLeft === 'setAlpha')
      ) {

        // Converting from hex / rgb to rgba
        if (this.color.value.a !== 1) {
          this.format = 'rgba';
          this.color.origFormat = 'rgba';
        }

        // Converting from rgba to hex
        else {
          this.format = 'hex';
          this.color.origFormat = 'hex';
        }
      }
      this.update(true);

      this.element.trigger({
        type: 'changeColor',
        color: this.color
      });
      return false;
    },
    mouseup: function(e) {
      e.stopPropagation();
      e.preventDefault();
      $(window.document).off({
        'mousemove.colorpicker': this.mousemove,
        'touchmove.colorpicker': this.mousemove,
        'mouseup.colorpicker': this.mouseup,
        'touchend.colorpicker': this.mouseup
      });
      return false;
    },
    change: function(e) {
      this.keyup(e);
    },
    keyup: function(e) {
      if ((e.keyCode === 38)) {
        if (this.color.value.a < 1) {
          this.color.value.a = Math.round((this.color.value.a + 0.01) * 100) / 100;
        }
        this.update(true);
      } else if ((e.keyCode === 40)) {
        if (this.color.value.a > 0) {
          this.color.value.a = Math.round((this.color.value.a - 0.01) * 100) / 100;
        }
        this.update(true);
      } else {
        this.color = this.createColor(this.input.val());
        // Change format dynamically
        // Only occurs if user choose the dynamic format by
        // setting option format to false
        if (this.color.origFormat && this.options.format === false) {
          this.format = this.color.origFormat;
        }
        if (this.getValue(false) !== false) {
          this.updateData();
          this.updateComponent();
          this.updatePicker();
        }
      }
      this.element.trigger({
        type: 'changeColor',
        color: this.color,
        value: this.input.val()
      });
    }
  };

  $.colorpicker = Colorpicker;

  $.fn.colorpicker = function(option) {
    var apiArgs = Array.prototype.slice.call(arguments, 1),
      isSingleElement = (this.length === 1),
      returnValue = null;

    var $jq = this.each(function() {
      var $this = $(this),
        inst = $this.data('colorpicker'),
        options = ((typeof option === 'object') ? option : {});

      if (!inst) {
        inst = new Colorpicker(this, options);
        $this.data('colorpicker', inst);
      }

      if (typeof option === 'string') {
        if ($.isFunction(inst[option])) {
          returnValue = inst[option].apply(inst, apiArgs);
        } else { // its a property ?
          if (apiArgs.length) {
            // set property
            inst[option] = apiArgs[0];
          }
          returnValue = inst[option];
        }
      } else {
        returnValue = $this;
      }
    });
    return isSingleElement ? returnValue : $jq;
  };

  $.fn.colorpicker.constructor = Colorpicker;

}));


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.vexDialog = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){

/**
 * Expose `parse`.
 */

module.exports = parse;

/**
 * Tests for browser support.
 */

var innerHTMLBug = false;
var bugTestDiv;
if (typeof document !== 'undefined') {
  bugTestDiv = document.createElement('div');
  // Setup
  bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
  // Make sure that link elements get serialized correctly by innerHTML
  // This requires a wrapper element in IE
  innerHTMLBug = !bugTestDiv.getElementsByTagName('link').length;
  bugTestDiv = undefined;
}

/**
 * Wrap map from jquery.
 */

var map = {
  legend: [1, '<fieldset>', '</fieldset>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  // for script/link/style tags to work in IE6-8, you have to wrap
  // in a div with a non-whitespace character in front, ha!
  _default: innerHTMLBug ? [1, 'X<div>', '</div>'] : [0, '', '']
};

map.td =
map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

map.option =
map.optgroup = [1, '<select multiple="multiple">', '</select>'];

map.thead =
map.tbody =
map.colgroup =
map.caption =
map.tfoot = [1, '<table>', '</table>'];

map.polyline =
map.ellipse =
map.polygon =
map.circle =
map.text =
map.line =
map.path =
map.rect =
map.g = [1, '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">','</svg>'];

/**
 * Parse `html` and return a DOM Node instance, which could be a TextNode,
 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
 * instance, depending on the contents of the `html` string.
 *
 * @param {String} html - HTML string to "domify"
 * @param {Document} doc - The `document` instance to create the Node for
 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
 * @api private
 */

function parse(html, doc) {
  if ('string' != typeof html) throw new TypeError('String expected');

  // default to the global `document` object
  if (!doc) doc = document;

  // tag name
  var m = /<([\w:]+)/.exec(html);
  if (!m) return doc.createTextNode(html);

  html = html.replace(/^\s+|\s+$/g, ''); // Remove leading/trailing whitespace

  var tag = m[1];

  // body support
  if (tag == 'body') {
    var el = doc.createElement('html');
    el.innerHTML = html;
    return el.removeChild(el.lastChild);
  }

  // wrap map
  var wrap = map[tag] || map._default;
  var depth = wrap[0];
  var prefix = wrap[1];
  var suffix = wrap[2];
  var el = doc.createElement('div');
  el.innerHTML = prefix + html + suffix;
  while (depth--) el = el.lastChild;

  // one element
  if (el.firstChild == el.lastChild) {
    return el.removeChild(el.firstChild);
  }

  // several elements
  var fragment = doc.createDocumentFragment();
  while (el.firstChild) {
    fragment.appendChild(el.removeChild(el.firstChild));
  }

  return fragment;
}

},{}],2:[function(require,module,exports){
// get successful control from form and assemble into object
// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2

// types which indicate a submit action and are not successful controls
// these will be ignored
var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;

// node names which could be successful controls
var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;

// Matches bracket notation.
var brackets = /(\[[^\[\]]*\])/g;

// serializes form fields
// @param form MUST be an HTMLForm element
// @param options is an optional argument to configure the serialization. Default output
// with no options specified is a url encoded string
//    - hash: [true | false] Configure the output type. If true, the output will
//    be a js object.
//    - serializer: [function] Optional serializer function to override the default one.
//    The function takes 3 arguments (result, key, value) and should return new result
//    hash and url encoded str serializers are provided with this module
//    - disabled: [true | false]. If true serialize disabled fields.
//    - empty: [true | false]. If true serialize empty fields
function serialize(form, options) {
    if (typeof options != 'object') {
        options = { hash: !!options };
    }
    else if (options.hash === undefined) {
        options.hash = true;
    }

    var result = (options.hash) ? {} : '';
    var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);

    var elements = form && form.elements ? form.elements : [];

    //Object store each radio and set if it's empty or not
    var radio_store = Object.create(null);

    for (var i=0 ; i<elements.length ; ++i) {
        var element = elements[i];

        // ingore disabled fields
        if ((!options.disabled && element.disabled) || !element.name) {
            continue;
        }
        // ignore anyhting that is not considered a success field
        if (!k_r_success_contrls.test(element.nodeName) ||
            k_r_submitter.test(element.type)) {
            continue;
        }

        var key = element.name;
        var val = element.value;

        // we can't just use element.value for checkboxes cause some browsers lie to us
        // they say "on" for value when the box isn't checked
        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
            val = undefined;
        }

        // If we want empty elements
        if (options.empty) {
            // for checkbox
            if (element.type === 'checkbox' && !element.checked) {
                val = '';
            }

            // for radio
            if (element.type === 'radio') {
                if (!radio_store[element.name] && !element.checked) {
                    radio_store[element.name] = false;
                }
                else if (element.checked) {
                    radio_store[element.name] = true;
                }
            }

            // if options empty is true, continue only if its radio
            if (!val && element.type == 'radio') {
                continue;
            }
        }
        else {
            // value-less fields are ignored unless options.empty is true
            if (!val) {
                continue;
            }
        }

        // multi select boxes
        if (element.type === 'select-multiple') {
            val = [];

            var selectOptions = element.options;
            var isSelectedOptions = false;
            for (var j=0 ; j<selectOptions.length ; ++j) {
                var option = selectOptions[j];
                var allowedEmpty = options.empty && !option.value;
                var hasValue = (option.value || allowedEmpty);
                if (option.selected && hasValue) {
                    isSelectedOptions = true;

                    // If using a hash serializer be sure to add the
                    // correct notation for an array in the multi-select
                    // context. Here the name attribute on the select element
                    // might be missing the trailing bracket pair. Both names
                    // "foo" and "foo[]" should be arrays.
                    if (options.hash && key.slice(key.length - 2) !== '[]') {
                        result = serializer(result, key + '[]', option.value);
                    }
                    else {
                        result = serializer(result, key, option.value);
                    }
                }
            }

            // Serialize if no selected options and options.empty is true
            if (!isSelectedOptions && options.empty) {
                result = serializer(result, key, '');
            }

            continue;
        }

        result = serializer(result, key, val);
    }

    // Check for all empty radio buttons and serialize them with key=""
    if (options.empty) {
        for (var key in radio_store) {
            if (!radio_store[key]) {
                result = serializer(result, key, '');
            }
        }
    }

    return result;
}

function parse_keys(string) {
    var keys = [];
    var prefix = /^([^\[\]]*)/;
    var children = new RegExp(brackets);
    var match = prefix.exec(string);

    if (match[1]) {
        keys.push(match[1]);
    }

    while ((match = children.exec(string)) !== null) {
        keys.push(match[1]);
    }

    return keys;
}

function hash_assign(result, keys, value) {
    if (keys.length === 0) {
        result = value;
        return result;
    }

    var key = keys.shift();
    var between = key.match(/^\[(.+?)\]$/);

    if (key === '[]') {
        result = result || [];

        if (Array.isArray(result)) {
            result.push(hash_assign(null, keys, value));
        }
        else {
            // This might be the result of bad name attributes like "[][foo]",
            // in this case the original `result` object will already be
            // assigned to an object literal. Rather than coerce the object to
            // an array, or cause an exception the attribute "_values" is
            // assigned as an array.
            result._values = result._values || [];
            result._values.push(hash_assign(null, keys, value));
        }

        return result;
    }

    // Key is an attribute name and can be assigned directly.
    if (!between) {
        result[key] = hash_assign(result[key], keys, value);
    }
    else {
        var string = between[1];
        // +var converts the variable into a number
        // better than parseInt because it doesn't truncate away trailing
        // letters and actually fails if whole thing is not a number
        var index = +string;

        // If the characters between the brackets is not a number it is an
        // attribute name and can be assigned directly.
        if (isNaN(index)) {
            result = result || {};
            result[string] = hash_assign(result[string], keys, value);
        }
        else {
            result = result || [];
            result[index] = hash_assign(result[index], keys, value);
        }
    }

    return result;
}

// Object/hash encoding serializer.
function hash_serializer(result, key, value) {
    var matches = key.match(brackets);

    // Has brackets? Use the recursive assignment function to walk the keys,
    // construct any missing objects in the result tree and make the assignment
    // at the end of the chain.
    if (matches) {
        var keys = parse_keys(key);
        hash_assign(result, keys, value);
    }
    else {
        // Non bracket notation can make assignments directly.
        var existing = result[key];

        // If the value has been assigned already (for instance when a radio and
        // a checkbox have the same name attribute) convert the previous value
        // into an array before pushing into it.
        //
        // NOTE: If this requirement were removed all hash creation and
        // assignment could go through `hash_assign`.
        if (existing) {
            if (!Array.isArray(existing)) {
                result[key] = [ existing ];
            }

            result[key].push(value);
        }
        else {
            result[key] = value;
        }
    }

    return result;
}

// urlform encoding serializer
function str_serialize(result, key, value) {
    // encode newlines as \r\n cause the html spec says so
    value = value.replace(/(\r)?\n/g, '\r\n');
    value = encodeURIComponent(value);

    // spaces should be '+' rather than '%20'.
    value = value.replace(/%20/g, '+');
    return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
}

module.exports = serialize;

},{}],3:[function(require,module,exports){
var domify = require('domify')
var serialize = require('form-serialize')

// Build DOM elements for the structure of the dialog
var buildDialogForm = function buildDialogForm (options) {
  var form = document.createElement('form')
  form.classList.add('vex-dialog-form')

  var message = document.createElement('div')
  message.classList.add('vex-dialog-message')
  message.appendChild(options.message instanceof window.Node ? options.message : domify(options.message))

  var input = document.createElement('div')
  input.classList.add('vex-dialog-input')
  input.appendChild(options.input instanceof window.Node ? options.input : domify(options.input))

  form.appendChild(message)
  form.appendChild(input)

  return form
}

// Take an array of buttons (see the default buttons below) and turn them into DOM elements
var buttonsToDOM = function buttonsToDOM (buttons) {
  var domButtons = document.createElement('div')
  domButtons.classList.add('vex-dialog-buttons')

  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i]
    var domButton = document.createElement('button')
    domButton.type = button.type
    domButton.textContent = button.text
    domButton.classList.add(button.className)
    domButton.classList.add('vex-dialog-button')
    if (i === 0) {
      domButton.classList.add('vex-first')
    } else if (i === buttons.length - 1) {
      domButton.classList.add('vex-last')
    }
    // Attach click listener to button with closure
    (function (button) {
      domButton.addEventListener('click', function (e) {
        if (button.click) {
          button.click.call(this, e)
        }
      }.bind(this))
    }.bind(this)(button))

    domButtons.appendChild(domButton)
  }

  return domButtons
}

var plugin = function plugin (vex) {
  // Define the API first
  var dialog = {
    // Plugin name
    name: 'dialog',

    // Open
    open: function open (opts) {
      var options = Object.assign({}, this.defaultOptions, opts)

      // `message` is unsafe internally, so translate
      // safe default: HTML-escape the message before passing it through
      if (options.unsafeMessage && !options.message) {
        options.message = options.unsafeMessage
      } else if (options.message) {
        options.message = vex._escapeHtml(options.message)
      }

      // Build the form from the options
      var form = options.unsafeContent = buildDialogForm(options)

      // Open the dialog
      var dialogInstance = vex.open(options)

      // Quick comment - these options and appending buttons and everything
      // would preferably be done _before_ opening the dialog. However, since
      // they rely on the context of the vex instance, we have to do them
      // after. A potential future fix would be to differentiate between
      // a "created" vex instance and an "opened" vex instance, so any actions
      // that rely on the specific context of the instance can do their stuff
      // before opening the dialog on the page.

      // Override the before close callback to also pass the value of the form
      var beforeClose = options.beforeClose && options.beforeClose.bind(dialogInstance)
      dialogInstance.options.beforeClose = function dialogBeforeClose () {
        // Only call the callback once - when the validation in beforeClose, if present, is true
        var shouldClose = beforeClose ? beforeClose() : true
        if (shouldClose) {
          options.callback(this.value || false)
        }
        // Return the result of beforeClose() to vex
        return shouldClose
      }.bind(dialogInstance)

      // Append buttons to form with correct context
      form.appendChild(buttonsToDOM.call(dialogInstance, options.buttons))

      // Attach form to instance
      dialogInstance.form = form

      // Add submit listener to form
      form.addEventListener('submit', options.onSubmit.bind(dialogInstance))

      // Optionally focus the first input in the form
      if (options.focusFirstInput) {
        var el = dialogInstance.contentEl.querySelector('button, input, textarea')
        if (el) {
          el.focus()
        }
      }

      // For chaining
      return dialogInstance
    },

    // Alert
    alert: function (options) {
      // Allow string as message
      if (typeof options === 'string') {
        options = {
          message: options
        }
      }
      options = Object.assign({}, this.defaultOptions, this.defaultAlertOptions, options)
      return this.open(options)
    },

    // Confirm
    confirm: function (options) {
      if (typeof options !== 'object' || typeof options.callback !== 'function') {
        throw new Error('dialog.confirm(options) requires options.callback.')
      }
      options = Object.assign({}, this.defaultOptions, this.defaultConfirmOptions, options)
      return this.open(options)
    },

    // Prompt
    prompt: function (options) {
      if (typeof options !== 'object' || typeof options.callback !== 'function') {
        throw new Error('dialog.prompt(options) requires options.callback.')
      }
      var defaults = Object.assign({}, this.defaultOptions, this.defaultPromptOptions)
      var dynamicDefaults = {
        unsafeMessage: '<label for="vex">' + vex._escapeHtml(options.label || defaults.label) + '</label>',
        input: '<input name="vex" type="text" class="vex-dialog-prompt-input" placeholder="' + vex._escapeHtml(options.placeholder || defaults.placeholder) + '" value="' + vex._escapeHtml(options.value || defaults.value) + '" />'
      }
      options = Object.assign(defaults, dynamicDefaults, options)
      // Pluck the value of the "vex" input field as the return value for prompt's callback
      // More closely mimics "window.prompt" in that a single string is returned
      var callback = options.callback
      options.callback = function promptCallback (value) {
        value = value[Object.keys(value)[0]]
        callback(value)
      }
      return this.open(options)
    }
  }

  // Now define any additional data that's not the direct dialog API
  dialog.buttons = {
    YES: {
      text: 'OK',
      type: 'submit',
      className: 'vex-dialog-button-primary',
      click: function yesClick () {
        this.value = true
      }
    },

    NO: {
      text: 'Cancel',
      type: 'button',
      className: 'vex-dialog-button-secondary',
      click: function noClick () {
        this.value = false
        this.close()
      }
    }
  }

  dialog.defaultOptions = {
    callback: function () {},
    afterOpen: function () {},
    message: '',
    input: '',
    buttons: [
      dialog.buttons.YES,
      dialog.buttons.NO
    ],
    showCloseButton: false,
    onSubmit: function onDialogSubmit (e) {
      e.preventDefault()
      if (this.options.input) {
        this.value = serialize(this.form, { hash: true })
      }
      return this.close()
    },
    focusFirstInput: true
  }

  dialog.defaultAlertOptions = {
    buttons: [
      dialog.buttons.YES
    ]
  }

  dialog.defaultPromptOptions = {
    label: 'Prompt:',
    placeholder: '',
    value: ''
  }

  dialog.defaultConfirmOptions = {}

  return dialog
}

module.exports = plugin

},{"domify":1,"form-serialize":2}]},{},[3])(3)
});

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__db_pokes_pokemons_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__db_pokes_pokemons_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__db_pokes_pokemons_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db_generations_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db_generations_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__db_generations_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__db_generations_options_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__db_generations_options_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__db_generations_options_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__db_gens_versions_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__db_gens_versions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__db_gens_versions_js__);
const pokedex = {};






[__WEBPACK_IMPORTED_MODULE_0__db_pokes_pokemons_js___default.a, __WEBPACK_IMPORTED_MODULE_1__db_generations_js___default.a, __WEBPACK_IMPORTED_MODULE_2__db_generations_options_js___default.a, __WEBPACK_IMPORTED_MODULE_3__db_gens_versions_js___default.a].forEach(item => item(pokedex));

/* harmony default export */ __webpack_exports__["a"] = pokedex;

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pokeinfo__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = Poke;


var MOVE_RETURN = 216;

function Poke() {
	this.reset();
}

Poke.prototype.reset = function() {
	this.num = 0;
	this.forme = 0;
	this.nick = "";
	this.item = 0;
	this.ability = 0;
	this.moves = [0, 0, 0, 0];
	if (this.gen && this.gen.num <= 2) {
		this.evs = [252, 252, 252, 252, 252, 252];
		this.ivs = [15, 15, 15, 15, 15, 15];
	} else {
		this.evs = [0, 0, 0, 0, 0, 0];
		this.ivs = [31, 31, 31, 31, 31, 31];
	}
	this.happiness = 0;
	this.level = 100;
	this.gender = 0;
	this.nature = 0;
	this.shiny = false;
	if (!this.gen) {
		this.gen = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["c" /* GenInfo */].lastGen;
	}
};

Poke.prototype.load = function(poke) {
    var alreadySet = false;

    if (this.num && __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].toNum(this) === __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].toNum(poke)) {
        alreadySet = true;
    } else {
        this.reset();
    }
    poke = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].toObject(poke);
    this.num = poke.num;
    this.forme = poke.forme;

    if (!alreadySet && !this.illegal) {
    	/* Change mega forme to base + item, and so on */
    	var item = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].itemForForme(this);
    	if (item) {
            if (__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["b" /* ItemInfo */].isMegaStone(item)) {
                this.forme = 0;
	        }
    		this.item = item;
    	}
    }

    this.data = {};
    this.data.moveNames = [];
    this.data.types = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].types(this, this.gen);

    this.data.gender = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].gender(this);

    if (this.illegal) {
    	this.data.allMoves = Object.keys(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].list());
    	this.data.abilities = Object.keys(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["h" /* AbilityInfo */].list());
    } else {
    	this.data.allMoves = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].allMoves(this, this.gen);
    	this.data.abilities = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].abilities(this, this.gen);
    	if (!this.data.abilities[2] || this.data.abilities[2] === this.data.abilities[0]) {
        	this.data.abilities.splice(2, 1);
	    }
	    if (!this.data.abilities[1] || this.data.abilities[1] === this.data.abilities[0]) {
	        this.data.abilities.splice(1, 1);
	    }
    }

    if (!alreadySet) {
        this.nick = this.num === 0 ? "" : __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(this);
        this.ability = this.data.abilities[0];
        this.gender = this.data.gender === 3 ? (1 + Math.floor(2 * Math.random())) : this.data.gender;
    }
};

Poke.prototype.evSurplus = function() {
	if (this.illegal || (this.gen && this.gen.num <= 2)) {
		return 0;
	}
    var sum = 0;
    for (var i = 0; i < 6; i++) {
        sum = sum + this.evs[i];
    }
    return sum - 510;
};

Poke.prototype.correctSurplus = function() {
	var surplus = this.evSurplus() + 2;
	if (surplus <= 0 || this.illegal || (this.gen && this.gen.num <= 2)) {
		return false;
	}
	for (var i = 0; i < 6; i++) {
		var reduction = Math.min(surplus, this.evs[i]);
		this.evs[i] -= reduction;
		surplus -= reduction;
	}
	return true;
};

Poke.prototype.export = function() {
	if (!this.num) {
		return "";
	}
	var gen = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["c" /* GenInfo */].getGen(this.gen);

	var lines = [];

	var name = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(this);

	if (name === this.nick || !this.nick) {
		name += this.shiny ? "*" : "";
	} else {
		name = this.nick + (this.shiny ? "*" : "") + " (" + name + ")";
	}

	if (gen.num > 1 && this.gender > 0) {
		name += ["", " (M)", " (F)"][this.gender % 3];
	}

	name += " @ " + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["b" /* ItemInfo */].name(this.item);

	lines.push(name);

	if (this.level !== 100) {
		lines.push("Level: " + this.level);
	}

	if (gen.num > 2) {
		lines.push("Ability: " + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["h" /* AbilityInfo */].name(this.ability));
	}

	var statNames = ["HP", "Atk", "Def", "SpA", "SpD", "Spe"];

	var evs = [];
	var ivs = [];

	for (var s = 0; s < 6; s++) {
		if ((gen.num > 2 && this.evs[s] > 0) || (gen.num <= 2 && this.evs[s] < 252)) {
			evs.push(this.evs[s] + " " + statNames[s]);
		}
		if ((gen.num > 2 && this.ivs[s] < 31) || (gen.num <= 2 && this.ivs[s] < 15)) {
			ivs.push(this.ivs[s] + " " + statNames[s]);
		}
	}

	if (evs.length > 0) {
		lines.push("EVs: " + evs.join(" / "));
	}

	if (ivs.length > 0) {
		lines.push("IVs: " + ivs.join(" / "));
	}

	if (gen.num > 2) {
		var nature = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["d" /* NatureInfo */].name(this.nature) + " Nature";
		if (__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["d" /* NatureInfo */].boostedStat(this.nature) > -1) {
			nature += " (+" + statNames[__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["d" /* NatureInfo */].boostedStat(this.nature)] +
					  ", -" + statNames[__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["d" /* NatureInfo */].reducedStat(this.nature)] + ")";
		}
		lines.push(nature);
	}

	for (var m = 0; m < this.moves.length; m++) {
		if (this.moves[m]) {
			var moveName = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].name(this.moves[m]);
			if (moveName === "Hidden Power") {
				moveName += " [" + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["e" /* TypeInfo */].name(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].getHiddenPowerType(this.ivs, this.gen)) + "]";
			}
			lines.push("- " + moveName);
		}
	}

	return lines.join("\n");
};

Poke.prototype.import = function(str) {
	this.reset();

	var gen = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["c" /* GenInfo */].getGen(this.gen);
	var lines = str.replace("\r", "").split("\n");
	var nameLine = lines.splice(0, 1)[0];
	var nameItem = nameLine.split("@");

	var nick = nameItem[0].replace("(M)", "").replace("(F)", "").replace("*", "").trim();
	var left = nick.indexOf("(");
	var right = nick.indexOf(")");
	if (left > -1 && right > left) {
		this.load(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].num(nick.substring(left + 1, right)));
		this.nick = nick.substring(0, left).trim();
	} else {
		this.load(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].num(nick));
	}

	this.shiny = nameItem[0].indexOf("*") > -1 && gen.num > 1;

	if (gen.num > 1 && nameItem[0].indexOf("(M)") > -1) {
		this.gender = 1;
	} else if (gen.num > 1 && nameItem[0].indexOf("(F)") > -1) {
		this.gender = 2;
	} else if (gen.num > 1 && this.data.gender == 3) {
		// If both are possible and none specified, default to male
		this.gender = 1;
	}

	if (nameItem.length > 1 && gen.num > 1) {
		this.item = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["b" /* ItemInfo */].num(nameItem[1].trim());
	} else {
		this.item = 0;
	}

	var statNames = {
		"HP": 0, "Atk": 1, "Def": 2,
		"SAtk": 3, "SpA": 3, "Spc": 3,
		"SDef": 4, "SpD": 4,
		"Spd": 5, "Spe": 5
	};
	var moveIndex = 0;

	while (lines.length > 0) {
		var line = lines.splice(0, 1)[0];
		var lower = line.toLowerCase();
		if (lower.startsWith("level:")) {
			this.level = parseInt(line.substr(line.indexOf(":") + 1), 10);
			if (!(this.level >= 1 && this.level <= 100)) {
				this.level = 100;
			}
		} else if (lower.startsWith("shiny:")) {
			this.shiny = lower.indexOf("yes") > -1;
		} else if (lower.startsWith("happiness:")) {
			this.happiness = +line.substr("happiness:".length()).trim();
		} else if (lower.startsWith("evs:")) {
			var evs = line.substr(4).split("/");
			for (var e = 0; e < evs.length; e++) {
				var ev = evs[e].trim().split(" ");
				if (ev.length < 2) {
					continue;
				}
				var evNum = parseInt(ev[0]);
				if (!(evNum >= 0 && evNum <= 252)) {
					continue;
				}
				if (!statNames.hasOwnProperty(ev[1].trim())) {
					continue;
				}
				this.evs[statNames[ev[1].trim()]] = evNum;
			}
		} else if (lower.startsWith("ivs:")) {
			var ivs = line.substr(4).split("/");
			var ivMax = gen.num > 2 ? 31 : 15;
			for (var i = 0; i < ivs.length; i++) {
				var iv = ivs[i].trim().split(" ");
				if (iv.length < 2) {
					continue;
				}
				var ivNum = parseInt(iv[0]);
				if (!(ivNum >= 0 && ivNum <= ivMax)) {
					continue;
				}
				if (!statNames.hasOwnProperty(iv[1].trim())) {
					continue;
				}
				this.ivs[statNames[iv[1].trim()]] = ivNum;
			}
		} else if (lower.startsWith("trait:") || lower.startsWith("ability:")) {
			this.ability = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["h" /* AbilityInfo */].num(lower.split(":")[1].trim());
		} else if (line.trim().startsWith("-")) {
			if (moveIndex >= 4) {
				continue;
			}
			line = line.substr(line.indexOf("-") + 1).trim();
			if (line.indexOf("[") > -1) {
				if (line.toLowerCase().startsWith("hidden power")) {
					var type = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["e" /* TypeInfo */].num(line.substr(12).replace("[", "").replace("]", "").trim());
					if (type > 0 && __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].getHiddenPowerType(this.ivs, this.gen) !== type) {
						// do not change ivs if current ivs already are a match
						this.ivs = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].getHiddenPowerIVs(type, this.gen)[0];
					}
				}
				line = line.substring(0, line.indexOf("[")).trim();
			}
			var mv = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].num(line);
			this.moves[moveIndex++] = mv;
			if (mv == MOVE_RETURN) {
				this.happiness = 255;
			}
		} else if (lower.contains("nature")) {
			line = line.trim();
			this.nature = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["d" /* NatureInfo */].num(line.substring(0, line.indexOf(" ")));
		}
	}
};


/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__network__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commandhandling__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__webclient__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = BattleData;






function BattleData(data) {
    __WEBPACK_IMPORTED_MODULE_0_riot_observable___default()(this);

    this.addData(data);
}

var battledata = BattleData.prototype;

Object.assign(battledata, __WEBPACK_IMPORTED_MODULE_2__commandhandling__["a" /* default */]);

/* Called when sound settings changed from the battle interface */
battledata.setSound = function (playSound) {
    this.sound = playSound;
    this.trigger("soundsettings", playSound);
};

/* Called when sound settings changed from up above */
battledata.changeSound = function (playSound) {
    this.sound = playSound;
    this.trigger("soundchanged", playSound);
};

battledata.addData = function(data) {
    Object.assign(this, data);
};

battledata.print = function(msg, args) {
    this.trigger("print", msg, args);
};

battledata.finished = function(result) {
    if (result === "close") {
        this.dealWithCommand({
            "command": "battleend",
            "result": 3
        });
    }
    if (result === "close" || result === "forfeit") {
        this.trigger("disable");
    }
};

battledata.start = function(data) {
    var self = this;

    this.speed = 1.0;
    this.pause();
    this.addData(data);

    this.data = {};

    var conf = this.conf;
    var team = this.team;

    this.queue = [];//Queues of message not yet processed

    /* Pokemon on the field */
    this.pokes = {"0": {}, "1": {}};
    /* teams */
    this.teams = [[{},{},{},{},{},{}], [{},{},{},{},{},{}]];
    this.choices = {};
    this.spectators = {};
    this.timers = [
        {"value":300, "ticking": false},
        {"value":300, "ticking": false}
    ];
    this.players = ["", ""];
    /* player names */
    if (conf.names) {
        for (var i in conf.names) {
            if (conf.names[i]) {
                this.players[i] = conf.names[i];
            }
        }
    }
    if (!this.players[0]) {
        this.players[0] = __WEBPACK_IMPORTED_MODULE_3__webclient__["a" /* default */].players.name(conf.players[0]);
    }
    if (!this.players[1]) {
        this.players[1] = __WEBPACK_IMPORTED_MODULE_3__webclient__["a" /* default */].players.name(conf.players[1]);
    }
    if (!__WEBPACK_IMPORTED_MODULE_3__webclient__["a" /* default */].players.hasPlayer(conf.players[0])) {
        __WEBPACK_IMPORTED_MODULE_3__webclient__["a" /* default */].requestInfo(conf.players[0]);
    }
    if (!__WEBPACK_IMPORTED_MODULE_3__webclient__["a" /* default */].players.hasPlayer(conf.players[1])) {
        __WEBPACK_IMPORTED_MODULE_3__webclient__["a" /* default */].requestInfo(conf.players[1]);
    }

    var setTeam = function(id, team) {
        // ugly way to clone, better way at http://stackoverflow.com/questions/728360/most-elegant-way-to-clone-a-javascript-object
        self.teams[id] = JSON.parse(JSON.stringify(team));
        while (self.teams[id].length < 6) {
            var moves = [];
            for (var j = 0; j < 4; j++) {
                moves.push({
                    "move": 0,
                    "pp":0,
                    "totalpp":0,
                    "tempmove":0,
                    "temppp": 0
                });
            }
            self.teams[id].push({
                "moves": moves,
                num: 0,
                level: 0
            });
        }
    };

    if (team) {
        this.myself = conf.players[1] === __WEBPACK_IMPORTED_MODULE_3__webclient__["a" /* default */].ownId ? 1 : 0;
        setTeam(this.myself, team);
        //this.updateTeamPokes(this.myself);
    } else {
        if (this.conf.teams) {
            setTeam(0, this.conf.teams[0]);
            setTeam(1, this.conf.teams[1]);
        }
        this.myself = 0;
    }

    this.opponent = 1 - this.myself;
};

battledata.isBattle = function() {
    if (arguments.length === 0) {
        return !!this.team;
    } else {
        return (this.team && this.myself == arguments[0]) || "teams" in this.conf;
    }
};


battledata.name = function(player) {
    return this.players[this.player(player)];
};

battledata.rnick = function(spot) {
    if (!(spot in this.pokes)) {
        return this.teams[this.player(spot)][this.slot(spot)].name || "???";
    }
    return this.pokes[spot].name;
};

battledata.nick = function(spot) {
    if (this.isBattle() && this.player(spot) == this.myself) {
        return this.rnick(spot);
    } else {
        return this.name(this.player(spot)) + "'s " + this.rnick(spot);
    }
};

battledata.player = function(spot) {
    return spot % 2;
};

battledata.side = function(spot) {
    return this.player(spot) == this.myself ? 1 : 0;
};

battledata.updateInfo = function(id, player) {
    if (this.ids[0] == id) {
        this.players[0] = player.name;
        this.trigger("playernameupdated", 0, player.name);
    } else if (this.ids[1] == id) {
        this.players[1] = player.name;
        this.trigger("playernameupdated", 1, player.name);
    }
};

battledata.close = function() {
    this.timers[0].ticking = this.timers[1].ticking = false;
};

battledata.updateClock = function(player, time, ticking) {
    this.timers[player] = {
        "time": time,
        "ticking": ticking,
        "lastupdate": new Date().getTime()
    };
    this.updateTimers();
};

battledata.updateTimers = function() {
    var self = this;

    for (var i = 0; i < 2; i++) {
        var time = this.timers[i].time;
        if (time === undefined) {
            time = 300;
        }
        if (this.timers[i].ticking) {
            time -= (((new Date().getTime()) - this.timers[i].lastupdate) / 1000);
            if (time < 0) {
                time = 0;
            }
        }
        this.trigger("timerupdated", i, time);
    }
    if (this.timers[0].ticking || this.timers[1].ticking) {
        setTimeout(function() {
            self.updateTimers();
        }, 1000);
    }
};

battledata.slot = function(spot) {
    return spot >> 1;
};

battledata.spot = function(player, slot) {
    return player + (slot << 1);
};

battledata.poke = function(spot) {
    return this.pokes[spot];
};

battledata.tpoke = function(spot) {
    if (arguments.length == 1) {
        return this.teams[this.player(spot)][this.slot(spot)];
    } else {
        return this.teams[arguments[0]][arguments[1]];
    }
};

battledata.updateFieldPoke = function(/* spot */) {
};

battledata.updateTeamPokes = function(player, pokes) {
    this.trigger("updateteampokes", player, pokes);
};

battledata.allowStart = function() {
    this.canStart = true;

    if (!this.paused) {
        this.readQueue();
    }
};

battledata.pause = function() {
    //console.log("pausing battle");
    this.paused = true;
};

battledata.unpause = function() {
    //console.log("unpausing battle");
    this.paused = false;
    this.readQueue();
};

battledata.emptyQueue = function() {
    return this.queue.length === 0;
};

battledata.readQueue = function() {
    if (this.queue.length === 0 || this.readingQueue ||!this.canStart) {
        return;
    }

    this.readingQueue = true;
    for (var i = 0; i < this.queue.length; i++) {
        if (this.paused) {
            break;
        }
        this.dealWithCommand(this.queue[i]);
    }
    this.queue = this.queue.slice(i);
    this.readingQueue = false;
};

/* Receives a battle command - a battle message.

   Calls the appropriate function from battle/commandshandling.js to handle it.
 */
battledata.dealWithCommand = function(params) {
    var isImmediate = (params.command in BattleData.immediateCommands) && !params.end;
    if ((this.paused || !this.canStart) && !isImmediate) {
        this.queue.push(params);
        return;
    }
    var funcName = "dealWith" + params.command[0].toUpperCase() + params.command.slice(1);
    if (funcName in BattleData.prototype) {
        this[funcName](params);
    } else {
        console.log("Unknown BattleData command issued.");
        console.log(params);
    }
};

BattleData.immediateCommands = {
    "clock": true,
    "playerchat": true,
    "spectatorjoin": true,
    "spectatorleave": true,
    "spectatorchat": true,
    "disconnect": true,
    "reconnect" : true
};

battledata.sendMessage = function (message) {
    var lines = message.trim().split("\n");
    var command = (this.isBattle() ? "battlechat": "spectatingchat");

    for (var i = 0; i < lines.length; i++) {
        __WEBPACK_IMPORTED_MODULE_1__network__["a" /* default */].command(command, {
            battle: this.id,
            message: lines[i]
        });
    }
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battledata__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__frontend__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = Battles;






function Battles() {
    __WEBPACK_IMPORTED_MODULE_0_riot_observable___default()(this);

    this.battles = {};
    this.battleList = {};
    this.battlesByPlayer = {};
}

Battles.prototype.isBattling = function(pid) {
    return (pid in this.battlesByPlayer);
};

Battles.prototype.battleOfPlayer = function(pid) {
    if (this.isBattling(pid)) {
        for (var x in this.battlesByPlayer[pid]) {
            return this.battlesByPlayer[pid][x].id;
        }
    }
};

Battles.prototype.battlesOfPlayer = function(pid) {
    return this.battlesByPlayer[pid];
};

Battles.prototype.addBattle = function (battles) {
    for (var id in battles) {
        var battle = battles[id];
        battle.id = id;
        this.battleList[id] = new __WEBPACK_IMPORTED_MODULE_3__battledata__["a" /* default */](battle);
        if (!(battle.ids[0] in this.battlesByPlayer)) {
            this.battlesByPlayer[battle.ids[0]] = {};
        }
        this.battlesByPlayer[battle.ids[0]][id] = battle;
        if (!(battle.ids[1] in this.battlesByPlayer)) {
            this.battlesByPlayer[battle.ids[1]] = {};
        }
        this.battlesByPlayer[battle.ids[1]][id] = battle;

        __WEBPACK_IMPORTED_MODULE_4__frontend__["default"].players.updatePlayer(battle.ids[0]);
        __WEBPACK_IMPORTED_MODULE_4__frontend__["default"].players.updatePlayer(battle.ids[1]);

        /* Is it a battle we're taking part in ? */
        if (battle.team) {
            __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].searchingForBattle = false;
            __WEBPACK_IMPORTED_MODULE_4__frontend__["default"].updateSearchingBattleState();

            this.startBattle(battle);
        }
    }
};

Battles.prototype.dealWithCommand = function(battleid, command) {
    if (battleid in this.battles) {
        this.battles[battleid].dealWithCommand(command);
    } else {
        console.log("battle command for battle " + battleid + " not found");
        console.log(command);
    }
};

Battles.results = [
    "forfeit",
    "win",
    "tie",
    "close"
];

Battles.prototype.battleEnded = function(battleid, result) {

    result = Battles.results[result.result];

    if (!this.battleList.hasOwnProperty(battleid)) {
        this.leaveBattle(battleid, result);
        return;
    }

    var ids = this.battleList[battleid].ids;
    this.removeBattle(battleid,result);

    /* We do nothing with result yet... no printing channel events?! */
    __WEBPACK_IMPORTED_MODULE_4__frontend__["default"].players.updatePlayer(ids[0]);
    __WEBPACK_IMPORTED_MODULE_4__frontend__["default"].players.updatePlayer(ids[1]);
};

Battles.prototype.serverStopWatching = function(battleid) {
    this.leaveBattle(battleid, "close");
};

/* Maybe instead of a direct call from players it should be bound by some kind of event listener and
    called that way. */
Battles.prototype.removePlayer = function(pid) {
    /* If both players are not in memory for a battle, removes the battle from memory */
    for (var battleid in this.battlesByPlayer[pid]) {
        var battle = this.battlesByPlayer[pid][battleid];
        var ids = battle.ids;
        if (!__WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.hasPlayer(ids[0] == pid ? ids[1] : ids[0])) {
            this.removeBattle(battleid, "forfeit");
        }
    }
};

Battles.prototype.removeBattle = function(battleid,result) {
    var ids = this.battleList[battleid].ids;
    delete this.battlesByPlayer[ids[0]][battleid];
    delete this.battlesByPlayer[ids[1]][battleid];
    delete this.battleList[battleid];
    /* If a player has no more battles, useless to keep them in memory */
    if (!Object.keys(this.battlesByPlayer[ids[0]]).length) {
        delete this.battlesByPlayer[ids[0]];
    }
    if (!Object.keys(this.battlesByPlayer[ids[1]]).length) {
        delete this.battlesByPlayer[ids[1]];
    }

    this.leaveBattle(battleid, result);
};

Battles.prototype.battle = function(pid) {
    if (pid in this.battles) {
        return this.battles[pid];
    }
    console.log("no battle with id " + pid + " found, current ids: " + JSON.stringify(Object.keys(this.battles)));
};

Battles.prototype.watchBattle = function(bid, conf) {
    if (bid in this.battles) {
        console.log("Already watching battle " + bid + " with conf " + JSON.stringify(conf));
        return;
    }

    this.startBattle({id: bid, conf: conf});
};

Battles.prototype.startBattle = function(battle) {
    /* The battle isn't always in the list - if the 2 players don't share channels with you */
    this.battles[battle.id] = this.battleList[battle.id] || new __WEBPACK_IMPORTED_MODULE_3__battledata__["a" /* default */](battle);
    this.battles[battle.id].start(battle);

    this.trigger("activebattle", battle.id);
};

Battles.prototype.leaveBattle = function(id, result) {
    if (id in this.battles) {
        if (result == "close" || result == "forfeit") {
            this.battles[id].finished(result);
            delete this.battles[id];
        }
    }
};

Battles.prototype.updateInfo = function(id, player) {
    for (var bid in this.battles) {
        this.battles[bid].updateInfo(id, player);
    }
};

__WEBPACK_IMPORTED_MODULE_1_jquery___default()(function() {
    __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].players.on("playerremove", function(id) {
        __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].battles.removePlayer(id);
    });
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap3_dialog__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap3_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap3_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basetab__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chat__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__network__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__battleconstants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pokeinfo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__webclient__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = BattleTab;














var pokeballrowHtml = "<span class='status status0' data-toggle='tooltip' title=''></span>".repeat(6);

function BattleTab(id) {
    __WEBPACK_IMPORTED_MODULE_7_riot_observable___default()(this);

    var databattle = __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].battles.battle(id);
    var conf = databattle.conf;
    // var team = databattle.team;
    var self = this;

    this.battle = databattle;
    this.battle.sound = __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].battles.sound;
    this.players = this.battle.players;
    this.myself = this.battle.myself;
    this.opponent = this.battle.opponent;

    this.setCallbacks();
    //new BattleAnimator(this);

    this.battle.data.background = Math.floor(37 * Math.random());

    this.shortHand = "battle";

    this.chat = new __WEBPACK_IMPORTED_MODULE_4__chat__["b" /* default */]();
    var layout = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>");
    layout.addClass("flex-row battle-tab-layout");

    var rows = [0,0];
    rows[this.opponent] = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("status-row").html("<span class='trainer-name'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* escapeHtml */])(this.players[this.opponent]) +
        "</span><span class='stretchX'></span><span class='timer-text'>5:00</span>"+pokeballrowHtml);
    rows[this.opponent].find('[data-toggle="tooltip"]').attr("data-placement", "top");
    rows[this.myself] = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("status-row").html(pokeballrowHtml + "<span class='timer-text'>5:00</span><span class='stretchX'></span><span class='trainer-name'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* escapeHtml */])(this.players[this.myself]) + "</span>");
    rows[this.myself].find('[data-toggle="tooltip"]').attr("data-placement", "bottom");
    this.rows = rows;
    layout.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("battle-view").append(rows[this.opponent]).append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("battle-canvas")
        .append(BattleTab.getIframe(id))
        .append("<img src='/battle/background/" + this.battle.data.background  + ".png'>")).append(rows[this.myself]));
    layout.append(this.chat.element);
    this.layout = layout;
    this.addTab(layout);
    this.timers=[rows[0].find(".timer-text"), rows[1].find(".timer-text")];

    this.teampokes = rows;

    /* Show switch row */
    if (this.isBattle()) {
        var pokeRow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("battle-switchrow btn-group btn-group-justified").attr("data-toggle", "buttons");
        for (const i in this.battle.teams[this.myself]) {
            // var poke = this.battle.teams[this.myself][i];
            const item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span>").addClass("btn btn-default battle-poke").append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<input type='radio'>")).append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<img>")).append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span>").addClass("battle-poke-text")).attr("slot", i);
            pokeRow.append(item);

            item.on("click", function(/* event */) {
                if (!self.battle.choicesAvailable || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("disabled")) {
                    return false;
                }

                self.onControlsChooseSwitch(+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("slot"));
            });

            this.addPopover(item);
        }
        this.switchRow = pokeRow;

        var onMoveClicked = function(/* event */) {
            if (!self.battle.choicesAvailable || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("disabled")) {
                return false;
            }

            self.onControlsChooseMove(+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("slot"));
        };

        var moveRow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("battle-attackrow btn-group-justified").attr("data-toggle", "buttons");
        for (const i in this.battle.teams[this.myself][0].moves) {
            const item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span>").addClass("btn btn-default battle-move").append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<input type='radio'>")).append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span>").addClass("battle-move-text")).attr("slot", i);
            item.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span class='battle-move-pp'>"));
            moveRow.append(item);

            item.on("click", onMoveClicked);

            this.addMovePopover(item);
        }
        this.attackRow = moveRow;

        var tabs = '\
            <div class="btn-group" data-toggle="buttons">\
                <a href="#moves-' + id + '" class="btn btn-default active battle-attack" data-toggle="tab">\
                    <input type="radio">Attack</a>\
                <a href="#switch-' + id + '" class="btn btn-default battle-switch" data-toggle="tab">\
                    <input type="radio">Switch</a>\
            </div>';

        var megacancel = `
            <div class="btn-group pull-right" data-toggle="buttons">
                <span class="btn btn-default battle-zmove">
                    <input type="checkbox">Z-Move</span>
                <span class="btn btn-default battle-mega">
                    <input type="checkbox">Mega</span>
                <span class="btn btn-default battle-struggle" slot="-1" disabled>
                    <input type="checkbox">Struggle</span>
                <span class="btn btn-default battle-cancel">
                    Cancel</span>
            </div>`;

        moveRow.addClass("tab-pane active").attr("id", "moves-" + id);
        pokeRow.addClass("tab-pane").attr("id", "switch-" + id);

        layout.find(".battle-view").append(tabs).append(megacancel).append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("tab-content").append(moveRow).append(pokeRow));

        this.attackButton = layout.find(".battle-attack");
        this.switchButton = layout.find(".battle-switch");
        this.megaButton = layout.find(".battle-mega");
        this.zButton = layout.find(".battle-zmove");
        this.cancelButton = layout.find(".battle-cancel");
        this.struggleButton = layout.find(".battle-struggle");
        this.struggleButton.on("click", onMoveClicked);

        this.cancelButton.on("click", function(/* event */) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("disabled")) {
                return false;
            }

            self.choose({"type": "cancel", "slot": self.myself});
        });
        this.zButton.on("click", function(/* event */) {
            self.enableChoices(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass("active"));
        });
    }

    this.pokes = [this.teampokes[0].find(".status:eq(0)"), this.teampokes[1].find(".status:eq(0)")];

    this.addFieldPopover(this.pokes[0], 0);
    this.addFieldPopover(this.pokes[1], 1);

    this.updateTeamPokes(this.myself);
    this.updateTeamPokes(this.opponent);

    self.fieldPopover = -1;

    this.canvas = layout.find(".battle-canvas");
    this.tab.on("mousemove", function(event) {
        var pos = {"top": event.pageY, "left": event.pageX};
        var cpos = self.canvas.offset();
        cpos.width = self.canvas.width();
        cpos.height = self.canvas.height();

        if (pos.top < cpos.top || pos.left < cpos.left || pos.top > cpos.top + cpos.height || pos.left > cpos.left + cpos.width) {
            self.battle.trigger("battle-hover", -1);
        }
    });

    this.chat.on("chat", function(msg) {
        self.battle.sendMessage(msg);
    });

    this.id = id;

    this.print("<strong>Battle between " + this.battle.name(0) + " and " + this.battle.name(1) + " just started!</strong><br />");
    this.print("<strong>Mode:</strong> " + __WEBPACK_IMPORTED_MODULE_8__battleconstants__["c" /* modes */][conf.mode]);

    if (this.isBattle() && !this.battle.choicesAvailable) {
        this.disableChoices();
    }

    /* Make sure data needed by the battle (such as move names) is loaded */
    __webpack_require__.e/* require.ensure */(1).then((() => {
        __webpack_require__(27);
        this.battle.allowStart();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

    //layout.find('[data-toggle="tooltip"]').tooltip();
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* inherits */])(BattleTab, __WEBPACK_IMPORTED_MODULE_3__basetab__["a" /* default */]);

BattleTab.getIframe = function(id) {
    if (__WEBPACK_IMPORTED_MODULE_5__frontend__["default"].battles.simpleWindow) {
        return "<iframe class='battle-iframe' src='/simple-battle-canvas?battle=" + id + "' seamless='seamless'></iframe>";
    } else {
        return "<iframe class='battle-iframe' src='/battle-canvas?battle=" + id + "' seamless='seamless'></iframe>";
    }
};

BattleTab.prototype.setCallbacks = function() {
    var self = this;
    this.battle.on("print", function(msg, args){self.print(msg, args)});
    this.battle.on("playeradd", function(id) {self.newPlayer(id);});
    this.battle.on("playerremove", function(id) {self.removePlayer(id);});
    this.battle.on("tier", function(tier) {
        self.trigger("changename", this.id, tier);
    });
    this.battle.on("timerupdated", function(i, time) {
        time = Math.floor(time);
        self.timers[i].text(Math.floor(time/60) + ":" + ("0" + (time%60)).substr(-2));
        if (time <= 30) {
            self.timers[i].addClass("time-critical");
        } else {
            self.timers[i].removeClass("time-critical");
        }
    });
    this.battle.on("disable", function() {
        self.chat.disable();
    });
    this.battle.on("updateteampokes", function(player, pokes) {
        self.updateTeamPokes(player, pokes);
    }).on("playernameupdated", function(spot, name) {
        self.rows[spot].find(".trainer-name").text(name);
    }).on("choicesavailable", function() {
        self.enableChoices();
    }).on("teampreview", function(team1, team2) {
        self.showTeamPreview(team1, team2);
    }).on("battle-hover", function(spot) {
        if (spot == self.fieldPopover) {
            return;
        }
        if (spot == -1) {
            self.pokes[0].popover("hide");
            self.pokes[1].popover("hide");
        } else {
            self.pokes[1-spot].popover("hide");
            self.pokes[spot].popover("show");
        }
        self.fieldPopover = spot;
    }).on("soundsettings", function(val) {
        __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].setBattleSound(val);
    });
}

BattleTab.prototype.switchToSimpleWindow = function() {
    this.battle.off("*");
    this.setCallbacks();
    this.layout.find(".battle-iframe").attr("src", "/simple-battle-canvas.html?battle=" + this.id);
};

BattleTab.prototype.addPopover = function(item, options) {
    options = options || {};

    var self = this;
    options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
        trigger: "hover",
        html: true,
        content: function() {
            var slot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("slot");

            var poke = self.battle.teams[self.myself][slot];
            var html = "Item: " + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["b" /* ItemInfo */].name(poke.item||0) + "<br>";
            if (poke.ability) html += "Ability: " + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["h" /* AbilityInfo */].name(poke.ability||0) + "<br>";
            html += "<br>Moves:<br>";
            for (var i in poke.moves) {
                var move = poke.moves[i];
                var name = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].name(move.move);
                if (name.toLowerCase() == "hidden power") {
                    name = name + " [" + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["e" /* TypeInfo */].name(self.getMoveType(poke, i)) + "]";
                }
                html += "-- " + name + " - " + move.pp + "/" + move.totalpp + " PP<br>";
            }

            return html;
        },
        title: function() {
            var slot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("slot");

            var poke = self.battle.teams[self.myself][slot];
            return __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].name(poke) + " lv. " + (poke.level ||0);
        },
        "placement": "top",
        container: "body"
    }, options);

    item.popover(options);
};

BattleTab.prototype.addMovePopover = function(item) {
    var battle = this.battle;
    item.popover({
        html: true,
        trigger: "hover",
        content: function() {
            var move = battle.teams[battle.myself][0].moves[item.attr("slot")].move;
            var cat = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].category(move);
            var str = "";
            if (cat) {
                str += "<strong>Power: </strong>" + (__WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].power(move) == 1 ? "???" : __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].power(move)) + "<br/> ";
            }
            var acc = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].accuracy(move);
            if (acc == 0 || acc == 101) {
                acc = "---";
            }
            str += "<strong>Accuracy: </strong>" + acc + "<br/> ";
            str += "<strong>Category: </strong>" + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["g" /* CategoryInfo */].name(cat);

            if (__WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].effect(move)) {
                str += "<br/><strong>Effect: </strong>" + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].effect(move);
            }
            return str;
        },
        "placement": "top",
        "container": "body"
    });
};

BattleTab.prototype.addFieldPopover = function(item, spot) {
    var battle = this.battle;
    item.popover({
        "html": true,
        content: function() {
            var poke = battle.pokes[spot];
            var types = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].types(poke);
            for (const i in types) {
                types[i] = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["e" /* TypeInfo */].name(types[i]);
            }

            var ret = [types.join(" / ")];
            ret.push("");

            var table = "<table class='table table-condensed table-bordered'>";
            for (let i = 0; i < 6; i++) {
                var stat = "<tr><td>"+__WEBPACK_IMPORTED_MODULE_9__pokeinfo__["i" /* StatInfo */].name(i) + "</td><td>";
                if (poke.stats) {
                    if (i == 0) {
                        stat += poke.totalLife;
                    } else {
                        stat += poke.stats[i];
                    }
                } else {
                    var boost = poke.boosts && i > 0 && poke.boosts[i] ? poke.boosts[i] : 0;

                    var min = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].minStat(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, poke, {"boost": boost}), i);
                    var max = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].maxStat(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, poke, {"boost": boost}), i);
                    stat += (isNaN(min) ? "???" : min) + " - " + (isNaN(max) ? "???" : max);
                }
                stat += "</td><td>";
                if (i > 0 && poke.boosts && poke.boosts[i]) {
                    stat += " " + (poke.boosts[i] > 0 ? "+" + poke.boosts[i] : poke.boosts[i]);
                } else if (i > 0) {
                    stat += " +0";
                }
                stat += "</td></tr>";
                table += stat;
            }
            ret.push(table + "</table>");
            var state = poke.fieldState || 0;
            var states = ["Spikes", "Spikes (2)", "Spikes (3)", "Stealth Rock", "Toxic Spikes", "Toxic Spikes (2)", "Sticky Web"];
            var actStates = [];
            for (var i in states) {
                if (state & (1 << i)) {
                    actStates.push(states[i]);
                }
            }
            if (actStates.length > 0) {
                ret.push(actStates.join(", "));
            }

            return ret.join("<br/>");
        },
        placement: this.battle.player(spot) == this.myself ? "top": "bottom"
    });
}

BattleTab.prototype.disableChoices = function() {
    this.switchRow.find(".battle-poke").attr("disabled", "disabled");
    this.attackRow.find(".battle-move").attr("disabled", "disabled");
    this.megaButton.attr("disabled", "disabled");
    this.zButton.attr("disabled", "disabled");
    this.struggleButton.attr("disabled", "disabled");
    this.cancelButton.removeAttr("disabled").removeClass("active");
};

BattleTab.prototype.myTeam = function() {
    return this.battle.teams[this.myself];
}

BattleTab.prototype.enableChoices = function(zMoving) {
    this.switchRow.find(".battle-poke").removeAttr("disabled").removeClass("active");
    this.attackRow.find(".battle-move").removeAttr("disabled").removeClass("active");
    this.megaButton.removeAttr("disabled").removeClass("active");
    this.zButton.removeAttr("disabled").removeClass("active");
    this.struggleButton.attr("disabled", "disabled").removeClass("active");
    this.cancelButton.attr("disabled", "disabled").removeClass("active");

    var available = this.battle.choices[this.myself];
    if (available) {
        if (!available.attack) {
            this.attackRow.find(".battle-move").attr("disabled", "disabled");
            this.megaButton.attr("disabled", "disabled");
            this.zButton.attr("disabled", "disabled");

            this.switchButton.trigger("click");
        } else {
            //below doesn't work, find out how to set tab
            this.attackButton.trigger("click");
            var allowed = false;
            for (var i in available.attacks) {
                if (zMoving ? available.zattacks[i] : available.attacks[i]) {
                    allowed = true;
                } else {
                    this.attackRow.find(".battle-move:eq(" + i + ")").attr("disabled", "disabled");
                }
            }
            if (!allowed) {
                this.struggleButton.removeAttr("disabled");
            }
            if (!available.mega) {
                this.megaButton.attr("disabled", "disabled");
            }
            if (!available.zmove) {
                this.zButton.attr("disabled", "disabled");
            }
        }
        if (!available.switch) {
            this.switchRow.find(".battle-poke").attr("disabled", "disabled");
        } else {
            for (const i in this.myTeam()) {
                if (this.myTeam()[i].life == 0 || this.myTeam()[i].status == 31) {
                    this.switchRow.find(".battle-poke:eq("+i+")").attr("disabled", "disabled");
                }
            }
        }
    }

    this.updateMoveChoices();
};

BattleTab.prototype.showTeamPreview = function(team1, team2) {
    while (team2.length < 6) {
        team2.push({"num":0, "level":0});
    }

    //Check if we've already changed the order, in which case, we restore it
    if (this.teampreviewOrder) {
        var team = [];
        for (var i in this.battle.teams[this.myself]) {
            team.push(this.battle.teams[this.myself][this.teampreviewOrder.indexOf(i)]);
        }
        this.battle.teams[this.myself] = team;
    }

    var self = this;

    var selected = -1;
    var row = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").attr("data-toggle", "buttons").addClass("btn-group-justified team-preview-row");
    for (let i  = 0; i < 6; i++) {
        const poke = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span>").addClass("btn btn-default btn-sm team-preview-poke").append("<input type='checkbox'>").append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<img>").attr("src", __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].icon(team1[i]))).attr("slot", i);
        if (team1[i].item) {
            poke.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<img>").addClass("team-preview-poke-held-item").attr("src", __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].heldItemSprite()));
        }
        if(team1[i].gender) {
            poke.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<img>").addClass("team-preview-poke-gender").attr("src", __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].genderSprite(team1[i].gender)));
        }
        poke.append("<br/>").append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<smaller>").text("Lv. " + team1[i].level));
        row.append(poke);

        this.addPopover(poke, {"placement": "bottom"});
    }

    row.on("click", "span.team-preview-poke", function(/* event */) {
        var clicked = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("slot");
        var cur = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);

        if (clicked == selected) {
            selected = -1;
        } else if (selected == -1) {
            selected = clicked;
        } else {
            row.find("span.team-preview-poke").removeClass("active");

            var sel = row.find("span.team-preview-poke[slot=" + selected + "]");

            cur.popover('hide');
            //sel.popover('destroy');

            var s1 = cur.html();
            var s2 = sel.html();

            // var team = self.battle.teams[self.myself];

            cur.html(s2);
            cur.attr("slot", selected);
            sel.html(s1);
            sel.attr("slot", clicked);

            /*setTimeout(function() {
                self.addPopover(sel, {"placement": "bottom"});
                self.addPopover(cur, {"placement": "bottom"});
            });*/

            selected = -1;

            return false;
        }
    });

    var row2 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").addClass("btn-group-justified team-preview-row");
    for (let i  = 0; i < 6; i++) {
        const poke = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<span>").addClass("btn btn-default btn-sm team-preview-poke").attr("disabled", "disabled").append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<img>").attr("src", __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].icon(team2[i])));
        if (team2[i].heldItem) {
            poke.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<img>").addClass("team-preview-poke-held-item").attr("src", __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].heldItemSprite()));
        }
        if(team2[i].gender) {
            poke.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<img>").addClass("team-preview-poke-gender").attr("src", __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].genderSprite(team2[i].gender)));
        }
        poke.append("<br/>").append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<smaller>").text("Lv. " + team2[i].level));
        row2.append(poke);
    }

    __WEBPACK_IMPORTED_MODULE_1_bootstrap3_dialog___default.a.show({
        title: "Team preview",
        message: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").append(row).append(row2),
        buttons: [
            {
                label: 'Done',
                action: function(dialogItself){
                    dialogItself.close();
                }
            }
        ],
        onhidden: function(/* dialogItself */) {
            //Send team preview
            var order = [];
            for (var i = 0; i < 6; i++) {
                order.push(row.find(".team-preview-poke:eq("+i+")").attr("slot"));
            }

            self.onControlsChooseTeamPreview(order);
        }
    });
};

BattleTab.prototype.print = function(msg, args) {
    msg = msg || "";
    var linebreak = true;

    /* Do not print empty message twice in a row */
    if (msg.length === 0) {
        if (this.blankMessage) {
            return;
        }
        this.blankMessage = true;
    } else {
        this.blankMessage = false;
    }

    if (args) {
        if ("spectator" in args) {
            msg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* escapeHtml */])(msg);
            var name = this.battle.spectators[args.spectator];
            const pref = "<span class='spectator-message'>" + name + ":</span>";
            msg = pref + " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* addChannelLinks */])(msg, __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].channels.channelsByName(true));
        } else if ("player" in args) {
            msg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* escapeHtml */])(msg);
            const pref = "<span class='player-message' style='color: " + (args.player == this.myself ? "darkcyan": "darkgoldenrod")+ "'>" + this.players[args.player] + ":</span>";
            msg = pref + " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* addChannelLinks */])(msg, __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].channels.channelsByName(true));
        } else if ("css" in args && args.css == "turn") {
            this.blankMessage = true;
            linebreak = false;
        }
    }

    this.chat.insertMessage(msg, {linebreak: linebreak});
    this.activateTab();

/*    if(!window.isActive && this.hadFocus && webclientUI.battleNotifications) {
        this.hadFocus = false;
        if ("Notification" in window) {
            if (this.notification) {
                this.notification.close();
            }
            this.notification = new window.Notification(this.battle.name(0) + ' vs ' + this.battle.name(1), {body: stripHtml(msg)});
        }
    } else if (window.isActive) {
        this.hadFocus = true;
    }*/
};

BattleTab.prototype.onSetCurrent = function() {
    this.chat.scrollDown();
};

BattleTab.prototype.updateTeamPokes = function(player, pokes) {
    if (!pokes) {
        pokes = [0,1,2,3,4,5];
    }
    var $pokes = this.teampokes[player];

    for (var i = 0; i < pokes.length; i++) {
        var $img = $pokes.find(".status:eq("+pokes[i]+")");
        var tpok = this.battle.teams[player][pokes[i]];
        if (tpok) {
            $img.removeClass();
            $img.html("");
            $img.addClass("status status"+(tpok.status || 0));
            if (!tpok.num) {
                $img.addClass("status-hidden")
            } else {
                $img.append('<img class="poke-icon" src="' + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].icon(tpok) + '">');
            }

            var tooltip = "";
            if (tpok.num) tooltip += __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].name(tpok);
            if (tpok.gender) tooltip += " " + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["k" /* GenderInfo */].shorthand(tpok.gender);
            if (tpok.level && tpok.level != 100) tooltip += " lv. " + tpok.level;
            if (tpok.percent !== undefined) {
                if (tpok.totalLife != undefined) {
                    tooltip += " - " + tpok.life + "/" + tpok.totalLife + " HP (" + tpok.percent + "%)";
                } else {
                    tooltip += " - " + tpok.percent + "%";
                }
            }
            //tooltip+= JSON.stringify(tpok);
            if (!tooltip)  tooltip="No Info";
            $img.attr("title", tooltip).tooltip("fixTitle");

            if (this.isBattle() && player == this.myself) {
                var $ct = this.switchRow.find(".battle-poke:eq("+pokes[i]+")");
                $ct.find("img").attr("src", __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].icon(tpok));
                var text = (tpok.name||"") + "<br/>" + (tpok.life||0) + "/" + (tpok.totalLife||0);
                $ct.find(".battle-poke-text").html(text);

                if (pokes[i] == 0) {
                    this.updateMoveChoices();
                }
            }
        }
    }
};

BattleTab.prototype.getMoveType = function(poke, i) {
    var move = poke.moves[i];
    var type = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].type(move.tempmove || move.move);
    if (__WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].name(move.tempmove || move.move).toLowerCase() == "hidden power") {
        type = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].getHiddenPowerType(poke.ivs, this.battle.conf.gen);
    }
    return type;
}

BattleTab.prototype.updateMoveChoices = function() {
    var poke = this.battle.teams[this.myself][0];
    var moves = poke.moves;
    for (var i in moves) {
        var move = moves[i];
        var movename = __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].name(move.tempmove || move.move);
        var $move = this.attackRow.find(".battle-move:eq("+i+")");
        $move.find(".battle-move-text").text(movename);
        $move.find(".battle-move-pp").text(move.pp + "/" + (move.temppp || move.totalpp) + " PP");
        $move.removeClass($move.attr("typeclass") || "");

        var cl = "type-" + __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["e" /* TypeInfo */].css(this.getMoveType(poke, i)).toLowerCase();
        $move.attr("typeclass", cl);
        $move.addClass(cl);
    }
};

/**
 * Called when a chooseMove button is clicked
 * @param $obj The button jquery object
 */
BattleTab.prototype.onControlsChooseMove = function(slot) {
    var choice = {"type":"attack", "slot":this.myself, "attackSlot": slot};
    if (this.megaButton.hasClass("active")) {
        choice.mega = true;
    }
    if (this.zButton.hasClass("active")) {
        choice.zmove = true;
    }
    this.choose(choice);
};

/**
 * Called when a chooseMove button is clicked
 * @param $obj The button jquery object
 */
BattleTab.prototype.onControlsChooseSwitch = function(slot) {
    var choice = {"type":"switch", "slot":this.myself, "pokeSlot": +slot};
    this.choose(choice);
};

BattleTab.prototype.onControlsChooseTeamPreview = function(neworder) {
    this.teampreviewOrder = neworder;

    var team = [];
    for (var i in this.battle.teams[this.myself]) {
        team.push(this.battle.teams[this.myself][neworder[i]]);
    }
    this.battle.teams[this.myself] = team;

    this.updateTeamPokes(this.myself);

    var choice = {"type":"rearrange", "slot":this.myself, "neworder": neworder};
    this.choose(choice);
};

BattleTab.prototype.getPlayers = function() {
    var array = [];
    for (var i = 0; i < this.battle.conf.players.length; i++) {
        array.push(this.battle.conf.players[i]);
    }
    for (var x in this.battle.spectators) {
        array.push(x);
    }

    return array;
};

BattleTab.prototype.choose = function(choice)
{
    this.battle.choicesAvailable = false;
    this.disableChoices();
    __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command('battlechoice', {id: this.id, choice: choice});
};

BattleTab.prototype.isBattle = function() {
    return this.battle.conf.players[0] == __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId || this.battle.conf.players[1] == __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].ownId;
};

BattleTab.prototype.close = function() {
    this.battle.close();
    delete __WEBPACK_IMPORTED_MODULE_10__webclient__["a" /* default */].battles.battles[this.id];
    clearInterval(this.timer);

    if (this.isBattle()) {
        __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command('forfeit', {battle: this.id});
    } else {
        __WEBPACK_IMPORTED_MODULE_6__network__["a" /* default */].command('stopwatching', {battle: this.id});
    }

    this.trigger("close");
    this.removeTab();
};


BattleTab.prototype.newPlayer = function (player) {
    if (this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].players.addPlayer(player);
    }
};

BattleTab.prototype.removePlayer = function (player) {
    if (this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_5__frontend__["default"].players.removePlayer(player);
    }
};

BattleTab.prototype.updatePokeData = function(spot) {
    var $poke = this.$poke(spot);
    var poke = this.pokes[spot];

    $poke.find(".pokemon_name").text(poke.name);
    $poke.find(".battle-stat-value").text(poke.percent + "%");
    var $prog = $poke.find(".battle-stat-progress");
    $prog.removeClass("battle-stat-progress-1x battle-stat-progress-2x battle-stat-progress-3x battle-stat-progress-4x");
    $prog.addClass("battle-stat-progress-" + (Math.floor(poke.percent*4/100.1)+1) + "x");
    $prog.css("width", poke.percent + "%");

    if (this.isBattle() && this.player(spot) == this.myself) {
        for (var i = 0; i < 4; i++) {
            this.updateMove(i, poke.moves[i]);
        }
    }
};

BattleTab.prototype.updateMove = function(num, move) {
    var $move = this.$content.find("#move-"+num);
    $move[0].className = '';
    $move.addClass("click_button");
    $move.addClass("type_"+__WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].type(move.move));
    $move.find(".battle-move-name").text(__WEBPACK_IMPORTED_MODULE_9__pokeinfo__["f" /* MoveInfo */].name(move.move));
    $move.find(".battle_move_pp").text(move.pp + "/" + move.totalpp + " PP");
};

BattleTab.prototype.effects = function(spot, effect) {
    if (typeof effect == "object") {
        return __WEBPACK_IMPORTED_MODULE_9__pokeinfo__["a" /* PokeInfo */].spriteData(effect, {"back":spot==0});
    } else {
        return BattleTab.effects[effect] || BattleTab.effects.none;
    }
};

/* Basic position of the pokemon sprite */
BattleTab.prototype.pos = function(spot, effect) {
    var wh = this.effects(spot, effect);

    if (spot == 0) {
        return {"bottom":"103" - wh.h/2,"left":"105" - wh.w / 2, "transform": "scale(1.5)"};
    } else {
        return {"top":"140" - wh.h/2,"right":"105" - wh.w / 2};
    }
};

BattleTab.prototype.setPos = function(img, spot, effect) {
    var p = this.pos(spot, effect);
    img.css(p);
    img.spot = spot;
    var wh = this.effects(spot, effect);
    img.w = wh.w;
    img.h = wh.h;
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pokeinfo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__battleconstants__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = CommandHandling;



function CommandHandling(){

}

/* dealWithXxxx functions are all called from dealWithCommand */
CommandHandling.dealWithTurn = function(params) {
    this.print("<h2>Turn " + params.turn + "</h2>", {"css": "turn"});
    this.trigger("turn", params.turn);
};

CommandHandling.dealWithBlank = function(/* params */) {
    this.print("");

    var self = this;

    if (this.speed < 10) {
        this.pause();
        setTimeout(function(){self.unpause();}, 600*this.speed);
    }
};

CommandHandling.dealWithSend = function(params) {
    var poke = params.pokemon;
    var sl = this.slot(params.spot);
    var player = this.player(params.spot);

    poke = Object.assign({}, this.teams[player][params.slot], poke);
    if (this.isBattle() && this.player(params.spot) == this.myself) {
        /* Don't update team poke with info from poke - could be fooled by
          zoroark etc. */
    } else {
        Object.assign(this.teams[player][params.slot], poke);
    }
    /* Stores the pokemon in field memory */
    this.pokes[params.spot] = poke;

    /* switch in memory */
    var tmp = this.teams[player][params.slot];
    this.teams[player][params.slot] = this.teams[player][sl];
    this.teams[player][sl] = tmp;

    //this.animator.on("send", params.spot);

    this.updateFieldPoke(params.spot);
    this.updateTeamPokes(player, [this.slot(params.spot), params.slot]);

    this.trigger("sendout", params.spot);

    if (__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(poke) == poke.name) {
        this.print(this.name(player) + " sent out " + poke.name + "!");
    } else {
        this.print(this.name(player) + " sent out " + poke.name + "! (" + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(poke) + ")");
    }
};

CommandHandling.dealWithSendback = function(params) {
    var poke = this.pokes[params.spot];
    var pl = this.player(params.spot);

    //this.animator.on("sendback", params.spot);

    if (pl == this.myself) {
        var moves = this.teams[pl][params.spot].moves;
        for (var i in moves) {
            moves[i].tempmove = 0;
            moves[i].temppp = 0;
        }
    }

    if (!params.silent) {
        this.print(this.name(pl) + " called " + poke.name + " back!");
    }

    this.trigger("sendback", params.spot);
};

CommandHandling.dealWithVanish = function(params) {
    this.pokes[params.spot].hidden = true;

    this.trigger("vanish", params.spot);
};

CommandHandling.dealWithReappear = function(params) {
    this.pokes[params.spot].hidden = false;

    this.trigger("reappear", params.spot);
};

/* Transform I guess, only affects poke on the field */
CommandHandling.dealWithSpritechange = function(params) {
    this.pokes[params.spot].sprite = params.sprite;

    this.trigger("spritechange", params.spot);
};

/* Cosmetic forme change, only affects poke on the field */
CommandHandling.dealWithSubformechange = function(params) {
    var newNum = this.pokes[params.spot].num + (1 << params.subforme);
    this.pokes[params.spot].sprite = newNum;

    this.trigger("spritechange", params.spot);
};

/* Definite change of the poke even in the team */
CommandHandling.dealWithFormechange = function(params) {
    var pokeObject = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].toObject(params.newforme);
    Object.assign(this.teams[params.player][params.slot], pokeObject);
    Object.assign(this.pokes[this.spot(params.player,params.slot)], pokeObject);

    this.updateTeamPokes(params.player, [params.slot]);

    this.trigger("spritechange", this.spot(params.player, params.spot));
};

CommandHandling.dealWithTeampreview = function(params) {
    var team = params.team;
    // var player = params.player;

    var yourTeam = [];
    var oppTeam = [];
    for (var i = 0; i< 6; i++) {
        if (this.teams[this.myself][i].num) {
            yourTeam.push(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(this.tpoke(this.myself, i)));
        }
        if (team[i] && team[i].num) {
            oppTeam.push(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(team[i]));
        }
    }

    this.print("<strong>Your team: </strong>" + yourTeam.join(" / "));
    this.print("<strong>Opponent's team: </strong>" + oppTeam.join(" / "));
    this.print("");

    /* triggers the choice */
    this.teamPreview = true;

    this.trigger("teampreview", this.teams[this.myself], team);
};

CommandHandling.dealWithPpchange = function(params) {
    this.teams[this.player(params.spot)][this.slot(params.spot)].moves[params.move].pp = params.pp;

    this.trigger("ppchange", params);
};

CommandHandling.dealWithPpuse = function(params) {
    /* params: amount - the new PP, move - the move used, spot - the poke */
    this.trigger("ppuse", params);
}

CommandHandling.dealWithMovechange = function(params) {

    var poke = this.teams[this.myself][params.spot];

    if (params.temporary) {
        poke.moves[params.slot].tempmove = params.move;
        poke.moves[params.slot].temppp = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].pp(params.move);
    } else {
        poke.moves[params.slot].move = params.move;
    }
};

CommandHandling.dealWithOfferchoice = function(params) {
    /* Deal with outdated relays */
    if (params.choice.zmove && !params.choice.zattacks) {
        params.choice.zattacks = [true,true,true,true];
    }
    this.choices[params.choice.slot] = params.choice;
};

CommandHandling.dealWithKo = function(params) {
    //this.animator.on("ko", params.spot);
    this.print("<strong>" + this.nick(params.spot) + " fainted!</strong>");

    this.pokes[params.spot].status = 31; //ko

    this.trigger("ko", params.spot);
};

CommandHandling.dealWithMove = function(params) {
    if (!params.silent) {
        this.print("<span class='use-battle-move'>" + this.nick(params.spot) + " used <strong class='battle-message-" + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["e" /* TypeInfo */].name(__WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].type(params.move)).toLowerCase() + "'>" + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].name(params.move) + "</strong>!</span>");
    }

    //this.animator.on("attack", params.spot, params.move);
};

CommandHandling.dealWithHpchange = function(params) {
    /* Checks & updates the pokemon in memory's life percent */
    var current = this.pokes[params.spot].percent;
    if (this.pokes[params.spot].life) {
        this.pokes[params.spot].life = params.newHP;
        this.pokes[params.spot].percent = Math.floor(params.newHP/this.pokes[params.spot].totalLife*100);
        this.tpoke(params.spot).life = params.newHP;
        this.tpoke(params.spot).percent = Math.floor(params.newHP/this.pokes[params.spot].totalLife*100);
    } else {
        this.tpoke(params.spot).percent = params.newHP;
        this.pokes[params.spot].percent = params.newHP;
    }

    this.updateTeamPokes(this.player(params.spot), [this.slot(params.spot)]);
    /* Is it healing or damage? */
/*    if (params.newHP > current || params.newHP == (this.pokes[params.spot].totalLife || 100)) {
        this.addCommand(["-heal", this.spotToPlayer(params.spot), this.pokemonDetails(this.pokes[params.spot])], this.damageCause);
    } else {
        this.addCommand(["-damage", this.spotToPlayer(params.spot), this.pokemonDetails(this.pokes[params.spot])], this.damageCause);
    }
    this.damageCause = {};
    */
    //this.animator.on("hpchange", params.spot, current, this.pokes[params.spot].percent);
    var change = current - this.pokes[params.spot].percent;
    /* Woudln't something with old & new HP be more prudent, like the commented line above? */
    this.trigger("hpchange", params.spot, change);
};

CommandHandling.dealWithHitcount = function(params) {
    this.print("Hit " + params.count + " time(s)!");
};

CommandHandling.dealWithEffectiveness = function(params) {
    if (params.effectiveness > 4) {
        this.print("<span class='battle-message-super'>It's super effective!</span>");
    } else if (params.effectiveness < 4 && params.effectiveness > 0) {
        this.print("<span class='battle-message-notvery'>It's not very effective...</span>");
    } else if (params.effectiveness === 0) {
        this.print("It had no effect on " + this.nick(params.spot) + "!");
    }
};

CommandHandling.dealWithCritical = function(/* params */) {
    this.print("<span class='battle-message-crit'>A critical hit!</span>");
};

CommandHandling.dealWithMiss = function(params) {
    this.print("The attack of "+ this.nick(params.spot) +" missed!");
};

CommandHandling.dealWithAvoid = function(params) {
    this.print(this.nick(params.spot) +" avoided the attack!");
};

CommandHandling.dealWithBoost = function(params) {
    if (params.silent) {
        return;
    }
    if (params.boost > 6) {
        this.print(this.nick(params.spot) +"'s " + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["i" /* StatInfo */].name(params.stat) + " drastically rose!");
    } else if (params.boost > 0) {
        this.print(this.nick(params.spot) +"'s " + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["i" /* StatInfo */].name(params.stat) + (params.boost > 1 ? (params.boost > 2 ? " drastically " : " sharply ") : "") + " rose!");
    } else if (params.boost < 0) {
        this.print(this.nick(params.spot) +"'s " + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["i" /* StatInfo */].name(params.stat) + (-params.boost > 1 ? (-params.boost > 2 ? " drastically " : " sharply ") : "") + " fell!");
    }
    //this.damageCause = {};
};

CommandHandling.dealWithDynamicinfo = function(params) {
    this.pokes[params.spot].boosts = params.boosts;
    this.pokes[params.spot].fieldState = params.fieldflags;
};

CommandHandling.dealWithStats = function(params) {
    this.pokes[params.spot].stats = params.stats;
};

CommandHandling.dealWithStatus = function(params) {
    if (params.status === 6) {
        this.print("<span class='battle-message-confusion'>%1 became confused!</span>".replace("%1", this.nick(params.spot)));
        return;
    }
    if (params.status === 0) {
        this.trigger("statuschange", params.spot, params.status);
        return;
    }
    var status = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].statuses[params.status];
    if (!status || status == "fnt") {
        return;
    }
    if (status == "psn" && params.multiple) {
        status = "tox";
    }

    var messages = [
        "",
        "%1 is paralyzed! It may be unable to move!",
        "%1 fell asleep!",
        "%1 was frozen solid!",
        "%1 was burned!",
        "%1 was poisoned!",
        "%1 was badly poisoned!"
    ];

    this.pokes[params.spot].status = params.status;
    this.tpoke(params.spot).status = params.status;

    var message = messages[params.status + (status == "tox" ? 1 : 0)].replace("%1", this.nick(params.spot));
    this.print("<span class='battle-message-" + (status == "tox" ? "psn" : status) + "'>" + message + "</span>");

    this.trigger("statuschange", params.spot, params.status);
    //this.damageCause = {};
};

CommandHandling.dealWithTeamstatus = function(params) {
    this.teams[params.player][params.slot].status = params.status;

    this.updateTeamPokes(params.player, [params.slot]);
};

CommandHandling.dealWithAlreadystatus = function(params) {
    var status = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].statuses[params.status];

    this.print("<span class='battle-message-" + (status == "tox" ? "psn" : status) + "'>" + this.nick(params.spot) + " is already " + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["j" /* StatusInfo */].name(params.status) + ".</span>");
};

CommandHandling.dealWithFeelstatus = function(params) {
    if (params.status == 6) { //confusion
        this.print("<span class='battle-message-confusion'>" + this.nick(params.spot) + " is confused!</span>");
    } else {
        var status = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].statuses[params.status];
        if (status == "par") {
            this.print("<span class='battle-message-par'>" + this.nick(params.spot) + " is paralyzed!</span>");
        } else if (status == "slp") {
            this.print("<span class='battle-message-slp'>" + this.nick(params.spot) + " is fast asleep!</span>");
        } else if (status == "frz") {
            this.print("<span class='battle-message-frz'>" + this.nick(params.spot) + " is frozen solid!</span>");
        }
    }
};

CommandHandling.dealWithStatusdamage = function(params) {
    if (params.status == 6) {
        this.print("<span class='battle-message-confusion'>It hurt itself in its confusion!</span>");
    } else {
        var status = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].statuses[params.status];

        if (status == "brn") {
            this.print("<span class='battle-message-brn'>" + this.nick(params.spot) + " was hurt by its burn!</span>");
        } else if (status == "psn") {
            this.print("<span class='battle-message-psn'>" + this.nick(params.spot) + " was hurt by poison!</span>");
        }
    }
    //this.damageCause.from = BattleConstants.statuses[params.status];
};

CommandHandling.dealWithFreestatus = function(params) {
    if (params.status == 6) { //confusion
        this.print("<span class='battle-message-statusover'>" + this.nick(params.spot) + " snapped out its confusion.</span>");
    } else {
        var status = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].statuses[params.status];
        if (status == "slp") {
            this.print("<span class='battle-message-statusover'>" + this.nick(params.spot) + " woke up!</span>");
        } else if (status == "frz") {
            this.print("<span class='battle-message-statusover'>" + this.nick(params.spot) + " thawed out!</span>");
        }
    }
};

CommandHandling.dealWithFail = function(params) {
    if (!params.silent) {
        this.print("But it failed!");
    }
};

CommandHandling.dealWithClauseactivated = function(params) {
    this.print(__WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].clauseTexts[params.clause]);
};

CommandHandling.dealWithPlayerchat = function(params) {
    this.print(params.message, {"player": params.spot});
};

CommandHandling.dealWithSpectatorjoin = function(params) {
    this.spectators[params.id] = params.name;
    this.print(params.name + " is watching the battle.");
    this.trigger("playeradd", params.id);
};

CommandHandling.dealWithSpectatorleave = function(params) {
    this.print(this.spectators[params.id] + " stopped watching the battle.");
    delete this.spectators[params.id];

    this.trigger("playerremove", params.id);
};

CommandHandling.dealWithSpectatorchat = function(params) {
    this.print(params.message, {"spectator": params.id});
};

CommandHandling.dealWithNotice = function(params) {
    this.print(params.content);
};

CommandHandling.dealWithClock = function(params) {
    this.updateClock(params.player, params.time, params.status == "ticking");
};

CommandHandling.dealWithNotarget = function(/* params */) {
    this.print("But there was no target...");
};

CommandHandling.dealWithFlinch = function(params) {
    this.print(this.nick(params.spot) + " flinched and couldn't move!");
};

CommandHandling.dealWithRecoil = function(params) {
    //this.damageCause.from = "recoil";
    this.print(this.nick(params.spot) + " is damaged by recoil!");
};

CommandHandling.dealWithDrain = function(params) {
    //this.damageCause.from = "drain";
    //this.damageCause.of = this.spotToPlayer(params.spot);
    this.print(this.nick(params.spot) + " had its energy drained!");
};

CommandHandling.dealWithWeatherstart = function(params) {
    var weather = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].weathers[params.weather];

    var weatherAbilityMessage = [
        "%1's Snow Warning whipped up a hailstorm!",
        "%1's Drizzle made it rain!",
        "%1's Sand Stream whipped up a sandstorm!",
        "%1's Drought intensified the sun's rays!",
        "%1's Desolate Land turned the sunlight extremely harsh!",
        "%1's Primordial Sea causes a heavy rain to fall!",
        "%1's Delta Stream stirs up a mysterious air current to protect Flying-type Pokémon!"
    ];

    var weatherRegularMessage = [
        "It started to hail!",
        "It started to rain!",
        "A sandstorm kicked up!",
        "The sunlight turned harsh!"
    ];

    if (params.permanent) {
        this.print("<span class='battle-message-" + weather + "'>" + weatherAbilityMessage[params.weather-1].replace("%1", this.nick(params.spot)) + "</span>");
    } else {
        this.print("<span class='battle-message-" + weather + "'>" + weatherRegularMessage[params.weather-1] + "</span>");
    }

    /* Hack to remove new weathers since it makes battle window crash */
    if (params.weather > 4) {
        if (params.weather == 5) params.weather = 4;
        if (params.weather == 6) params.weather = 2;
    }
    if (params.weather <= 4) {
        this.trigger("weather", params.weather);
    }
};

CommandHandling.dealWithFeelweather = function(params) {
    var weather = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].weathers[params.weather];

    var messages = [
        "The hail crashes down.",
        "Rain continues to fall.",
        "The sandstorm rages.",
        "The sunlight is strong.",
        "The intense sunlight continues to shine.",
        "The heavy downpour continues.",
        "A mysterious air current is protecting Flying-type Pokémon."
    ];

    this.print("<span class='battle-message-" + weather + "'>" + messages[params.weather -1] + "</span>");

    weather = params.weather;
    if (weather > 4) {
        if (weather == 5) weather = 4;
        if (weather == 6) weather = 2;
    }
    if (weather <= 4) {
        this.trigger("weather", weather);
    }
};

CommandHandling.dealWithWeatherend = function(params) {
    var weather = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].weathers[params.weather];

    var messages = [
        "The hail stopped.",
        "The rain stopped.",
        "The sandstorm subsided.",
        "The sunlight faded.",
        "The harsh sunlight faded.",
        "The heavy rain has lifted!",
        "The mysterious air current has dissipated!"
    ];

    this.print("<span class='battle-message-" + weather + "'>" + messages[params.weather -1] + "</span>");
};

CommandHandling.dealWithWeatherhurt = function(params) {
    //this.damageCause.from = BattleConstants.weathers[params.weather];
    var weather = __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].weathers[params.weather];

    var messages = [
        "%1 is buffeted by the hail!",
        undefined,
        "%1 is buffeted by the sandstorm!",
        undefined,
        undefined,
        undefined,
        undefined
    ];

    if (messages[params.weather -1]) {
        this.print("<span class='battle-message-" + weather + "'>" + messages[params.weather -1].replace("%1", this.nick(params.spot)) + "</span>");
    }
};

CommandHandling.dealWithSubstitute = function(params) {
    this.pokes[params.spot].substitute = params.substitute;

    this.trigger("substitute", params.spot, params.substitute);
};

CommandHandling.dealWithDamage = function(params)
{
    if (!this.isBattle(this.player(params.spot))) {
        this.print(this.nick(params.spot) + " lost " + params.damage + "% of its health!");
    } else {
        this.print(this.nick(params.spot) + " lost " + params.damage + " HP! (" +
            Math.floor(params.damage*100/this.tpoke(params.spot).totalLife) + "% of its health)!");
    }
};

CommandHandling.dealWithTier = function(params) {
    if (this.dealtWithTier) {
        return;
    }
    this.dealtWithTier = true;

    this.print("<strong>Tier: </strong> " + params.tier);

    this.tier = params.tier;
    this.trigger("tier", params.tier);
};

CommandHandling.dealWithRated = function(params) {
    if (this.dealtWithRated) {
        return;
    }
    this.dealtWithRated = true;

    this.print("<strong>Rule: </strong> " + (params.rated ? "Rated" : "Unrated"));

    /* Print the clauses, convert flags to actual clause numbers */
    var clauses = this.conf.clauses;
    var i = 0;

    while (clauses > 0) {
        if (clauses % 2) {
            this.print("<strong>Rule: </strong> " + __WEBPACK_IMPORTED_MODULE_1__battleconstants__["b" /* default */].clauses[i]);
        }
        clauses = Math.floor(clauses/2);
        i = i+1;
    }
};

CommandHandling.dealWithRule = function(params) {
    this.print("<strong>" + params.rule + ": </strong> " + params.content);
};

CommandHandling.dealWithChoiceselection = function(params) {
    if (this.isBattle() && this.player(params.spot) == this.myself) {
        this.choicesAvailable = true;
        this.trigger("choicesavailable");
    }
};

/* When we send a wrong choice */
CommandHandling.dealWithChoicecancellation = function(params) {
    if (this.isBattle() && params.player == this.myself) {
        this.choicesAvailable = true;
        this.trigger("choicesavailable");
    }
};

/*
 Forfeit,
 Win,
 Tie,
 Close
 */
CommandHandling.dealWithBattleend = function(params) {
    if (params.result == 0) {
        this.print("<strong>" + this.name(!params.winner) + " forfeited against " + this.name(params.winner) + "!</strong>");
    } else if (params.result == 1) {
        this.print("<strong>" + this.name(params.winner) + " won the battle!</strong>");
    } else if (params.result == 2) {
        this.print("<strong>Tie between " + this.name(0) + " and " + this.name(1) + "!</strong>");
    } else if (params.result == 3) {
        this.print("<strong>One of the players left the battle.</strong>");
    }
};

CommandHandling.dealWithVariation = function(params) {
    this.print("<strong>Variation: </strong>" + params.bonus + ", " + params.malus);
};

CommandHandling.dealWithDisconnect = function(params) {
    this.print(this.name(params.player) + " disconnected.");
};

CommandHandling.dealWithReconnect = function(params) {
    this.print(this.name(params.player) + " reconnected.");
};

CommandHandling.dealWithItemmessage = function(params) {
    /* Item like Potion used on a pokemon we haven't seen */
    if (this.pokes[params.foe].num == 0 || this.pokes[params.spot].num == 0) {
        return;
    }
    var mess = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["b" /* ItemInfo */].message(params.item, params.part);
    if (!mess) {
        return;
    }
    if (mess.contains("%st")) mess = mess.replace("%st", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["i" /* StatInfo */].name(params.other, this.conf.gen));
    if (mess.contains("%s")) mess = mess.replace("%s", this.nick(params.spot));
    if (mess.contains("%f")) mess = mess.replace("%f", this.nick(params.foe));
    if (mess.contains("%i")) mess = mess.replace("%i", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["b" /* ItemInfo */].name(params.berry));
    if (mess.contains("%m")) mess = mess.replace("%m", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].name(params.other));
    if (mess.contains("%p")) mess = mess.replace("%p", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(params.other));

    /* Balloon gets a really special treatment */
    if (params.item == 35)
        this.print("<strong>" + mess + "</strong>");
    else
        this.print(mess);
};

CommandHandling.dealWithMovemessage = function(params) {
    var mess = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].message(params.move, params.part);
    if (!mess) {
        return;
    }
    if (mess.contains("%s")) mess = mess.replace("%s", this.nick(params.spot));
    if (mess.contains("%ts")) mess = mess.replace("%ts", this.name(params.spot));
    if (mess.contains("%tf")) mess = mess.replace("%tf", this.name(1-params.spot));
    if (mess.contains("%t")) mess = mess.replace("%t", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["e" /* TypeInfo */].name(params.type));
    if (mess.contains("%f")) mess = mess.replace("%f", this.nick(params.foe));
    if (mess.contains("%m")) mess = mess.replace("%m", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].name(params.other));
    if (mess.contains("%d")) mess = mess.replace("%d", params.other);
    if (mess.contains("%q")) mess = mess.replace("%q", params.data);
    if (mess.contains("%i")) mess = mess.replace("%i", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["b" /* ItemInfo */].name(params.other));
    if (mess.contains("%a")) mess = mess.replace("%a", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["h" /* AbilityInfo */].name(params.other));
    if (mess.contains("%p")) mess = mess.replace("%p", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(params.other));

    this.print("<span class='battle-message-" + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["e" /* TypeInfo */].name(params.type).toLowerCase() + "'>" + mess + "</span>");
};

CommandHandling.dealWithAbilitymessage = function(params) {
    var mess = __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["h" /* AbilityInfo */].message(params.ability, params.part);
    if (!mess) {
        return;
    }
    if (mess.contains("%st")) mess = mess.replace("%st", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["i" /* StatInfo */].name(params.other, this.conf.gen));
    if (mess.contains("%s")) mess = mess.replace("%s", this.nick(params.spot));
    //            mess.replace("%ts", data()->name(spot));
    if (mess.contains("%tf")) mess = mess.replace("%tf", this.name(!params.spot));
    if (mess.contains("%t")) mess = mess.replace("%t", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["e" /* TypeInfo */].name(params.type));
    if (mess.contains("%f")) mess = mess.replace("%f", this.nick(params.foe));
    if (mess.contains("%m")) mess = mess.replace("%m", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["f" /* MoveInfo */].name(params.other));
    //            mess.replace("%d", QString::number(other));
    if (mess.contains("%i")) mess = mess.replace("%i", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["b" /* ItemInfo */].name(params.other));
    if (mess.contains("%a")) mess = mess.replace("%a", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["h" /* AbilityInfo */].name(params.other));
    if (mess.contains("%p")) mess = mess.replace("%p", __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["a" /* PokeInfo */].name(params.other));

    /* if (type == 0) {
        printLine("AbilityMessage", escapeHtml(tu(mess)));
    } else {
        printHtml("AbilityMessage", toColor(escapeHtml(tu(mess)),theme()->typeColor(type)));
    } */

    if (params.type != 0) {
        this.print("<span class='battle-message-" + __WEBPACK_IMPORTED_MODULE_0__pokeinfo__["e" /* TypeInfo */].name(params.type).toLowerCase() + "'>" + mess + "</span>");
    } else {
        this.print(mess);
    }
};


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__postorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__webclient__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = ChannelHolder;




function ChannelData(id, name) {
    __WEBPACK_IMPORTED_MODULE_0_riot_observable___default()(this);

    this.players = {};
    this.name = name || "";
    this.id = id;
}

ChannelData.prototype.setPlayers = function(ids) {
    this.loadingPlayers = true;

    for (var x in ids) {
        this.newPlayer(ids[x]);
    }

    this.loadingPlayers = false;
    this.trigger("setplayers", ids);
};

ChannelData.prototype.newPlayer = function(id) {
    if (id in this.players) {
        return;
    }

    this.players[id] = true;
    this.trigger("playeradd", id);
};

ChannelData.prototype.removePlayer = function(id) {
    if (! (id in this.players)) {
        return;
    }

    delete this.players[id];
    this.trigger("playerremove", id);

    if (id === __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].ownId) {
        __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].channels.leaveChannel(this.id);
    }
};

ChannelData.prototype.changeName = function(name) {
    this.name = name;
    this.trigger("changename", name);
};

function ChannelHolder() {
    __WEBPACK_IMPORTED_MODULE_0_riot_observable___default()(this);

    this.joinedChannels = [];
    this.channels = {};
    this.channelCount = 0;
    this.names = {}; // id -> name
    this.byName = {}; // name -> id

    this.newChannel(0, 'Main Channel');
}

ChannelHolder.prototype.channel = function (id) {
    if (id === -1 || !(id in this.channels)) {
        return null;
    }
    return this.channels[id];
};

ChannelHolder.prototype.name = function(id) {
    return this.names[id];
};

ChannelHolder.prototype.hasChannel = function (id) {
    return id in this.channels;
};

ChannelHolder.prototype.updateAutoJoin = function() {
    var names = [];
    for (var i in this.joinedChannels) {
        var id = this.joinedChannels[i];
        if (id !== 0) {
            names.push(this.name(id));
        }
    }

    __WEBPACK_IMPORTED_MODULE_1__postorage__["a" /* default */].set("auto-join-"+ __WEBPACK_IMPORTED_MODULE_2__webclient__["a" /* default */].serverIP, names);
};

ChannelHolder.prototype.setNames = function (names) {
    var i;

    this.names = names;
    this.byName = {};
    for (i in this.names) {
        this.byName[this.names[i]] = i;
    }

    // Updating already existing channels if needed
    for (i in this.channels) {
        if ((i in names) && this.channel(i).name !== names[i]) {
            this.channel(i).changeName(names[i]);
        }
    }

    for (i in this.names) {
        if (!(i in this.channels)) {
            this.newChannel(i, this.names[i]);
        }
    }

    this.trigger("nameslist", Object.keys(names));
    //webclient.ui.channellist.setChannels(Object.keys(names));
};

ChannelHolder.prototype.changeChannelName = function (id, name) {
    if (!(id in this.names)) {
        this.newChannel(id, name);
        return;
    }

    delete this.byName[this.names[id]];
    this.names[id] = name;
    this.byName[name] = id;

    if (id in this.channels) {
        this.channels[id].changeName(name);
    }

    this.trigger("changename", id);
};

ChannelHolder.prototype.newChannel = function (id, name) {
    this.channels[id] = new ChannelData(id, name);
    this.names[id] = name;
    this.byName[name] = id;

    this.channelCount += 1;

    this.trigger("newchannel", id);
    //webclient.ui.channellist.addChannel(id);
};

ChannelHolder.prototype.removeChannel = function(id) {
    if (!(id in this.channels)) {
        console.log("Cannot destroy nonexistent channel: " + id);
        return;
    }

    delete this.channels[id];
    delete this.byName[this.names[id]];
    delete this.names[id];

    this.trigger("channeldestroyed", id);
    //webclient.ui.channellist.removeChannel(id);
};

ChannelHolder.prototype.joinChannel = function(id) {
    if (this.joinedChannels.indexOf(id) < 0) {
        console.log("joining channel", id);
        this.joinedChannels.push(id);
        if (id !== 0) {
            this.updateAutoJoin();
        }
        this.trigger("joinchannel", id);
    } else {
        console.log("Channel already joined: " + id);
    }
};

ChannelHolder.prototype.channelsByName = function(lowercase) {
    var o = [];
    for (var name in this.byName) {
        o.push(lowercase ? name.toLowerCase() : name);
    }
    return o;
};

ChannelHolder.prototype.leaveChannel = function(id) {
    id = +id;
    var index = this.joinedChannels.indexOf(id);
    if (index > -1) {
        this.joinedChannels.splice(index, 1);
        this.updateAutoJoin();
        this.trigger("leavechannel", id);
    } else {
        console.log("Channel not joined: " + id);
    }
};


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basetab__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chat__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_riot_observable__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ChannelTab;










function ChannelTab(id, name) {
    console.log("open channel", id, name);
    __WEBPACK_IMPORTED_MODULE_6_riot_observable___default()(this);

    this.shortHand = "channel";
    this.id = id;
    this.name = name;
    this.players = {};

    var self = this;

    /* We can close a channel tab only if the client decided to close the channel,
      and the server kicked us out of the channel / destroyed the channel.

      We keep track with this variable. */
    this.closable = 0; // 1 = Server close, 2=Player close

    this.channel = __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].channels.channel(id);

    if (!__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].currentTab) {
        __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].currentTab = this;
    }

    this.channel.off("*");
    this.channel.on("setplayers", function(ids) {self.setPlayers(ids);});
    this.channel.on("playeradd", function(id) {self.newPlayer(id);});
    this.channel.on("playerremove", function(id) {self.removePlayer(id);});
    this.channel.on("changename", function(name) {self.changeName(name);});
    // var $chan = $("#channel-" + id);
    // if ($chan.length === 0 || $chan.data('initialized') === false) {
    //     /* Create new tab */
    //     if ($chan.length === 0) {
    //         $('#channel-tabs').tabs("add", "#channel-" + id, webclient.classes.BaseTab.makeName(name || ("channel " + id)));
    //     }

    //     this.chat = new webclient.classes.Chat('send-channel-' + id);
    //     this.chat.appendTo($("#channel-" + id));
    //     $chan.data('initialized', true);
    // }
    this.chat = new __WEBPACK_IMPORTED_MODULE_2__chat__["b" /* default */]();
    this.addTab(this.chat.element);

    this.chat.on("chat", this.sendMessage.bind(this));
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* inherits */])(ChannelTab, __WEBPACK_IMPORTED_MODULE_1__basetab__["a" /* default */]);

ChannelTab.prototype.onSetCurrent = function() {
    this.chat.scrollDown();
};

ChannelTab.prototype.close = function() {
    this.trigger("close");
    this.removeTab();
};

ChannelTab.prototype.getPlayers = function() {
    return Object.keys(this.channel.players);
};

ChannelTab.prototype.setPlayers = function (players) {
    // var len, id, i;

    // /* The server 'unclosed' us, so removing server close if there */
    // this.closable &= ~1;

    // this.players = {};

    // for (i = 0, len = players.length; i < len; i += 1) {
    //     id = players[i];
    //     this.players[id] = true;
    // }

    // this.trigger("setplayers");

    if (this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].players.setPlayers(players);
    }
};

ChannelTab.prototype.newPlayer = function (player) {
    //this.players[player] = true;

    if (player != __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].ownId && __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.chanEventsEnabled(this.channel.id) && !this.channel.loadingPlayers) {
        this.printHtml('<span class="player-join">' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.name(player)) + ' joined the channel.');
    }

    if (this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].players.addPlayer(player);
    }
};

ChannelTab.prototype.removePlayer = function (player) {
    // delete this.players[player];

    // if (player === webclient.ownId) {
    //     if (this.closable & 2) {
    //         this.remove();
    //     } else {
    //         this.closable |= 1;
    //         this.print("<i>You were removed from this channel</i>", true);
    //     }
    // }

    if (__WEBPACK_IMPORTED_MODULE_3__frontend__["default"].channels.chanEventsEnabled(this.channel.id) && !this.channel.loadingPlayers) {
        this.printHtml('<span class="player-leave">' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* escapeHtml */])(__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.name(player)) + ' left the channel.');
    }

    if (this.isCurrent()) {
        __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].players.removePlayer(player);
    }
};

ChannelTab.prototype.hasPlayer = function(/* player */) {
//    return player in this.players;
};

ChannelTab.prototype.print = function (/* msg, html, raw */) {
    // var pref, id, auth;

    // if (raw !== true) {
    //     if (html) {
    //         msg = webclient.convertImages($("<div>").html(msg)).html();
    //     } else {
    //         msg = escapeHtml(msg);

    //         if (msg.substr(0, 3) === "***") {
    //             msg = "<span class='action'>" + msg + "</span>";
    //         } else if (msg.indexOf(":") !== -1) {
    //             pref = msg.substr(0, msg.indexOf(":"));
    //             id = webclient.players.id(pref);
    //             auth = webclient.players.auth(id);

    //             if (webclient.players.isIgnored(id)) {
    //                 return;
    //             }

    //             if (pref === "~~Server~~") {
    //                 pref = "<span class='server-message'>" + pref + ":</span>";
    //             } else if (pref === "Welcome Message") {
    //                 pref = "<span class='welcome-message'>" + pref + ":</span>";
    //             } else if (id === -1) {
    //                 pref = "<span class='script-message'>" + pref + ":</span>";
    //             } else {
    //                 this.shown[id] = true;
    //                 pref = "<a href='po:info/" + id + "'><span class='player-message' style='color: " + webclient.players.color(id) + "' oncontextmenu='return false'>" + rank(auth) + rankStyle(pref + ":", auth) + "</span></a>";
    //                 this.activateTab();
    //             }

    //             msg = pref + addChannelLinks(msg.slice(msg.indexOf(":") + 1), webclient.channels.channelsByName(true));
    //         }
    //     }
    // }

    // this.chat.insertMessage(msg, {
    //     timestamps: true,
    //     timestampCheck: 'chat.timestamps',
    //     html: html,
    //     linebreak: true
    //  });
};

ChannelTab.prototype.printHtml = function(html) {
    this.printMessage(html, true);
};

ChannelTab.prototype.printMessage = function(msg, html) {
    var flash = false;
    var useTimeStamps = true;

    var ownname = __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].ownName();
    if (ownname !== "???") { //Because webclient.ownName() returns "???" when starting up the client and that messes with the RegExp
        var ex = new RegExp("\\b" + ownname + "\\b", "gi");
        if (ex.test(msg.indexOf(":") !== -1 ? msg.substr(msg.indexOf(":")) : msg)) {
            this.flashTab();
            flash = true;

            /* When flashed, also display a notification */
            if (!window.isActive) {
                if ("Notification" in window) {
                    new window.Notification("In #"+this.name + ": ", {body: html ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* stripHtml */])(msg): msg});
                }
            }
        }
    }
    if (html) {
        useTimeStamps = msg.includes("<timestamp");
        msg = __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].convertImages(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div>").html(msg)).html();
    } else {
        msg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* escapeHtml */])(msg);

        if (msg.substr(0, 3) === "***") {
            msg = "<span class='action'>" + msg + "</span>";
        } else if (msg.indexOf(":") !== -1) {
            var pref = msg.substr(0, msg.indexOf(":"));
            var id = __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.id(pref);

            var auth = __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.auth(id);

            if (__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.isIgnored(id)) {
                return;
            }

            if (pref === "~~Server~~") {
                pref = "<span class='server-message'>" + pref + ":</span>";
            } else if (pref === "Welcome Message") {
                pref = "<span class='welcome-message'>" + pref + ":</span>";
            } else if (id === -1) {
                pref = "<span class='script-message'>" + pref + ":</span>";
            } else {
                pref = "<a href='po:info/" + id + "'><span class='player-message' style='color: " + __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.color(id) + "'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* rank */])(auth) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* rankStyle */])(pref + ":", auth) + "</span></a>";
                this.activateTab();
            }

            msg = pref + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["g" /* addChannelLinks */])(msg.slice(msg.indexOf(":") + 1), __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].channels.channelsByName(true));
            //msg = pref + msg.slice(msg.indexOf(":") + 1);
        }
    }

    if (flash) {
        msg = "<mark>" + msg + "</mark>";
    }

    this.chat.insertMessage(msg, {timestamps: __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].timestamps && useTimeStamps});
    //$(".chat").html($(".chat").html() + stripHtml(msg) + "<br>");
};

ChannelTab.prototype.sendMessage = function (message) {
    __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].sendMessage(message, this.id);
};

ChannelTab.prototype.changeName = function (name) {
    this.name = name;

    // $("#channel-tabs > ul a[href=\"#channel-" + this.id + "\"]").html("<span>" + webclient.classes.BaseTab.makeName(name) + '</span>');
};

ChannelTab.prototype.disconnect = function() {
    // this.trigger("disconnect");
    // this.players = {};
};

ChannelTab.prototype.remove = function () {
    //this.trigger("remove");
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_riot_observable__);
/* harmony export (immutable) */ __webpack_exports__["a"] = PlayerHolder;



var namecolorlist = ['#5811b1', '#399bcd', '#0474bb', '#f8760d', '#a00c9e', '#0d762b', '#5f4c00', '#9a4f6d', '#d0990f', '#1b1390', '#028678', '#0324b1'];

function PlayerHolder() {
    __WEBPACK_IMPORTED_MODULE_1_riot_observable___default()(this);

    this.players = {};
    this.names = {};
    this.ignores = {};

    this.friends = [];
}

PlayerHolder.prototype.login = function (id, info) {
    var obj = {};

    obj[id] = info;

    __WEBPACK_IMPORTED_MODULE_0__webclient__["a" /* default */].ownId = id;

    this.addPlayer(obj);

    this.trigger("login", id, info);
};

PlayerHolder.prototype.hasPlayer = function (pid) {
    return pid in this.players;
};

PlayerHolder.prototype.addPlayer = function (players) {
    var playerObj,
        player, name,
        id, x;

    for (id in players) {
        player = players[id];
        name = player.name.toLowerCase();

        player.id = +id;
        playerObj = this.players[id];

        if (!playerObj) {
            this.players[id] = playerObj = player;
        } else {
            delete this.names[playerObj.name.toLowerCase()]; // Delete old names.

            /* Update only the new params */
            for (x in player) {
                playerObj[x] = player[x];
            }
        }

        this.names[name] = playerObj;
        this.trigger("playeradd", +id, playerObj, name);
        if (id == __WEBPACK_IMPORTED_MODULE_0__webclient__["a" /* default */].ownId) {
            this.trigger("ownplayerupdated", +id);
        }
    }
};

PlayerHolder.prototype.optionsChange = function(player) {
    var id = player.id;
    var playerObj = this.player(id);

    for (const x in player) {
        playerObj[x] = player[x];
    }

    if (id == __WEBPACK_IMPORTED_MODULE_0__webclient__["a" /* default */].ownId) {
        this.trigger("ownplayerupdated", +id);
    }

    this.trigger("playerupdated", +id, playerObj);
};

PlayerHolder.prototype.addFriend = function (id) {
    if (this.friends.indexOf(id) !== -1) {
        return;
    }

    this.friends.push(id);
    if (id in this.players) {
        this.players[id].friend = true;
    }

    this.trigger("friendadd", id);
};

PlayerHolder.prototype.addIgnore = function (id) {
    if (id in this.ignores) {
        return;
    }

    this.ignores[id] = true;
    if (id in this.players) {
        this.players[id].ignored = true;
    }

    this.trigger("ignoreadd", id);
};

PlayerHolder.prototype.removeIgnore = function (id) {
    if (!(id in this.ignores)) {
        return;
    }

    delete this.ignores[id];
    if (id in this.players) {
        this.players[id].ignored = false;
    }

    this.trigger("ignoreremove", id);
};

// Returns true if the player was ignored, false otherwise.
PlayerHolder.prototype.toggleIgnore = function (id) {
    if (id in this.ignores) {
        this.removeIgnore(id);
        return false;
    }

    this.addIgnore(id);
    return true;
};

PlayerHolder.prototype.isIgnored = function(id) {
    return id in this.players && this.players[id].ignored;
};

PlayerHolder.prototype.removePlayer = function (id) {
    var player = this.players[id],
        wasFriend = false;

    if (!player) {
        return;
    }

    if (this.friends.indexOf(id) !== -1) {
        this.friends.splice(this.friends.indexOf(id), 1);
        wasFriend = true;
    }

    this.trigger("playerremove", id, wasFriend);
    delete this.names[player.name.toLowerCase()];
    delete this.players[id];
};

PlayerHolder.prototype.player = function (pid) {
    var pidlc;

    if (pid in this.players) {
        return this.players[pid];
    } else if ((pidlc = (pid + "").toLowerCase()) in this.names) {
        return this.names[pidlc];
    }

    return null;
};

PlayerHolder.prototype.name = function (pid) {
    return ((pid in this.players) ? this.players[pid].name : "???");
};

PlayerHolder.prototype.auth = function (pid) {
    return ((pid in this.players) ? this.players[pid].auth : 0);
};

PlayerHolder.prototype.id = function (name) {
    let lname = name.toLowerCase();

    return (lname in this.names) ? this.names[lname].id : -1;
};

PlayerHolder.prototype.testPlayerOnline = function (player) {
    var channels = __WEBPACK_IMPORTED_MODULE_0__webclient__["a" /* default */].channels.channels,
        i;

    if (this.friends.indexOf(player) !== -1) {
        return;
    }

    for (i in channels) {
        if (player in channels[i].players) {
            return;
        }
    }

    this.removePlayer(player);
};

PlayerHolder.prototype.color = function (id) {
    var player = this.player(id);

    if (!player) {
        return "#000000";
    }

    return player.color || namecolorlist[id % namecolorlist.length];
};

PlayerHolder.prototype.away = function (id) {
    var player = this.player(id);
    return player ? player.away : false;
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pmtab__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__webclient__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = PMHolder;






function PMHolder() {
    __WEBPACK_IMPORTED_MODULE_0_riot_observable___default()(this);

    this.pms = {};
}

PMHolder.prototype.pm = function (pid, open) {
    open = open || false;
    if (pid == __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].ownId) {
        return;
    }

    var pm;
    pid = +pid;
    if (pid in this.pms) {
        return this.pms[pid];
    }

    if (__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.isIgnored(pid)) {
        return;
    }

    __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.addFriend(pid);

    pm = this.pms[pid] = new __WEBPACK_IMPORTED_MODULE_2__pmtab__["a" /* default */](pid);
    this.observe(pm);

    this.trigger("newpm", pid);

    if (open) {
        __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].switchToTab("pm-"+pid);
    } else {
        pm.flashTab();
    }

    return pm;
};

PMHolder.prototype.observe = function (pm) {
    var self = this;

    pm.on("close", function () {
        delete self.pms[pm.id];
    });
};

__WEBPACK_IMPORTED_MODULE_1_jquery___default()(function() {
    var self = __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].pms;

    __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.on("login", function (id) {
        if (id in self.pms) {
            self.pm(id).reconnect();
        }
    }).on("playerremove", function (id) {
        if (id in self.pms) {
            self.pm(id).disconnect();
        }
    });
});


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basetab__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chat__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_riot_observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_riot_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_riot_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = PMTab;










function PMTab(id) {
    __WEBPACK_IMPORTED_MODULE_5_riot_observable___default()(this);

    this.shortHand = "pm";
    this.id = id;
    __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.addFriend(id);

    this.chat = new __WEBPACK_IMPORTED_MODULE_2__chat__["b" /* default */]();
    this.addTab(this.chat.element);

    this.chat.on("chat", this.sendMessage.bind(this));
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* inherits */])(PMTab, __WEBPACK_IMPORTED_MODULE_1__basetab__["a" /* default */]);

var pmtab = PMTab.prototype;

pmtab.sendMessage = function(msg) {
    __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].sendPM(msg, this.id);
};

pmtab.onSetCurrent = function() {
    this.chat.scrollDown();
};

pmtab.name = function() {
    return __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.name(this.id);
};

pmtab.close = function() {
    this.trigger("close");
    this.removeTab();
};

pmtab.getPlayers = function() {
    return [__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].ownId, this.id];
};

pmtab.printMessage = function(id, msg) {
    this.activateTab();

    var raw = id === -1,
        auth;
    var orMsg = msg;

    if (!raw) {
        auth = __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.auth(id);
        msg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* escapeHtml */])(msg);
        msg = "<a href='po:info/" + id + "'><span class='player-message' style='color: " + __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.color(id) + "'>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* rank */])(auth) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["f" /* rankStyle */])(__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].players.name(id) + ":", auth) + "</span></a>"
            + " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["g" /* addChannelLinks */])(msg, __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].channels.channelsByName(true));

        this.activateTab();
    }

    this.chat.insertMessage(msg, {
        timestamps: __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].timestamps,
        html: raw,
        linebreak: true
    });

    if (id == this.id && !window.isActive) {
        if ("Notification" in window) {
            var notification = new window.Notification(this.name() + " says: ", {body: orMsg});
            setTimeout(function() {notification.close();}, 4000);
        }
    }
};

pmtab.reconnect = function() {
    if (this.state == "reconnected") {
        return;
    }
    this.state = "reconnected";
    let msg = "<span class='text-center pm-disconnect'><em>The player reconnected.</em></span>";
    this.chat.insertMessage(msg, {
        timestamps: __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].timestamps,
        html: true,
        linebreak: true
    });
};

pmtab.disconnect = function() {
    if (this.state == "disconnected") {
        return;
    }
    this.state = "disconnected";
    let msg = "<span class='text-center pm-disconnect'><em>The player was disconnected.</em></span>";
    this.chat.insertMessage(msg, {
        timestamps: __WEBPACK_IMPORTED_MODULE_3__frontend__["default"].timestamps,
        html: true,
        linebreak: true
    });
};

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function() {
    if ("Notification" in window) {
        window.Notification.requestPermission(function(result) {
          if (result === 'denied') {
            return;
          } else if (result === 'default') {
            return;
          }
          // Do something with the granted permission.
        });
    }
});


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vex_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vex_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vex_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontend__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__network__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__webclient__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = serverConnect;







function serverConnect(params) {
    if (__WEBPACK_IMPORTED_MODULE_3__network__["a" /* default */].isOpen()) {
        __WEBPACK_IMPORTED_MODULE_3__network__["a" /* default */].close();
    }

    params = params || {};

    var relayIP = params.relay || __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].relayIP;
    var port = params.port || __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].hostPort;

    params.onconnect = params.onconnect || function() {
        __WEBPACK_IMPORTED_MODULE_3__network__["a" /* default */].command("connect", {ip: "localhost:" + port});
    };

    __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].serverIP = relayIP;

    __WEBPACK_IMPORTED_MODULE_3__network__["a" /* default */].open(
        relayIP + ":" + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* queryField */])("rport") || __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].relayPort),
        // open
        function() {
            params.onconnect();
        },
        // error
        function() {
            if (__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].connectedToServer) {
                // closeFunction();
                return;
            }
            __WEBPACK_IMPORTED_MODULE_0_vex_js___default.a.dialog.alert({
                unsafeMessage: "Could not connect to the server. It could be offline, the address could be invalid, or you might have trouble connecting. <br><br> You will be taken back to the list of servers.",
                callback: function() {
                    document.location.href = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].registry;
                }
            });
            console.log("Failed to connect to relay.");
            __WEBPACK_IMPORTED_MODULE_3__network__["a" /* default */].close();
        },
        // close
        function() {
            if (__WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].connectedToServer) {
                __WEBPACK_IMPORTED_MODULE_2__frontend__["default"].printDisconnectionMessage();
                __WEBPACK_IMPORTED_MODULE_4__webclient__["a" /* default */].connectedToServer = false;
            }
            __WEBPACK_IMPORTED_MODULE_3__network__["a" /* default */].close();
        }
    );
}


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = pokedex => { if(!pokedex.generations)pokedex.generations={};
pokedex.generations.generations = {
1:"Generation 1",
2:"Generation 2",
3:"Generation 3",
4:"Generation 4",
5:"Generation 5",
6:"Generation 6",
7:"Generation 7"  
};
}


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = pokedex => { if(!pokedex.generations)pokedex.generations={};
pokedex.generations.options = {
1:{
	gender:false, // if this gen has gender selection
	shiny:false, // if this gen has shinies
	special_stat:true, // if this gen has a single special stat
	special_stats_same:true, // if all special stats have the same value/ivs/evs
	damage_classes_move_specific:false, // if the category of a move is specific to it or is it depending on its type
	happiness:false, // if this gen has happiness
	ivs_limit:15, // the maximum number of ivs
	hidden_power:false,
	hidden_power_bp:false,
	ability:false,
	nature:false,
	item:false,
	evs:false,
	types_ids:[0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15],
	num_pokemon: 151,
	num_moves: 165,
	sprite_folder:'yellow/'
},
2:{
	gender:true,
	shiny:true,
	special_stat:false,
	special_stats_same:true,
	damage_classes_move_specific:false,
	happiness:true,
	ivs_limit:15,
	hidden_power:true,
	hidden_power_bp:false,
	ability:false,
	nature:false,
	item:true,
	evs:false,
	types_ids:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
	num_pokemon: 251,
	num_moves: 251,
	sprite_folder:'crystal/'
},
3:{
	gender:true,
	shiny:true,
	special_stat:false,
	special_stats_same:false,
	damage_classes_move_specific:false,
	happiness:true,
	ivs_limit:31,
	hidden_power:true,
	hidden_power_bp:false,
	ability:true,
	nature:true,
	item:true,
	evs:true,
	types_ids:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
	num_pokemon: 386,
	num_moves: 353,
	sprite_folder:'firered-leafgreen/'
},
4:{
	gender:true,
	shiny:true,
	special_stat:false,
	special_stats_same:false,
	damage_classes_move_specific:true,
	happiness:true,
	ivs_limit:31,
	hidden_power:true,
	hidden_power_bp:false,
	ability:true,
	nature:true,
	item:true,
	evs:true,
	types_ids:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
	num_pokemon: 493,
	num_moves: 467,
	sprite_folder:'heartgold-soulsilver/'
},
5:{
	gender:true,
	shiny:true,
	special_stat:false,
	special_stats_same:false,
	damage_classes_move_specific:true,
	happiness:true,
	ivs_limit:31,
	hidden_power:true,
	hidden_power_bp:false,
	ability:true,
	nature:true,
	item:true,
	evs:true,
	types_ids:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
	num_pokemon: 649,
	num_moves: 559,
	sprite_folder:'black-white/',
	animated: true
},
6:{
	gender:true,
	shiny:true,
	special_stat:false,
	special_stats_same:false,
	damage_classes_move_specific:true,
	happiness:true,
	ivs_limit:31,
	hidden_power:true,
	hidden_power_bp:60,
	ability:true,
	nature:true,
	item:true,
	evs:true,
	types_ids:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
	num_pokemon: 718,
	num_moves: 607,
	sprite_folder:'x-y/',
	animated: true
},
7:{
	gender:true,
	shiny:true,
	special_stat:false,
	special_stats_same:false,
	damage_classes_move_specific:true,
	happiness:true,
	ivs_limit:31,
	hidden_power:true,
	hidden_power_bp:60,
	ability:true,
	nature:true,
	item:true,
	evs:true,
	types_ids:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
	num_pokemon: 802,
	num_moves: 701,
	sprite_folder:'s-m/',
	nosmogon: true,
	animated: false
}
};
};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = pokedex => {if(!pokedex.gens)pokedex.gens={};
pokedex.gens.versions = {
1:"Red/Blue",
65537:"Yellow",
131073:"Stadium",
196609:"Stadium w/ Tradebacks",
2:"Gold/Silver",
65538:"Crystal",
131074:"Stadium 2",
3:"Ruby/Sapphire",
65539:"Colosseum",
131075:"Fire Red/Leaf Green",
196611:"Emerald",
262147:"XD",
4:"Diamond/Pearl",
65540:"Platinum",
131076:"Heart Gold/Soul Silver",
5:"Black/White",
65541:"Black/White 2",
6:"X/Y",
65542:"Omega Ruby/Alpha Sapphire",
7:"Sun/Moon",
};
}


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = pokedex => {if(!pokedex.pokes)pokedex.pokes={};
if(!pokedex.pokes)pokedex.pokes={};
pokedex.pokes.pokemons = {
0:"Missingno",
1:"Bulbasaur",
2:"Ivysaur",
3:"Venusaur",
65539:"Mega Venusaur",
4:"Charmander",
5:"Charmeleon",
6:"Charizard",
65542:"Mega Charizard X",
131078:"Mega Charizard Y",
7:"Squirtle",
8:"Wartortle",
9:"Blastoise",
65545:"Mega Blastoise",
10:"Caterpie",
11:"Metapod",
12:"Butterfree",
13:"Weedle",
14:"Kakuna",
15:"Beedrill",
65551:"Mega Beedrill",
16:"Pidgey",
17:"Pidgeotto",
18:"Pidgeot",
65554:"Mega Pidgeot",
19:"Rattata",
65555:"Alolan Rattata",
20:"Raticate",
65556:"Alolan Raticate",
21:"Spearow",
22:"Fearow",
23:"Ekans",
24:"Arbok",
25:"Pikachu",
65561:"Pikachu-Rock Star",
131097:"Pikachu-Belle",
196633:"Pikachu-Pop Star",
262169:"Pikachu-Ph. D",
327705:"Pikachu-Libre",
393241:"Pikachu-Cosplay",
458777:"Pikachu-First Hat",
524313:"Pikachu-Second Hat",
589849:"Pikachu-Third Hat",
655385:"Pikachu-Fourth Hat",
720921:"Pikachu-Fifth Hat",
786457:"Pikachu-Sixth Hat",
26:"Raichu",
65562:"Alolan Raichu",
27:"Sandshrew",
65563:"Alolan Sandshrew",
28:"Sandslash",
65564:"Alolan Sandslash",
29:"Nidoran-F",
30:"Nidorina",
31:"Nidoqueen",
32:"Nidoran-M",
33:"Nidorino",
34:"Nidoking",
35:"Clefairy",
36:"Clefable",
37:"Vulpix",
65573:"Alolan Vulpix",
38:"Ninetales",
65574:"Alolan Ninetales",
39:"Jigglypuff",
40:"Wigglytuff",
41:"Zubat",
42:"Golbat",
43:"Oddish",
44:"Gloom",
45:"Vileplume",
46:"Paras",
47:"Parasect",
48:"Venonat",
49:"Venomoth",
50:"Diglett",
65586:"Alolan Diglett",
51:"Dugtrio",
65587:"Alolan Dugtrio",
52:"Meowth",
65588:"Alolan Meowth",
53:"Persian",
65589:"Alolan Persian",
54:"Psyduck",
55:"Golduck",
56:"Mankey",
57:"Primeape",
58:"Growlithe",
59:"Arcanine",
60:"Poliwag",
61:"Poliwhirl",
62:"Poliwrath",
63:"Abra",
64:"Kadabra",
65:"Alakazam",
65601:"Mega Alakazam",
66:"Machop",
67:"Machoke",
68:"Machamp",
69:"Bellsprout",
70:"Weepinbell",
71:"Victreebel",
72:"Tentacool",
73:"Tentacruel",
74:"Geodude",
65610:"Alolan Geodude",
75:"Graveler",
65611:"Alolan Graveler",
76:"Golem",
65612:"Alolan Golem",
77:"Ponyta",
78:"Rapidash",
79:"Slowpoke",
80:"Slowbro",
65616:"Mega Slowbro",
81:"Magnemite",
82:"Magneton",
83:"Farfetch'd",
84:"Doduo",
85:"Dodrio",
86:"Seel",
87:"Dewgong",
88:"Grimer",
65624:"Alolan Grimer",
89:"Muk",
65625:"Alolan Muk",
90:"Shellder",
91:"Cloyster",
92:"Gastly",
93:"Haunter",
94:"Gengar",
65630:"Mega Gengar",
95:"Onix",
96:"Drowzee",
97:"Hypno",
98:"Krabby",
99:"Kingler",
100:"Voltorb",
101:"Electrode",
102:"Exeggcute",
103:"Exeggutor",
65639:"Alolan Exeggutor",
104:"Cubone",
105:"Marowak",
65641:"Alolan Marowak",
106:"Hitmonlee",
107:"Hitmonchan",
108:"Lickitung",
109:"Koffing",
110:"Weezing",
111:"Rhyhorn",
112:"Rhydon",
113:"Chansey",
114:"Tangela",
115:"Kangaskhan",
65651:"Mega Kangaskhan",
116:"Horsea",
117:"Seadra",
118:"Goldeen",
119:"Seaking",
120:"Staryu",
121:"Starmie",
122:"Mr. Mime",
123:"Scyther",
124:"Jynx",
125:"Electabuzz",
126:"Magmar",
127:"Pinsir",
65663:"Mega Pinsir",
128:"Tauros",
129:"Magikarp",
130:"Gyarados",
65666:"Mega Gyarados",
131:"Lapras",
132:"Ditto",
133:"Eevee",
134:"Vaporeon",
135:"Jolteon",
136:"Flareon",
137:"Porygon",
138:"Omanyte",
139:"Omastar",
140:"Kabuto",
141:"Kabutops",
142:"Aerodactyl",
65678:"Mega Aerodactyl",
143:"Snorlax",
144:"Articuno",
145:"Zapdos",
146:"Moltres",
147:"Dratini",
148:"Dragonair",
149:"Dragonite",
150:"Mewtwo",
65686:"Mega Mewtwo X",
131222:"Mega Mewtwo Y",
151:"Mew",
152:"Chikorita",
153:"Bayleef",
154:"Meganium",
155:"Cyndaquil",
156:"Quilava",
157:"Typhlosion",
158:"Totodile",
159:"Croconaw",
160:"Feraligatr",
161:"Sentret",
162:"Furret",
163:"Hoothoot",
164:"Noctowl",
165:"Ledyba",
166:"Ledian",
167:"Spinarak",
168:"Ariados",
169:"Crobat",
170:"Chinchou",
171:"Lanturn",
172:"Pichu",
65708:"Pichu-Spiky Eared",
173:"Cleffa",
174:"Igglybuff",
175:"Togepi",
176:"Togetic",
177:"Natu",
178:"Xatu",
179:"Mareep",
180:"Flaaffy",
181:"Ampharos",
65717:"Mega Ampharos",
182:"Bellossom",
183:"Marill",
184:"Azumarill",
185:"Sudowoodo",
186:"Politoed",
187:"Hoppip",
188:"Skiploom",
189:"Jumpluff",
190:"Aipom",
191:"Sunkern",
192:"Sunflora",
193:"Yanma",
194:"Wooper",
195:"Quagsire",
196:"Espeon",
197:"Umbreon",
198:"Murkrow",
199:"Slowking",
200:"Misdreavus",
201:"Unown",
65737:"Unown-B",
131273:"Unown-C",
196809:"Unown-D",
262345:"Unown-E",
327881:"Unown-F",
393417:"Unown-G",
458953:"Unown-H",
524489:"Unown-I",
590025:"Unown-J",
655561:"Unown-K",
721097:"Unown-L",
786633:"Unown-M",
852169:"Unown-N",
917705:"Unown-O",
983241:"Unown-P",
1048777:"Unown-Q",
1114313:"Unown-R",
1179849:"Unown-S",
1245385:"Unown-T",
1310921:"Unown-U",
1376457:"Unown-V",
1441993:"Unown-W",
1507529:"Unown-X",
1573065:"Unown-Y",
1638601:"Unown-Z",
1704137:"Unown-!",
1769673:"Unown-?",
202:"Wobbuffet",
203:"Girafarig",
204:"Pineco",
205:"Forretress",
206:"Dunsparce",
207:"Gligar",
208:"Steelix",
65744:"Mega Steelix",
209:"Snubbull",
210:"Granbull",
211:"Qwilfish",
212:"Scizor",
65748:"Mega Scizor",
213:"Shuckle",
214:"Heracross",
65750:"Mega Heracross",
215:"Sneasel",
216:"Teddiursa",
217:"Ursaring",
218:"Slugma",
219:"Magcargo",
220:"Swinub",
221:"Piloswine",
222:"Corsola",
223:"Remoraid",
224:"Octillery",
225:"Delibird",
226:"Mantine",
227:"Skarmory",
228:"Houndour",
229:"Houndoom",
65765:"Mega Houndoom",
230:"Kingdra",
231:"Phanpy",
232:"Donphan",
233:"Porygon2",
234:"Stantler",
235:"Smeargle",
236:"Tyrogue",
237:"Hitmontop",
238:"Smoochum",
239:"Elekid",
240:"Magby",
241:"Miltank",
242:"Blissey",
243:"Raikou",
244:"Entei",
245:"Suicune",
246:"Larvitar",
247:"Pupitar",
248:"Tyranitar",
65784:"Mega Tyranitar",
249:"Lugia",
250:"Ho-Oh",
251:"Celebi",
252:"Treecko",
253:"Grovyle",
254:"Sceptile",
65790:"Mega Sceptile",
255:"Torchic",
256:"Combusken",
257:"Blaziken",
65793:"Mega Blaziken",
258:"Mudkip",
259:"Marshtomp",
260:"Swampert",
65796:"Mega Swampert",
261:"Poochyena",
262:"Mightyena",
263:"Zigzagoon",
264:"Linoone",
265:"Wurmple",
266:"Silcoon",
267:"Beautifly",
268:"Cascoon",
269:"Dustox",
270:"Lotad",
271:"Lombre",
272:"Ludicolo",
273:"Seedot",
274:"Nuzleaf",
275:"Shiftry",
276:"Taillow",
277:"Swellow",
278:"Wingull",
279:"Pelipper",
280:"Ralts",
281:"Kirlia",
282:"Gardevoir",
65818:"Mega Gardevoir",
283:"Surskit",
284:"Masquerain",
285:"Shroomish",
286:"Breloom",
287:"Slakoth",
288:"Vigoroth",
289:"Slaking",
290:"Nincada",
291:"Ninjask",
292:"Shedinja",
293:"Whismur",
294:"Loudred",
295:"Exploud",
296:"Makuhita",
297:"Hariyama",
298:"Azurill",
299:"Nosepass",
300:"Skitty",
301:"Delcatty",
302:"Sableye",
65838:"Mega Sableye",
303:"Mawile",
65839:"Mega Mawile",
304:"Aron",
305:"Lairon",
306:"Aggron",
65842:"Mega Aggron",
307:"Meditite",
308:"Medicham",
65844:"Mega Medicham",
309:"Electrike",
310:"Manectric",
65846:"Mega Manectric",
311:"Plusle",
312:"Minun",
313:"Volbeat",
314:"Illumise",
315:"Roselia",
316:"Gulpin",
317:"Swalot",
318:"Carvanha",
319:"Sharpedo",
65855:"Mega Sharpedo",
320:"Wailmer",
321:"Wailord",
322:"Numel",
323:"Camerupt",
65859:"Mega Camerupt",
324:"Torkoal",
325:"Spoink",
326:"Grumpig",
327:"Spinda",
328:"Trapinch",
329:"Vibrava",
330:"Flygon",
331:"Cacnea",
332:"Cacturne",
333:"Swablu",
334:"Altaria",
65870:"Mega Altaria",
335:"Zangoose",
336:"Seviper",
337:"Lunatone",
338:"Solrock",
339:"Barboach",
340:"Whiscash",
341:"Corphish",
342:"Crawdaunt",
343:"Baltoy",
344:"Claydol",
345:"Lileep",
346:"Cradily",
347:"Anorith",
348:"Armaldo",
349:"Feebas",
350:"Milotic",
351:"Castform",
65887:"Castform-Snowy",
131423:"Castform-Rainy",
262495:"Castform-Sunny",
352:"Kecleon",
353:"Shuppet",
354:"Banette",
65890:"Mega Banette",
355:"Duskull",
356:"Dusclops",
357:"Tropius",
358:"Chimecho",
359:"Absol",
65895:"Mega Absol",
360:"Wynaut",
361:"Snorunt",
362:"Glalie",
65898:"Mega Glalie",
363:"Spheal",
364:"Sealeo",
365:"Walrein",
366:"Clamperl",
367:"Huntail",
368:"Gorebyss",
369:"Relicanth",
370:"Luvdisc",
371:"Bagon",
372:"Shelgon",
373:"Salamence",
65909:"Mega Salamence",
374:"Beldum",
375:"Metang",
376:"Metagross",
65912:"Mega Metagross",
377:"Regirock",
378:"Regice",
379:"Registeel",
380:"Latias",
65916:"Mega Latias",
381:"Latios",
65917:"Mega Latios",
382:"Kyogre",
65918:"Primal Kyogre",
383:"Groudon",
65919:"Primal Groudon",
384:"Rayquaza",
65920:"Mega Rayquaza",
385:"Jirachi",
386:"Deoxys",
65922:"Deoxys-Attack",
131458:"Deoxys-Defense",
196994:"Deoxys-Speed",
387:"Turtwig",
388:"Grotle",
389:"Torterra",
390:"Chimchar",
391:"Monferno",
392:"Infernape",
393:"Piplup",
394:"Prinplup",
395:"Empoleon",
396:"Starly",
397:"Staravia",
398:"Staraptor",
399:"Bidoof",
400:"Bibarel",
401:"Kricketot",
402:"Kricketune",
403:"Shinx",
404:"Luxio",
405:"Luxray",
406:"Budew",
407:"Roserade",
408:"Cranidos",
409:"Rampardos",
410:"Shieldon",
411:"Bastiodon",
412:"Burmy",
65948:"Burmy-Sandy",
131484:"Burmy-Trash",
413:"Wormadam",
65949:"Wormadam-Sandy",
131485:"Wormadam-Trash",
414:"Mothim",
415:"Combee",
416:"Vespiquen",
417:"Pachirisu",
418:"Buizel",
419:"Floatzel",
420:"Cherubi",
421:"Cherrim",
65957:"Cherrim-Sunshine",
422:"Shellos",
65958:"Shellos-East",
423:"Gastrodon",
65959:"Gastrodon-East",
424:"Ambipom",
425:"Drifloon",
426:"Drifblim",
427:"Buneary",
428:"Lopunny",
65964:"Mega Lopunny",
429:"Mismagius",
430:"Honchkrow",
431:"Glameow",
432:"Purugly",
433:"Chingling",
434:"Stunky",
435:"Skuntank",
436:"Bronzor",
437:"Bronzong",
438:"Bonsly",
439:"Mime Jr.",
440:"Happiny",
441:"Chatot",
442:"Spiritomb",
443:"Gible",
444:"Gabite",
445:"Garchomp",
65981:"Mega Garchomp",
446:"Munchlax",
447:"Riolu",
448:"Lucario",
65984:"Mega Lucario",
449:"Hippopotas",
450:"Hippowdon",
451:"Skorupi",
452:"Drapion",
453:"Croagunk",
454:"Toxicroak",
455:"Carnivine",
456:"Finneon",
457:"Lumineon",
458:"Mantyke",
459:"Snover",
460:"Abomasnow",
65996:"Mega Abomasnow",
461:"Weavile",
462:"Magnezone",
463:"Lickilicky",
464:"Rhyperior",
465:"Tangrowth",
466:"Electivire",
467:"Magmortar",
468:"Togekiss",
469:"Yanmega",
470:"Leafeon",
471:"Glaceon",
472:"Gliscor",
473:"Mamoswine",
474:"Porygon-Z",
475:"Gallade",
66011:"Mega Gallade",
476:"Probopass",
477:"Dusknoir",
478:"Froslass",
479:"Rotom",
66015:"Rotom-Mow",
131551:"Rotom-Heat",
197087:"Rotom-Frost",
262623:"Rotom-Wash",
328159:"Rotom-Fan",
480:"Uxie",
481:"Mesprit",
482:"Azelf",
483:"Dialga",
484:"Palkia",
485:"Heatran",
486:"Regigigas",
487:"Giratina",
66023:"Giratina-Origin",
488:"Cresselia",
489:"Phione",
490:"Manaphy",
491:"Darkrai",
492:"Shaymin",
66028:"Shaymin-Sky",
493:"Arceus",
66029:"Arceus-Fighting",
131565:"Arceus-Flying",
197101:"Arceus-Poison",
262637:"Arceus-Ground",
328173:"Arceus-Rock",
393709:"Arceus-Bug",
459245:"Arceus-Ghost",
524781:"Arceus-Steel",
590317:"Arceus-Fire",
655853:"Arceus-Water",
721389:"Arceus-Grass",
786925:"Arceus-Electric",
852461:"Arceus-Psychic",
917997:"Arceus-Ice",
983533:"Arceus-Dragon",
1049069:"Arceus-Dark",
1114605:"Arceus-Fairy",
494:"Victini",
495:"Snivy",
496:"Servine",
497:"Serperior",
498:"Tepig",
499:"Pignite",
500:"Emboar",
501:"Oshawott",
502:"Dewott",
503:"Samurott",
504:"Patrat",
505:"Watchog",
506:"Lillipup",
507:"Herdier",
508:"Stoutland",
509:"Purrloin",
510:"Liepard",
511:"Pansage",
512:"Simisage",
513:"Pansear",
514:"Simisear",
515:"Panpour",
516:"Simipour",
517:"Munna",
518:"Musharna",
519:"Pidove",
520:"Tranquill",
521:"Unfezant",
522:"Blitzle",
523:"Zebstrika",
524:"Roggenrola",
525:"Boldore",
526:"Gigalith",
527:"Woobat",
528:"Swoobat",
529:"Drilbur",
530:"Excadrill",
531:"Audino",
66067:"Mega Audino",
532:"Timburr",
533:"Gurdurr",
534:"Conkeldurr",
535:"Tympole",
536:"Palpitoad",
537:"Seismitoad",
538:"Throh",
539:"Sawk",
540:"Sewaddle",
541:"Swadloon",
542:"Leavanny",
543:"Venipede",
544:"Whirlipede",
545:"Scolipede",
546:"Cottonee",
547:"Whimsicott",
548:"Petilil",
549:"Lilligant",
550:"Basculin",
66086:"Basculin-Blue Striped",
551:"Sandile",
552:"Krokorok",
553:"Krookodile",
554:"Darumaka",
555:"Darmanitan",
66091:"Darmanitan-Zen",
556:"Maractus",
557:"Dwebble",
558:"Crustle",
559:"Scraggy",
560:"Scrafty",
561:"Sigilyph",
562:"Yamask",
563:"Cofagrigus",
564:"Tirtouga",
565:"Carracosta",
566:"Archen",
567:"Archeops",
568:"Trubbish",
569:"Garbodor",
570:"Zorua",
571:"Zoroark",
572:"Minccino",
573:"Cinccino",
574:"Gothita",
575:"Gothorita",
576:"Gothitelle",
577:"Solosis",
578:"Duosion",
579:"Reuniclus",
580:"Ducklett",
581:"Swanna",
582:"Vanillite",
583:"Vanillish",
584:"Vanilluxe",
585:"Deerling",
66121:"Deerling-Summer",
131657:"Deerling-Autumn",
197193:"Deerling-Winter",
586:"Sawsbuck",
66122:"Sawsbuck-Summer",
131658:"Sawsbuck-Autumn",
197194:"Sawsbuck-Winter",
587:"Emolga",
588:"Karrablast",
589:"Escavalier",
590:"Foongus",
591:"Amoonguss",
592:"Frillish",
593:"Jellicent",
594:"Alomomola",
595:"Joltik",
596:"Galvantula",
597:"Ferroseed",
598:"Ferrothorn",
599:"Klink",
600:"Klang",
601:"Klinklang",
602:"Tynamo",
603:"Eelektrik",
604:"Eelektross",
605:"Elgyem",
606:"Beheeyem",
607:"Litwick",
608:"Lampent",
609:"Chandelure",
610:"Axew",
611:"Fraxure",
612:"Haxorus",
613:"Cubchoo",
614:"Beartic",
615:"Cryogonal",
616:"Shelmet",
617:"Accelgor",
618:"Stunfisk",
619:"Mienfoo",
620:"Mienshao",
621:"Druddigon",
622:"Golett",
623:"Golurk",
624:"Pawniard",
625:"Bisharp",
626:"Bouffalant",
627:"Rufflet",
628:"Braviary",
629:"Vullaby",
630:"Mandibuzz",
631:"Heatmor",
632:"Durant",
633:"Deino",
634:"Zweilous",
635:"Hydreigon",
636:"Larvesta",
637:"Volcarona",
638:"Cobalion",
639:"Terrakion",
640:"Virizion",
641:"Tornadus",
66177:"Tornadus-Therian",
642:"Thundurus",
66178:"Thundurus-Therian",
643:"Reshiram",
644:"Zekrom",
645:"Landorus",
66181:"Landorus-Therian",
646:"Kyurem",
66182:"Kyurem-White",
131718:"Kyurem-Black",
647:"Keldeo",
66183:"Keldeo-Resolute",
648:"Meloetta",
66184:"Meloetta-Pirouette",
649:"Genesect",
66185:"Genesect-Douse",
131721:"Genesect-Shock",
197257:"Genesect-Burn",
262793:"Genesect-Chill",
650:"Chespin",
651:"Quilladin",
652:"Chesnaught",
653:"Fennekin",
654:"Braixen",
655:"Delphox",
656:"Froakie",
657:"Frogadier",
658:"Greninja",
66194:"Greninja-Unbonded",
131730:"Ash Greninja",
659:"Bunnelby",
660:"Diggersby",
661:"Fletchling",
662:"Fletchinder",
663:"Talonflame",
664:"Scatterbug",
665:"Spewpa",
666:"Vivillon",
66202:"Vivillon-Icy Snow",
131738:"Vivillon-Archipelago",
197274:"Vivillon-Continental",
262810:"Vivillon-Elegant",
328346:"Vivillon-Garden",
393882:"Vivillon-High Plains",
459418:"Vivillon-Jungle",
524954:"Vivillon-Marine",
590490:"Vivillon-Modern",
656026:"Vivillon-Monsoon",
721562:"Vivillon-Ocean",
787098:"Vivillon-Polar",
852634:"Vivillon-River",
918170:"Vivillon-Sandstorm",
983706:"Vivillon-Savannah",
1049242:"Vivillon-Sun",
1114778:"Vivillon-Tundra",
1180314:"Vivillon-Fancy",
1245850:"Vivillon-Pokeball",
667:"Litleo",
668:"Pyroar",
669:"Flabébé",
66205:"Flabébé-Orange",
131741:"Flabébé-Yellow",
197277:"Flabébé-Blue",
262813:"Flabébé-White",
670:"Floette",
66206:"Floette-Orange",
131742:"Floette-Yellow",
197278:"Floette-Blue",
262814:"Floette-White",
328350:"Floette-Eternal",
671:"Florges",
66207:"Florges-Orange",
131743:"Florges-Yellow",
197279:"Florges-Blue",
262815:"Florges-White",
672:"Skiddo",
673:"Gogoat",
674:"Pancham",
675:"Pangoro",
676:"Furfrou",
66212:"Furfrou-Heart",
131748:"Furfrou-Star",
197284:"Furfrou-Diamond",
262820:"Furfrou-Debutante",
328356:"Furfrou-Matron",
393892:"Furfrou-Dandy",
459428:"Furfrou-La Reine",
524964:"Furfrou-Kabuki",
590500:"Furfrou-Pharaoh",
677:"Espurr",
678:"Meowstic",
66214:"Meowstic-F",
679:"Honedge",
680:"Doublade",
681:"Aegislash",
66217:"Aegislash-Blade",
682:"Spritzee",
683:"Aromatisse",
684:"Swirlix",
685:"Slurpuff",
686:"Inkay",
687:"Malamar",
688:"Binacle",
689:"Barbaracle",
690:"Skrelp",
691:"Dragalge",
692:"Clauncher",
693:"Clawitzer",
694:"Helioptile",
695:"Heliolisk",
696:"Tyrunt",
697:"Tyrantrum",
698:"Amaura",
699:"Aurorus",
700:"Sylveon",
701:"Hawlucha",
702:"Dedenne",
703:"Carbink",
704:"Goomy",
705:"Sliggoo",
706:"Goodra",
707:"Klefki",
708:"Phantump",
709:"Trevenant",
710:"Pumpkaboo",
66246:"Pumpkaboo-Small",
131782:"Pumpkaboo-Large",
197318:"Pumpkaboo-Super",
711:"Gourgeist",
66247:"Gourgeist-Small",
131783:"Gourgeist-Large",
197319:"Gourgeist-Super",
712:"Bergmite",
713:"Avalugg",
714:"Noibat",
715:"Noivern",
716:"Xerneas",
717:"Yveltal",
718:"Zygarde",
66254:"Zygarde-10%",
131790:"Zygarde-Complete",
719:"Diancie",
66255:"Mega Diancie",
720:"Hoopa",
66256:"Hoopa-Unbound",
721:"Volcanion",
722:"Rowlet",
723:"Dartrix",
724:"Decidueye",
725:"Litten",
726:"Torracat",
727:"Incineroar",
728:"Popplio",
729:"Brionne",
730:"Primarina",
731:"Pikipek",
732:"Trumbeak",
733:"Toucannon",
734:"Yungoos",
735:"Gumshoos",
736:"Grubbin",
737:"Charjabug",
738:"Vikavolt",
739:"Crabrawler",
740:"Crabominable",
741:"Oricorio",
66277:"Oricorio-Pom Pom",
131813:"Oricorio-Pa'u",
197349:"Oricorio-Sensu",
742:"Cutiefly",
743:"Ribombee",
744:"Rockruff",
745:"Lycanroc",
66281:"Lycanroc-Midnight",
746:"Wishiwashi",
66282:"Wishiwashi-School",
747:"Mareanie",
748:"Toxapex",
749:"Mudbray",
750:"Mudsdale",
751:"Dewpider",
752:"Araquanid",
753:"Fomantis",
754:"Lurantis",
755:"Morelull",
756:"Shiinotic",
757:"Salandit",
758:"Salazzle",
759:"Stufful",
760:"Bewear",
761:"Bounsweet",
762:"Steenee",
763:"Tsareena",
764:"Comfey",
765:"Oranguru",
766:"Passimian",
767:"Wimpod",
768:"Golisopod",
769:"Sandygast",
770:"Palossand",
771:"Pyukumuku",
772:"Type: Null",
773:"Silvally",
66309:"Silvally-Fighting",
131845:"Silvally-Flying",
197381:"Silvally-Poison",
262917:"Silvally-Ground",
328453:"Silvally-Rock",
393989:"Silvally-Bug",
459525:"Silvally-Ghost",
525061:"Silvally-Steel",
590597:"Silvally-Fire",
656133:"Silvally-Water",
721669:"Silvally-Grass",
787205:"Silvally-Electric",
852741:"Silvally-Psychic",
918277:"Silvally-Ice",
983813:"Silvally-Dragon",
1049349:"Silvally-Dark",
1114885:"Silvally-Fairy",
774:"Minior",
66310:"Minior-Red",
131846:"Minior-Orange",
197382:"Minior-Yellow",
262918:"Minior-Green",
328454:"Minior-Blue",
393990:"Minior-Indigo",
459526:"Minior-Violet",
775:"Komala",
776:"Turtonator",
777:"Togedemaru",
778:"Mimikyu",
66314:"Mimikyu-Busted",
779:"Bruxish",
780:"Drampa",
781:"Dhelmise",
782:"Jangmo-o",
783:"Hakamo-o",
784:"Kommo-o",
785:"Tapu Koko",
786:"Tapu Lele",
787:"Tapu Bulu",
788:"Tapu Fini",
789:"Cosmog",
790:"Cosmoem",
791:"Solgaleo",
792:"Lunala",
793:"Nihilego",
794:"Buzzwole",
795:"Pheromosa",
796:"Xurkitree",
797:"Celesteela",
798:"Kartana",
799:"Guzzlord",
800:"Necrozma",
801:"Magearna",
66337:"Magearna-Pokeball",
802:"Marshadow",
};
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * Bootstrap Context Menu
 * Author: @sydcanem
 * https://github.com/sydcanem/bootstrap-contextmenu
 *
 * Inspired by Bootstrap's dropdown plugin.
 * Bootstrap (http://getbootstrap.com).
 *
 * Licensed under MIT
 * ========================================================= */

;(function($) {

	'use strict';

	/* CONTEXTMENU CLASS DEFINITION
	 * ============================ */
	var toggle = '[data-toggle="context"]';

	var ContextMenu = function (element, options) {
		this.$element = $(element);

		this.before = options.before || this.before;
		this.onItem = options.onItem || this.onItem;
		this.scopes = options.scopes || null;

		if (options.target) {
			this.$element.data('target', options.target);
		}

		this.listen();
	};

	ContextMenu.prototype = {

		constructor: ContextMenu
		,show: function(e) {

			var $menu
				, evt
				, tp
				, items
				, relatedTarget = { relatedTarget: this, target: e.currentTarget };

			if (this.isDisabled()) return;

			this.closemenu();

			if (this.before.call(this,e,$(e.currentTarget)) === false) return;

			$menu = this.getMenu();
			$menu.trigger(evt = $.Event('show.bs.context', relatedTarget));

			tp = this.getPosition(e, $menu);
			items = 'li:not(.divider)';
			$menu.attr('style', '')
				.css(tp)
				.addClass('open')
				.on('click.context.data-api', items, $.proxy(this.onItem, this, $(e.currentTarget)))
				.trigger('shown.bs.context', relatedTarget);

			// Delegating the `closemenu` only on the currently opened menu.
			// This prevents other opened menus from closing.
			$('html')
				.on('click.context.data-api', $menu.selector, $.proxy(this.closemenu, this));

			return false;
		}

		,closemenu: function(e) {
			var $menu
				, evt
				, items
				, relatedTarget;

			$menu = this.getMenu();

			if(!$menu.hasClass('open')) return;

			relatedTarget = { relatedTarget: this };
			$menu.trigger(evt = $.Event('hide.bs.context', relatedTarget));

			items = 'li:not(.divider)';
			$menu.removeClass('open')
				.off('click.context.data-api', items)
				.trigger('hidden.bs.context', relatedTarget);

			$('html')
				.off('click.context.data-api', $menu.selector);
			// Don't propagate click event so other currently
			// opened menus won't close.
			if (e) {
				e.stopPropagation();
			}
		}

		,keydown: function(e) {
			if (e.which == 27) this.closemenu(e);
		}

		,before: function(e) {
			return true;
		}

		,onItem: function(e) {
			return true;
		}

		,listen: function () {
			this.$element.on('contextmenu.context.data-api', this.scopes, $.proxy(this.show, this));
			$('html').on('click.context.data-api', $.proxy(this.closemenu, this));
			$('html').on('keydown.context.data-api', $.proxy(this.keydown, this));
		}

		,destroy: function() {
			this.$element.off('.context.data-api').removeData('context');
			$('html').off('.context.data-api');
		}

		,isDisabled: function() {
			return this.$element.hasClass('disabled') || 
					this.$element.attr('disabled');
		}

		,getMenu: function () {
			var selector = this.$element.data('target')
				, $menu;

			if (!selector) {
				selector = this.$element.attr('href');
				selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
			}

			$menu = $(selector);

			return $menu && $menu.length ? $menu : this.$element.find(selector);
		}

		,getPosition: function(e, $menu) {
			var mouseX = e.clientX
				, mouseY = e.clientY
				, boundsX = $(window).width()
				, boundsY = $(window).height()
				, menuWidth = $menu.find('.dropdown-menu').outerWidth()
				, menuHeight = $menu.find('.dropdown-menu').outerHeight()
				, tp = {"position":"absolute","z-index":9999}
				, Y, X, parentOffset;

			if (mouseY + menuHeight > boundsY) {
				Y = {"top": mouseY - menuHeight + $(window).scrollTop()};
			} else {
				Y = {"top": mouseY + $(window).scrollTop()};
			}

			if ((mouseX + menuWidth > boundsX) && ((mouseX - menuWidth) > 0)) {
				X = {"left": mouseX - menuWidth + $(window).scrollLeft()};
			} else {
				X = {"left": mouseX + $(window).scrollLeft()};
			}

			// If context-menu's parent is positioned using absolute or relative positioning,
			// the calculated mouse position will be incorrect.
			// Adjust the position of the menu by its offset parent position.
			parentOffset = $menu.offsetParent().offset();
			X.left = X.left - parentOffset.left;
			Y.top = Y.top - parentOffset.top;
 
			return $.extend(tp, Y, X);
		}

	};

	/* CONTEXT MENU PLUGIN DEFINITION
	 * ========================== */

	$.fn.contextmenu = function (option,e) {
		return this.each(function () {
			var $this = $(this)
				, data = $this.data('context')
				, options = (typeof option == 'object') && option;

			if (!data) $this.data('context', (data = new ContextMenu($this, options)));
			if (typeof option == 'string') data[option].call(data, e);
		});
	};

	$.fn.contextmenu.Constructor = ContextMenu;

	/* APPLY TO STANDARD CONTEXT MENU ELEMENTS
	 * =================================== */

	$(document)
	   .on('contextmenu.context.data-api', function() {
			$(toggle).each(function () {
				var data = $(this).data('context');
				if (!data) return;
				data.closemenu();
			});
		})
		.on('contextmenu.context.data-api', toggle, function(e) {
			$(this).contextmenu('show', e);

			e.preventDefault();
			e.stopPropagation();
		});
		
}(jQuery));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 59 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 60 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(59),
      utf8 = __webpack_require__(20).utf8,
      isBuffer = __webpack_require__(60),
      bin = __webpack_require__(20).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);
//# sourceMappingURL=frontend.js.map